/* ツートン製品別SVG（形データのみ）ここから */
/* 形だけを持つファイル。色・糸・縫い目の判断は twotone-ito.js 側 2026.10.23 */
/* 製品別は共通の枠 frame() で、高さを代表3形にそろえる 2026.10.26 */
/* キー：商品ハンドル名。'default' はハンドルが対応表に無い製品の予備（代表3形） 2026.10.23 */
/* 各関数が受け取る c：{ uid, mainUrl, subUrl, size, stitch(tag,id,geometry), pattern(id,url,size), emb(x,y,大きさ), name(x,y,幅,高さ,付く場所の革), reinforce() } 2026.10.23（emb・name は 2026.10.26 追加。古い twotone-ito.js では無いので、あるか確かめてから使う）*/
(function () {
  'use strict';

  var shapes = window.JAPLISH_SHAPES = window.JAPLISH_SHAPES || {};

  /* 代表3形：財布・ブックカバー・バッグ（旧 makeSvg の中身をそのまま移動） 2026.10.23 */
  shapes['default'] = function (c) {
    var wm = 'url(#' + c.uid + '-wm)';
    var ws = 'url(#' + c.uid + '-ws)';
    var cm = 'url(#' + c.uid + '-cm)';
    var cs = 'url(#' + c.uid + '-cs)';
    var bm = 'url(#' + c.uid + '-bm)';
    var bs = 'url(#' + c.uid + '-bs)';

    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="95 65 1635 495" role="img" aria-label="ツートン革色見本" style="display:block;width:100%;height:auto">' +
      '<defs>' +
        c.pattern(c.uid + '-wm', c.mainUrl, c.size) +
        c.pattern(c.uid + '-ws', c.subUrl, c.size) +
        c.pattern(c.uid + '-cm', c.mainUrl, c.size) +
        c.pattern(c.uid + '-cs', c.subUrl, c.size) +
        c.pattern(c.uid + '-bm', c.mainUrl, c.size) +
        c.pattern(c.uid + '-bs', c.subUrl, c.size) +
      '</defs>' +

      '<g id="wallet" transform="translate(20.6 239.3) scale(.62)">' +
        '<g id="wallet-sub">' +
          '<path id="wallet-sub-leather" d="M480 95H614Q660 95 660 141V439Q660 485 614 485H480Z" fill="' + ws + '" stroke="#080808" stroke-width="5" stroke-linejoin="round"/>' +
          '<path id="wallet-card-lines" d="M480 170H656 M480 225H656 M480 280H656" fill="none" stroke="#080808" stroke-width="5"/>' +
          c.stitch('path', 'wallet-sub-stitch', 'd="M493 109H614Q646 109 646 141V439Q646 471 614 471H493"') +
        '</g>' +
        '<g id="wallet-main">' +
          '<path id="wallet-main-leather" d="M174 75H506Q552 75 552 121V439Q552 485 506 485H174Q128 485 128 439V121Q128 75 174 75Z" fill="' + wm + '" stroke="#080808" stroke-width="5" stroke-linejoin="round"/>' +
          c.stitch('path', 'wallet-main-stitch', 'd="M174 87H506Q540 87 540 121V439Q540 473 506 473H174Q140 473 140 439V121Q140 87 174 87Z"') +
        '</g>' +
      '</g>' +

      '<g id="book-cover" transform="translate(478 198.75) scale(.65)">' +
        '<g id="book-cover-sub">' +
          '<rect id="book-cover-sub-leather" x="80" y="95" width="640" height="430" rx="28" fill="' + cs + '" stroke="#080808" stroke-width="5" stroke-linejoin="round"/>' +
        '</g>' +
        '<g id="book-cover-main">' +
          '<rect id="book-cover-main-leather" x="215" y="95" width="370" height="430" fill="' + cm + '" stroke="#080808" stroke-width="5"/>' +
        '</g>' +
        c.stitch('rect', 'book-cover-stitch', 'x="96" y="111" width="608" height="398" rx="18"') +
      '</g>' +

      '<g id="bag" transform="translate(842 117.76) scale(1.12)">' +
        '<g transform="translate(132 0) scale(.74 1)" stroke="#080808" stroke-width="5" stroke-linejoin="round" stroke-linecap="round">' +
          '<g id="bag-main">' +
            '<path id="bag-body-fill" d="M96 98H846Q858 98 858 110V280Q858 377 761 377H181Q84 377 84 280V110Q84 98 96 98Z" fill="' + bm + '" stroke="none"/>' +
            '<path id="bag-body-outline" d="M96 98Q84 98 84 110V280Q84 377 181 377H761Q858 377 858 280V110Q858 98 846 98" fill="none" stroke="#080808" stroke-width="5" stroke-linecap="butt"/>' +
            '<path id="bag-left-loop" d="M183 0H222V65H183Z" fill="' + bm + '"/>' +
            '<path id="bag-right-loop" d="M722 0H761V65H722Z" fill="' + bm + '"/>' +
          '</g>' +
          '<g id="bag-sub">' +
            '<path id="bag-left-attachment" d="M165 99V83Q165 65 183 65H222Q240 65 240 83V99Z" fill="' + bs + '"/>' +
            '<path id="bag-right-attachment" d="M704 99V83Q704 65 722 65H761Q779 65 779 83V99Z" fill="' + bs + '"/>' +
            '<path id="bag-top-band" d="M67 145V95Q67 79 84 79H859Q877 79 877 95V145H858V99H86V145Z" fill="' + bs + '"/>' +
            '<path id="bag-center-tab" d="M424 78Q424 59 442 59H502Q520 59 520 78V127A48 48 0 0 1 424 127Z" fill="' + bs + '"/>' +
          '</g>' +
        '</g>' +
      '</g>' +
      '</svg>';
  };

  /* 共通の枠：高さは代表3形と同じ（1635×495）。面を横に並べ、全部の面を同じ縮尺で置く。面どうしは下でそろえる 2026.10.26 */
  /* views：[{ box: [x, y, 幅, 高さ]（その面の絵が収まる範囲）, body: 'その面のSVGの中身', k: 倍率（省略時1）, core: [上, 高さ]（本体だけの縦の範囲・省略時は box と同じ） }, ...]
     k は、写真の撮り方で面ごとに大きさがずれた時の補正。同じ製品の正面と内部で、高さなど実物で同じ長さがそろうように決める 2026.10.26
     面の幅に合わせて横の場所を割り振り、面と面の間は FRAME_GAP あける（面の幅が違っても無駄な余白ができない）2026.10.26 */
  /* プレビューの大きさを全製品で揃える 2026.11.02
     ・FRAME_W＝候補欄の幅（項目名の右、選択欄の左の端から右の端まで。PC本番は写真の列の幅）。
     ・本体の高さ（最初の面＝正面の core。引き手・ベルトなどのはみ出しは数えない）を全製品で BODY_H にする。
     ・枠は絵の大きさぴったりで作り、表示の幅は「絵の幅 ÷ FRAME_W」の割合で右寄せ。入りきらない時は max-width で全体を縮める。
     ・上下2段（4面）は高さが増えてよい（例外）。縮尺は1段と同じ。 */
  var FRAME_W = 1635;
  var FRAME_H = 495;
  var FRAME_PAD = 24;
  var FRAME_GAP = 70;
  var BODY_H = 400; /* 本体の高さ（FRAME_W に対する大きさ。全製品共通）2026.11.02 */
  var TWO_IMG_W = 0.72; /* 画像が2枚以下の時の幅の上限（候補欄の幅に対する割合）2026.11.02 */

  /* 線の太さの基準になる縮尺（st-3 の正面の縮尺。この面の縫い目・黒い線の見え方を全製品の基本にする）2026.10.26 */
  var LINE_REF_SCALE = 0.6873;

  /* 定番の引き手の拡大図は、どの製品でも画面上で同じ大きさ（g-22 で決めた大きさ）2026.10.27 */
  var PULL_SCALE = 1.0;

  function frame(c, label, views, opts) {
    opts = opts || {}; /* 大きさの指定（tall・big）2026.11.02 */
    /* 面が多い製品は2段にする（各面に row: 0 か 1）。段が増えると全体の高さも増える。倍率は全段で共通 2026.10.27 */
    var nRows = 1;
    views.forEach(function (v) { nRows = Math.max(nRows, (v.row || 0) + 1); });

    var rows = [];
    for (var r = 0; r < nRows; r++) rows.push({ views: [], totalW: 0, maxH: 0, fixedW: 0 });
    var first = null;
    views.forEach(function (v) {
      var row = rows[v.row || 0];
      row.views.push(v);
      /* fixed：製品に関係なく画面上の大きさを決めて描く面（定番の引き手の拡大など）。他の面の倍率に左右されない 2026.10.27 */
      if (v.fixed) { row.fixedW += v.box[2] * v.fixed; return; }
      if (!first) first = v;
      var k = v.k || 1;
      row.totalW += v.box[2] * k;
      row.maxH = Math.max(row.maxH, v.box[3] * k);
    });

    /* 縮尺：最初の面（正面）の本体の高さが BODY_H になるように。全製品で同じ 2026.11.02 */
    var coreH = first ? (first.core ? first.core[1] : first.box[3]) * (first.k || 1) : 1;
    var scale = BODY_H / coreH;
    var ROW_GAP = 30; /* 段と段のすき間（詰める）*/

    /* 段の高さ・幅は中身に合わせる（余白を作らない）2026.11.02 */
    var contentW = 0;
    function layout(sc) {
      contentW = 0;
      var sumH = 0;
      rows.forEach(function (row) {
        var hh = row.maxH * sc;
        row.views.forEach(function (v) { if (v.fixed) hh = Math.max(hh, v.box[3] * v.fixed); });
        row.h = hh;
        row.used = row.totalW * sc + row.fixedW + FRAME_GAP * (row.views.length - 1);
        contentW = Math.max(contentW, row.used);
        sumH += hh;
      });
      return sumH + ROW_GAP * (nRows - 1);
    }
    var contentH = layout(scale);

    /* 見本の大きさは臨機応変に 2026.11.02
       ・opts.tall：縦に長く画像の少ない製品（g-69 など）は、4画像を上下2段にした時の高さまで使って大きく見せる。
       ・画像が2枚以下の1段は大きくなりがちなので、幅は候補欄の TWO_IMG_W の割合までに抑える（必要な製品は opts.big で外す）。 */
    var nImg = views.filter(function (v) { return !v.fixed; }).length;
    if (opts.tall) {
      var TALL_H = 2 * BODY_H * 1.12 + ROW_GAP;
      if (contentH < TALL_H) { scale *= TALL_H / contentH; contentH = layout(scale); }
    } else if (!opts.big && nRows === 1 && nImg <= 2) {
      var cap = FRAME_W * TWO_IMG_W;
      for (var it = 0; it < 3 && contentW > cap; it++) { scale *= cap / contentW; contentH = layout(scale); }
    }

    var totalW = contentW + FRAME_PAD * 2;
    var totalH = contentH + FRAME_PAD * 2;

    var groups = '';
    var rowTop = FRAME_PAD;
    rows.forEach(function (row) {
      var bottom = rowTop + row.h; /* この段の下（面どうしは下でそろえる）*/
      rowTop = bottom + ROW_GAP;
      var x = totalW - FRAME_PAD - row.used; /* 見本は全部右寄せ（1段も2段も）2026.10.27 */

      row.views.forEach(function (v) {
        var k = v.k || 1;
        var sc = v.fixed || scale * k;
        var w = v.box[2] * sc;
        var h = v.box[3] * sc;
        var tx = x - v.box[0] * sc;
        var ty = bottom - h - v.box[1] * sc;
        /* 大きさ固定の面（引き手の拡大）は、革の下を他の面の革の下（余白20×全体の倍率）にそろえる 2026.10.27 */
        if (v.fixed && v.pad != null) {
          ty = bottom - 20 * scale - (v.box[1] + v.box[3] - v.pad) * sc;
        }

        x += w + FRAME_GAP;
        groups += draw(v, sc, tx, ty);
      });
    });

    function draw(v, sc, tx, ty) {
      /* 縫い目（太さ・間隔）と黒い輪郭線は、どの製品のどの面でも、画面上で同じ太さに見えるようにそろえる。
         基準は st-3 の正面（縮尺 LINE_REF_SCALE）。面の縮尺 sc との比で割り戻す 2026.10.26 */
      var f = LINE_REF_SCALE / sc;
      var body = v.body.replace(
        /stroke-width="([\d.]+)" stroke-dasharray="([\d. ]+)"/g,
        function (all, w, dash) {
          return 'stroke-width="' + (parseFloat(w) * f).toFixed(2) + '" stroke-dasharray="' +
            dash.trim().split(/\s+/).map(function (n) { return (parseFloat(n) * f).toFixed(2); }).join(' ') + '"';
        }
      ).replace(
        /stroke="#080808" stroke-width="([\d.]+)"/g,
        function (all, w) {
          return 'stroke="#080808" stroke-width="' + (parseFloat(w) * f).toFixed(2) + '"';
        }
      );

      return '<g transform="translate(' + tx.toFixed(2) + ' ' + ty.toFixed(2) + ') scale(' + sc.toFixed(4) + ')">' +
        body + '</g>';
    }

    /* 表示の幅＝絵の幅 ÷ FRAME_W（候補欄の幅に対する割合）。右寄せ。入りきらない時は全体を縮める 2026.11.02 */
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ' + totalW.toFixed(1) + ' ' + totalH.toFixed(1) + '" role="img" aria-label="' + label + '" style="display:block;width:' + (totalW / FRAME_W * 100).toFixed(2) + '%;max-width:100%;height:auto;margin-left:auto">' +
      '<defs>' +
        c.pattern(c.uid + '-m', c.mainUrl, c.size) +
        c.pattern(c.uid + '-s', c.subUrl, c.size) +
        c.pattern(c.uid + '-a', c.accUrl || c.subUrl, c.size) +
        c.pattern(c.uid + '-k', c.camelUrl || c.accUrl || c.subUrl, c.size) +
        c.pattern(c.uid + '-p', c.pairUrl || c.subUrl, c.size) + /* ふだんは基本の組み合わせの色の部品（ac-18 のマチ）。ツートンを選んだらサブ 2026.11.02 */ /* いつもキャメルの部品（ツートンを選んでも変わらない）2026.10.27 */ /* ふだんキャメルの部品（ベルト・引き手・タグなど）。ツートンを選んだらサブ革 2026.10.27 */
      '</defs>' +
      groups +
      '</svg>';
  }

  /* 共通の色指定 2026.10.26 */
  var ZIP_TAPE = '#3A2418';
  var ZIP_METAL = '#A88A3E';
  var ZIP_TEETH = '#9C8656'; /* ファスナーの歯：くすんだ真鍮色（目立たせすぎず、ファスナーと分かる程度）2026.10.27 */

  /* ファスナー（全製品共通）：焦げ茶の布＋少し明るい焦げ茶の歯。本体の黒線に重なってよい 2026.10.27 */
  /* ファスナーの終わり：途中で消えず、布が本体の中へ入っていく。終わりの点から本体側へ曲がる尻尾（布だけ・歯なし）。L字ファスナーの時だけ（直線のファスナーは今のまま）。
     ファスナーは本体より先に描くので、尻尾は本体の下にもぐって見える（全製品共通）2026.10.27 */
  function tailDown(x, y) { return ' Q' + x + ' ' + (y + 8) + ' ' + (x - 40) + ' ' + (y + 10); }  /* 縦に下りてきたファスナー → 終わりの位置からそのまま本体の中へ（下の端へは出ない）2026.10.27 */

  function zip(id, d, tail) {
    /* 布（焦げ茶）を広めに、その真ん中に細かい歯の列。両側に布が見えるのでファスナーと分かる 2026.10.27 */
    return '<path id="' + id + '-tape" d="' + d + (tail || '') + '" fill="none" stroke="' + ZIP_TAPE + '" stroke-width="20" stroke-linejoin="round"/>' +
      '<path id="' + id + '-teeth" d="' + d + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="9" stroke-dasharray="5 4"/>';
  }
  var EDGE = ' stroke="#080808" stroke-width="5" stroke-linejoin="round"'; /* 黒い輪郭線は全部これ1種類（革・プレート・丸い革・金具の丸も）。太さ5、画面上の見え方は frame() が st-3 正面にそろえる 2026.10.26 */

  /* 黒い線だけを引く（塗りなし）。革が隣り合う境目は、両方の革で線を描くと2本重なって濃く・太く見えるので、
     塗りは線なしで描き、境目と外周の線はこれで1回だけ引く（全製品共通のルール）2026.10.27 */
  function line(d) {
    return '<path d="' + d + '" fill="none"' + EDGE + '/>';
  }

  /* 小さい部品（ブランド刻印・ネームプレート・ボタン飾りの丸い革）の黒い線。画面上の太さは同じでも、小さい部品は線が詰まって太く見えるので細くする 2026.10.26 */
  var EDGE_SMALL = ' stroke="#080808" stroke-width="3" stroke-linejoin="round"';

  /* 縫い目と革の端の距離（全製品共通の基本）。どの辺も、この距離で縫い目を引く 2026.10.26 */
  var INSET = 15;

  /* ポケットの下の左右の角の丸み（R）。全製品共通。縫い目も同じ中心で、R から INSET を引いた丸みで回る 2026.10.26 */
  var POCKET_R = 28;

  /* 補強の糸（短い線）：色は c.reinforce()（emb-new.js の japlishEmb.reinforce）から。「補強糸を無くす」なら描かない。
     2色の補強（左右・上下）は、index で何色目かを選ぶ 2026.10.26 */
  function reinLine(c, d, index) {
    if (!c.reinforce) return '';

    var r = c.reinforce();
    if (!r || !r.hex || !r.hex.length) return '';

    var color = r.hex[Math.min(index || 0, r.hex.length - 1)];
    var edge = color.toUpperCase() === '#FCF6E8' ? '<path d="' + d + '" fill="none" stroke="#999999" stroke-width="10" stroke-linecap="round"/>' : '';

    return edge + '<path d="' + d + '" fill="none" stroke="' + color + '" stroke-width="7" stroke-linecap="round"/>';
  }

  /* 下部の四角補強（emb-rein-box）：□を底に巻いて縫うので、正面からは下の端に開いたコの字（⊓）に見える。
     位置はファスナー側（右端）からの実寸の距離で決まり、製品の大きさに関係なく同じ（4.6cm）。
     大きさも実寸（幅0.75cm・高さ0.3cm）。u＝その製品の図の1cmあたりの長さ（図の幅÷実物の幅）。g-2・g-21・g-22・g-65 共通 2026.10.27 */
  var REIN_BOX_FROM_RIGHT = 4.6;
  function reinBox(c, right, bottom, u) {
    var cx = right - REIN_BOX_FROM_RIGHT * u;
    var w = 0.75 * u / 2, h = 0.3 * u;
    return reinLine(c, 'M' + (cx - w) + ' ' + bottom + ' V' + (bottom - h) + ' H' + (cx + w) + ' V' + bottom);
  }

  /* ファスナーのスライダー（金具）：ファスナーの上に乗る小さな金具。引き手はここから出る（全製品共通）2026.10.27 */
  function zipSlider(x0, y, u) {
    var w = 0.9 * u, h = 0.6 * u;
    return '<rect x="' + x0 + '" y="' + (y - h / 2) + '" width="' + w + '" height="' + h + '" rx="' + (h / 3) + '" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>';
  }

  /* 引き手の付け根：スライダーの上の真ん中。引き手はここから右へ、15度上に向かって出る（本体にめり込まない）2026.10.27 */
  function pullBase(x0, y, u) {
    return { x: x0 + 0.45 * u, y: y - 0.3 * u };
  }

  /* ファスナーの革の引き手（正面の小さい引き手）：長さは全製品共通の実寸（g-2 基準：3.33cm・太さ0.64cm）。
     x0, y＝ファスナーの始まり。スライダーを描き、その上から右へ15度上に出す。c を渡すと引き手にも縫い目（g-52 など）。u＝図の1cmあたりの長さ 2026.10.27 */
  function zipPull(fill, x0, y, u, c) {
    var len = 3.33 * u, h = 0.64 * u, i = h * 0.28;
    var p = pullBase(x0, y, u);
    var rx = p.x - h * 0.3, ry = p.y - h; /* 引き手の下の辺が付け根を通る */
    /* 引き手を横から見ているので、縫い目は長さ方向の1本だけ（輪にしない）。真ん中より下寄り 2026.10.27 */
    var st = c ? c.stitch('path', 'pull-stitch-' + x0, 'd="M' + (rx + h * 0.5) + ' ' + (ry + h * 0.7) + ' H' + (rx + len - h * 0.5) + '"') : '';
    return zipSlider(x0, y, u) +
      '<g transform="rotate(-15 ' + p.x + ' ' + p.y + ')">' +
      '<rect x="' + rx + '" y="' + ry + '" width="' + len + '" height="' + h + '" rx="' + (h / 2.4) + '" fill="' + fill + '"' + EDGE + '/>' + st + '</g>';
  }

  /* 革の引き手が無いファスナー（小銭入れなど）：スライダーから、金具色の少し太い棒の引き手。向き・角度は革の引き手と同じ。長さ1.3cm・太さ0.32cm 2026.10.27 */
  function zipMetalPull(x0, y, u) {
    var len = 1.3 * u, h = 0.32 * u;
    var p = pullBase(x0, y, u);
    return zipSlider(x0, y, u) +
      '<g transform="rotate(-15 ' + p.x + ' ' + p.y + ')">' +
      '<rect x="' + (p.x - h * 0.3) + '" y="' + (p.y - h) + '" width="' + len + '" height="' + h + '" rx="' + (h / 2) + '" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/></g>';
  }

  /* 刺繍は実物より少し大きめに見せる（プレビューで見やすいことを優先）。全製品共通の倍率。置いた場所の中心はそのまま 2026.10.26 */
  var EMB_SCALE = 1.3;

  function embBig(c, x, y, size) {
    if (!c.emb) return '';

    var big = size * EMB_SCALE;
    return c.emb(x - (big - size) / 2, y - (big - size) / 2, big);
  }

  /* ブランド刻印のプレート：位置と縫い目だけ（文字は描かない）。革は付く場所と同じ。黒線は小さい部品用 2026.10.26 */
  /* ブランド刻印の文字（型押し）：読める場所なら薄く入れる。cx は真ん中、y は文字の下の線、size は文字の高さ 2026.11.02 */
  function brandText(cx, y, size, word) {
    return '<text x="' + cx + '" y="' + y + '" text-anchor="middle" font-family="\'Segoe Script\', \'Brush Script MT\', cursive" font-style="italic" font-size="' + size + '" fill="#000" fill-opacity="0.28">' + (word || 'japlish') + '</text>';
  }

  /* 革を折った小さな引き手＋カシメ（ac-54型・共通部品）。x, y＝スライダーの位置。down なら下へ垂れる。カシメは付け根寄り 2026.11.02 */
  function foldPull(x, y, fill, down) {
    var top = down ? y + 10 : y - 150;
    return '<rect x="' + (x - 10) + '" y="' + (y - 12) + '" width="20" height="24" rx="4" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
      '<rect x="' + (x - 24) + '" y="' + top + '" width="48" height="140" rx="22" fill="' + fill + '"' + EDGE + '/>' +
      rivet(x, down ? y + 42 : y - 42, 9);
  }

  function brandPlate(c, x, y, w, h, fill) {
    var i = 7;

    return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="5" fill="' + fill + '"' + EDGE_SMALL + '/>' +
      c.stitch('rect', 'brand-stitch-' + x, 'x="' + (x + i) + '" y="' + (y + i) + '" width="' + (w - i * 2) + '" height="' + (h - i * 2) + '" rx="3"');
  }

  /* ポケットのU字の縫い目（左・下・右）。上は口なので縫わない。x1,y1 は左上、x2,y2 は右下（革の端）*/
  function pocketStitch(x1, y1, x2, y2) {
    var i = INSET;
    var r = Math.max(POCKET_R - i, 4);

    return 'M' + (x1 + i) + ' ' + (y1 + i) +
      ' V' + (y2 - i - r) + ' Q' + (x1 + i) + ' ' + (y2 - i) + ' ' + (x1 + i + r) + ' ' + (y2 - i) +
      ' H' + (x2 - i - r) + ' Q' + (x2 - i) + ' ' + (y2 - i) + ' ' + (x2 - i) + ' ' + (y2 - i - r) +
      ' V' + (y1 + i);
  }

  /* 定番の引き手（拡大図）：サブ革。幅150・長さ295（前の大きさに戻した）。
     ・スライダー側（上）は半円、先（下）は角を小さく丸める。
     ・カシメは上の半円の中に、控えめな金具色で。
     ・イカリ刺繍は引き手の下半分に、左右に余白が残る大きさで。
     ほかの製品でも、この部品をそのまま使う。返り値 { box, body } は frame() の面にそのまま渡せる 2026.10.26 */
  function anchorPull(c, fill) {
    return {
      box: [-4, -4, 158, 315], /* 下＝革の下(295)＋16（×1.25で正面の＋20と同じ）。全面の革の下をそろえる 2026.10.27 */
      body:
        '<path d="M0 75 A75 75 0 0 1 150 75 V281 Q150 295 136 295 H14 Q0 295 0 281 Z" fill="' + fill + '"' + EDGE + '/>' +
        '<circle cx="75" cy="76" r="36" fill="#8C7A55"' + EDGE + '/>' +
        embBig(c, 19, 149, 112) /* 140は大きすぎ・85は小さすぎ → 間の112。中心は引手の下半分のまま 2026.10.26 */
    };
  }

  /* g-22：L字長財布。正面＝本体（メイン）＋下の帯・引き手（サブ）、内部＝小銭入れ（メイン）＋ポケット（サブ）、引き手の拡大（サブ）。共通の枠に3面で並べる 2026.10.26 */
  shapes['g-22'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var s = 'url(#' + c.uid + '-s)';
    var I = INSET;

    var front =
      /* Dカンの革（サブ革）：左の辺の上寄り。金具（輪）は描かない 2026.10.26 */
      '<path id="g22-dtab" d="M98 346 H72 Q60 346 60 358 V399 Q60 411 72 411 H98 Z" fill="' + s + '"' + EDGE + '/>' +
      /* ファスナー：焦げ茶。本体の線に沿わせる（重なってよい）2026.10.27 */
      zip('g22-zip', 'M152 261 H822 Q955 261 955 392 V737', tailDown(955, 737)) /* 端から端までではない：始まりは引き手の下、終わりは下の端の少し手前 2026.10.27 */ +
      /* 引き手：サブ革（ファスナーにつながる）*/
      zipPull(s, 152, 261, 856 / 18) + /* 引き手：ファスナーの始まりに付けて斜め上へ（g-2 と同じ長さ）2026.10.27 */
      /* 本体（メイン革） */
      '<path id="g22-main" d="M92 268 H822 Q948 268 948 392 V664 H92 Z" fill="' + m + '"/>' +
      /* 下の帯（サブ革の裏）。直角、左下だけ小さなR */
      suede('M92 664 H948 V772 H108 Q92 772 92 756 Z', s, true) + /* 下の帯は起毛した裏の面（写真）2026.10.26 */
      /* 黒い線：外周と、本体と帯の境目を1回だけ 2026.10.27 */
      line('M92 268 H822 Q948 268 948 392 V772 H108 Q92 772 92 756 Z') +
      line('M92 664 H948') +
      /* 縫い目：上辺と右辺（下まで）、帯の上部。革の端から INSET */
      c.stitch('path', 'g22-stitch-edge', 'd="M' + (92 + I) + ' ' + (268 + I) + ' H822 Q' + (948 - I) + ' ' + (268 + I) + ' ' + (948 - I) + ' 392 V' + (772 - I) + '"') +
      c.stitch('path', 'g22-stitch-band', 'd="M' + (92 + I) + ' ' + (664 + I) + ' H' + (948 - I) + '"') +
      /* ブランド刻印の半円タブ：g-2 と同じ実寸（左端から3.75cm・半径1.05cm）。ツートン対象外なのでメイン革 2026.10.27 */
      '<path id="g22-brand" d="M' + (92 + 3.75 * 856 / 18 - 50) + ' 664 A50 50 0 0 1 ' + (92 + 3.75 * 856 / 18 + 50) + ' 664 Z" fill="' + m + '"' + EDGE_SMALL + '/>' +
      /* 補強：下の端のコの字（g-2 と同じ）2026.10.27 */
      reinBox(c, 948, 772, (948 - 92) / 18); /* g-22 の幅 18cm */

    var inside =
      /* ファスナー：正面と同じ描き方 2026.10.27 */
      zip('g22c-zip', 'M198 338 H810') +
      /* 本体（メイン革） */
      '<path id="g22c-main" d="M165 345 H838 V692 Q842 732 800 732 H208 Q168 732 165 692 Z" fill="' + m + '"' + EDGE + '/>' +
      zipMetalPull(198, 338, 856 / 18) + /* 革の引き手が無いので金具の引き手 2026.10.27 */
      /* 中央ポケット（サブ革）：下の左右の角は丸い（R）。全製品共通 */
      '<path id="g22c-pocket" d="M242 440 H757 V' + (705 - POCKET_R) + ' Q757 705 ' + (757 - POCKET_R) + ' 705 H' + (242 + POCKET_R) + ' Q242 705 242 ' + (705 - POCKET_R) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      /* 縫い目：上辺、ポケットの左・下・右。どの辺も革の端から INSET（下だけ離れていたのを直した）2026.10.26 */
      c.stitch('path', 'g22c-stitch-top', 'd="M' + (165 + I) + ' ' + (345 + I) + ' H' + (838 - I) + '"') +
      c.stitch('path', 'g22c-stitch-pocket', 'd="' + pocketStitch(242, 440, 757, 705) + '"') +
      /* ネームプレート：ポケットの上寄り・真ん中（写真の黄色い斜線の場所）。ネームを選んだ時だけ描く 2026.10.26 */
      (c.name ? c.name(426, 475, 150, 63, s) : ''); /* プレートの革は、付く場所（ポケット＝サブ革）と同じ 2026.10.26 */

    /* 引き手の拡大：定番の引き手（イカリ刺繍入り）。ほかの製品でも同じ部品を使う 2026.10.26 */
    var pull = anchorPull(c, s);

    return frame(c, 'L字長財布のツートン見本', [
      { box: [54, 196, 916, 596], core: [254, 518], body: front }, /* 上は斜めの引き手の分を空ける 2026.10.27 */
      { box: [158, 326, 690, 426], body: inside }, /* 下＝革の下(732)＋20 2026.10.27 */
      /* 引き手は拡大図。前と同じ倍率 2026.10.26 */
      { box: pull.box, body: pull.body, fixed: PULL_SCALE, pad: 16 }
    ]);
  };

  /* 裏革・起毛の面：革の上に白を薄く重ねて、表と区別する。起毛の帯は g-2・g-22・sb-1-2 くらい 2026.10.26 */
  function suede(d, m, noEdge) {
    return '<path d="' + d + '" fill="' + m + '"/>' +
      '<path d="' + d + '" fill="#FFFFFF" fill-opacity="0.16"' + (noEdge ? '' : EDGE) + '/>'; /* 白を薄めに（0.32→0.16）2026.10.26。noEdge なら線なし（線は line() で1回だけ）2026.10.27 */
  }

  /* st-3：フィトーレ（文庫本カバー・ホック調整）。正面＝全部メイン、内部＝差し込み2枚とフタ裏がサブ、残りはメイン革の裏 2026.10.26 */
  shapes['st-3'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var s = 'url(#' + c.uid + '-s)';

    var front =
      /* 本体（メイン革） */
      '<path id="st3-body" d="M270 170 H716 Q728 170 728 182 V786 Q728 798 716 798 H270 Q258 798 258 786 V182 Q258 170 270 170 Z" fill="' + m + '"/>' +
      /* フタ（メイン革）：先が左を向いた封筒型。上・右・下の外周は本体と同じ線に重ねる（ずれて2本に見え、太く見えていた）2026.10.26 */
      '<path id="st3-flap" d="M584 170 H716 Q728 170 728 182 V786 Q728 798 716 798 H602 L520 458 Z" fill="' + m + '"/>' +
      /* 黒い線：フタの斜めの辺と、本体の外周を1回だけ（フタの外周は本体と重なるので引かない）2026.10.27 */
      line('M584 170 L520 458 L602 798') +
      line('M270 170 H716 Q728 170 728 182 V786 Q728 798 716 798 H270 Q258 798 258 786 V182 Q258 170 270 170 Z') +
      /* ボタン飾り（メイン革） */
      '<circle id="st3-button" cx="605" cy="462" r="46" fill="' + m + '"' + EDGE_SMALL + '/>' +
      /* 刺繍：ボタン飾りの中（右が開いた四角）2026.10.26 */
      embBig(c, 575, 432, 60) +
      /* 縫い目：本体の上辺・下辺、フタのふち。どの辺も革の端から INSET(15)。本体の縫い目はフタの端で止める 2026.10.27 */
      c.stitch('path', 'st3-stitch-top', 'd="M273 185 H581"') +
      c.stitch('path', 'st3-stitch-bottom', 'd="M273 783 H598"') +
      c.stitch('path', 'st3-stitch-flap', 'd="M596 185 L535.4 457.9 L613.8 783"') +
      c.stitch('path', 'st3-stitch-flap-edge', 'd="M596 185 H713 V783 H613.8"'); /* 正面には補強を描かない（不要と確認）2026.10.27 */

    var inside =
      /* 外周の土台：メイン革の裏 */
      suede('M84 302 H926 L962 516 L926 752 H84 Q72 752 72 740 V314 Q72 302 84 302 Z', m, true) +
      /* 左の差し込み（サブ） */
      '<path id="st3-in-left" d="M84 302 H246 V752 H84 Q72 752 72 740 V314 Q72 302 84 302 Z" fill="' + s + '"/>' +
      /* ブランド刻印のプレート：左の差し込み（サブ革）の左下。プレートの革は付く場所と同じ。まわりを縫う 2026.10.26 */
      brandPlate(c, 94, 640, 130, 59, s) +
      /* 右の差し込み（サブ） */
      '<path id="st3-in-right" d="M562 302 H744 V752 H562 Z" fill="' + s + '"/>' +
      /* フタの裏（サブ） */
      '<path id="st3-in-flap" d="M824 302 H926 L962 516 L926 752 H824 Z" fill="' + s + '"/>' +
      /* 黒い線：革の境目の縦4本と、外周を1回だけ（重ねて引くと外周だけ濃く太く見えていた）2026.10.27 */
      line('M246 302 V752 M562 302 V752 M744 302 V752 M824 302 V752') +
      line('M84 302 H926 L962 516 L926 752 H84 Q72 752 72 740 V314 Q72 302 84 302 Z') +
      /* ホック */
      '<circle cx="894" cy="516" r="14" fill="#A88A3E"' + EDGE + '/>' +
      /* ネームプレート：右の差し込み（サブ革）の下寄り・右寄り（写真の黄色い斜線の場所）。革は付く場所と同じ 2026.10.26 */
      (c.name ? c.name(609, 646, 106, 47, s) : '') +
      /* 補強（縦の短い線、4か所）：左の差し込みの内側の端と、右の差し込みの外側の端の、それぞれ上下（写真の水色の糸）2026.10.26 */
      reinLine(c, 'M236 292 V318') + reinLine(c, 'M236 736 V762') +
      reinLine(c, 'M726 292 V318') + reinLine(c, 'M726 736 V762') +
      /* 縫い目：外周。革の端から INSET(15) 2026.10.27 */
      c.stitch('path', 'st3-stitch-inside', 'd="M87 317 H913.3 L946.8 516.1 L913.1 737 H87 V317"');

    return frame(c, '文庫本カバーのツートン見本', [
      { box: [250, 162, 486, 644], core: [170, 628], body: front },
      /* 内部の写真は正面より小さく写っている。本体の高さ（正面628・内部450）がそろうよう倍率をかける 2026.10.26 */
      { box: [64, 294, 906, 466], body: inside, k: 628 / 450 }
    ]);
  };

  /* st-12：ベルト付きブックカバー（文庫）。品番はネーム位置の画像の中の記録から読んだ 2026.10.27。正面＝本体（メイン）＋ベルト、内部＝左右の差し込み（サブ）＋真ん中はメイン革の裏、ベルト。
     ベルトはツートン「しない」の時、メイン革の色に関係なくキャメル（c.accUrl → 'url(#uid-a)'）。写真の座標そのまま（正面1000px・内部1800px）2026.10.27 */
  shapes['st-12'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var s = 'url(#' + c.uid + '-s)';
    var a = 'url(#' + c.uid + '-a)'; /* ふだんキャメルの部品（ベルト）2026.10.27 */
    var I = INSET;

    var front =
      /* 本体（メイン革）：左が背、上・右・下に縫い目 */
      '<path id="bcb-body" d="M290 150 H773 Q785 150 785 162 V820 Q785 832 773 832 H290 Z" fill="' + m + '"/>' +
      line('M290 150 H773 Q785 150 785 162 V820 Q785 832 773 832 H290 Z') +
      c.stitch('path', 'bcb-stitch', 'd="M' + (290 + 7) + ' ' + (150 + I) + ' H' + (785 - I) + ' V' + (832 - I) + ' H' + (290 + 7) + '"') +
      /* ベルト：右の端から回り込み、先は丸い。ホックで留める（金具は控えめな色）*/
      '<path id="bcb-belt" d="M739 430 H825 Q835 430 835 440 V538 Q835 548 825 548 H739 A59 59 0 0 1 739 430 Z" fill="' + a + '"' + EDGE + '/>' +
      '<circle cx="737" cy="489" r="22" fill="#8C7A55"' + EDGE_SMALL + '/>';

    var inside =
      /* 内部は2枚目の写真（1000px）に合わせる：ベルトは右、正面と同じ高さ。左の差し込み（サブ）＋右の差し込み（サブ）＋真ん中はメイン革の裏 2026.10.27 */
      suede('M84 183 H878 Q890 183 890 195 V716 Q890 728 878 728 H84 Q72 728 72 716 V195 Q72 183 84 183 Z', m, true) +
      /* 左の差し込み（サブ）*/
      '<path id="bcb-in-left" d="M84 183 H245 V728 H84 Q72 728 72 716 V195 Q72 183 84 183 Z" fill="' + s + '"/>' +
      /* 右の差し込み（サブ）*/
      '<path id="bcb-in-right" d="M715 183 H878 Q890 183 890 195 V716 Q890 728 878 728 H715 Z" fill="' + s + '"/>' +
      /* 黒い線：差し込みの境目と外周を1回だけ */
      line('M245 183 V728 M715 183 V728') +
      line('M84 183 H878 Q890 183 890 195 V716 Q890 728 878 728 H84 Q72 728 72 716 V195 Q72 183 84 183 Z') +
      /* 縫い目：外周。革の端から INSET */
      c.stitch('path', 'bcb-stitch-inside', 'd="M' + (72 + I) + ' ' + (183 + I) + ' H' + (890 - I) + ' V' + (728 - I) + ' H' + (72 + I) + ' Z"') +
      /* ベルト：正面とまったく同じ高さ・大きさ・はみ出し（正面の座標を倍率で割り戻した値）。先（左）は丸い 2026.10.27 */
      '<path id="bcb-in-belt" d="M853.2 407 H922 Q930 407 930 415 V493 Q930 501 922 501 H853.2 A47.2 47.2 0 0 1 853.2 407 Z" fill="' + a + '"' + EDGE + '/>' +
      '<circle cx="851.6" cy="454" r="17.6" fill="#8C7A55"' + EDGE_SMALL + '/>' +
      /* ネームプレート：右の差し込みの右下（確認済み）。革は付く場所（サブ）と同じ 2026.10.27 */
      (c.name ? c.name(750, 632, 113, 56, s) : '');

    return frame(c, 'ブックカバーのツートン見本', [
      { box: [275, 140, 575, 712], core: [150, 682], body: front }, /* 下＝革の下(832)＋20 */
      /* 内部の写真は正面より小さく写っている。本体の高さ（正面682・内部545）がそろうよう倍率をかける 2026.10.27 */
      { box: [62, 173, 878, 571], body: inside, k: 682 / 545 }
    ]);
  };

  /* g-21：L字ファスナー財布（細長）。ツートンは g-22 と同じ考え：正面＝本体（メイン）＋下の帯・輪の引き手（サブ）、内部＝本体（メイン）＋カードポケット・ペン差し（サブ）。
     正面の写真（1000px）の座標そのまま。u＝図の1cmあたり（補強のコの字が写真の位置＝右端から4.6cmに来る値）2026.10.27 */
  shapes['g-21'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var s = 'url(#' + c.uid + '-s)';
    var I = INSET;
    var L = 213, R = 840, T = 365, BT = 684, B = 752, CR = 62; /* 左・右・上・帯の上・下・右上の角の丸み */
    var u = 135 / REIN_BOX_FROM_RIGHT;

    /* 引き手（サブ革）：スライダーから左斜め上へ。細長い革を折った帯で、付け根にカシメ。縫い目は真ん中に1本（g-21 の引き手は例外で縫い目あり。g-52 と同じく例外）2026.10.27 */
    var px = 262, py = T - 7, len = 200, th = 42;
    var loop =
      '<g transform="rotate(211.5 ' + px + ' ' + py + ')">' +
      '<path id="g21-loop" d="M' + px + ' ' + (py - th / 2) + ' H' + (px + len - th / 2) + ' A' + (th / 2) + ' ' + (th / 2) + ' 0 0 1 ' + (px + len - th / 2) + ' ' + (py + th / 2) + ' H' + px + ' Z" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'g21-loop-stitch', 'd="M' + (px + 44) + ' ' + py + ' H' + (px + len - 14) + '"') +
      '<circle cx="' + (px + 22) + '" cy="' + py + '" r="11" fill="#8C7A55"' + EDGE_SMALL + '/>' +
      '</g>';

    var front =
      /* ファスナー：上と右（L字）。終わりは下の端の少し手前から本体の中へ */
      zip('g21-zip', 'M' + (L + 40) + ' ' + (T - 7) + ' H' + (R - CR) + ' Q' + (R + 7) + ' ' + (T - 7) + ' ' + (R + 7) + ' ' + (T + CR) + ' V' + (B - 30), tailDown(R + 7, B - 30)) +
      loop + zipSlider(L + 40, T - 7, u) +
      /* 本体（メイン）と下の帯（サブ）：塗りだけ、線は1回 */
      '<path id="g21-main" d="M' + L + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + BT + ' H' + L + ' Z" fill="' + m + '"/>' +
      '<path id="g21-band" d="M' + L + ' ' + BT + ' H' + R + ' V' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' Z" fill="' + s + '"/>' +
      line('M' + L + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' Z') +
      line('M' + L + ' ' + BT + ' H' + R) +
      /* 縫い目：上辺と右辺（下まで）、帯の上部。革の端から INSET */
      c.stitch('path', 'g21-stitch-edge', 'd="M' + (L + I) + ' ' + (T + I) + ' H' + (R - CR) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + CR) + ' V' + (B - I) + '"') +
      c.stitch('path', 'g21-stitch-band', 'd="M' + (L + I) + ' ' + (BT + I) + ' H' + (R - I) + '"') +
      /* 刺繍（イカリ）：本体の上寄り・真ん中（写真の位置）*/
      embBig(c, 513, 441, 38) +
      /* ブランド刻印の半円タブ：帯の上の左寄り（写真の位置）。ツートン対象外なのでメイン革 */
      '<path id="g21-brand" d="M' + (370 - 1.05 * u) + ' ' + BT + ' A' + (1.05 * u) + ' ' + (1.05 * u) + ' 0 0 1 ' + (370 + 1.05 * u) + ' ' + BT + ' Z" fill="' + m + '"' + EDGE_SMALL + '/>' +
      /* 補強：下の端のコの字（g-2・g-22 と共通）*/
      reinBox(c, R, B, u);

    /* 内部：背面の裏側。外形は正面と同じ（右上の丸みも同じ・同じ大きさ）。上はメイン革の裏、下の帯はサブ革の裏（正面の帯と同じ高さ）。
       ペン差しは左の端から（離さない）、ポケットとともにサブ。どちらも帯の上に置き、帯には重ねない。ネームはポケットの上寄り・真ん中 2026.10.27 */
    var inOutline = 'M' + L + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' Z';
    var inside =
      /* 本体：メイン革の裏（白く重ねる）*/
      suede(inOutline, m, true) +
      /* 下の帯：サブ革の裏（白く重ねる）。正面の帯と同じ高さ */
      suede('M' + L + ' ' + BT + ' H' + R + ' V' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' Z', s, true) +
      /* ペン差し（サブ革）：左の端から。帯の上まで */
      '<path id="g21c-pen" d="M' + L + ' 470 H' + (L + 73) + ' V670 H' + L + ' Z" fill="' + s + '"/>' +
      /* ポケット（サブ革）：下は帯の上の線まで */
      '<path id="g21c-pocket" d="M352 502 H727 V' + BT + ' H352 Z" fill="' + s + '"/>' +
      /* 黒い線：外周、帯の境目、ペン差し、ポケットを1回だけ */
      line(inOutline) +
      line('M' + L + ' ' + BT + ' H' + R) +
      line('M' + L + ' 470 H' + (L + 73) + ' V670 H' + L) +
      line('M352 ' + BT + ' V502 H727 V' + BT) +
      /* 縫い目：正面と同じ位置（上と右）、帯の上部。革の端から INSET */
      c.stitch('path', 'g21c-stitch-edge', 'd="M' + (L + I) + ' ' + (T + I) + ' H' + (R - CR) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + CR) + ' V' + (B - I) + '"') +
      c.stitch('path', 'g21c-stitch-band', 'd="M' + (L + I) + ' ' + (BT + I) + ' H' + (R - I) + '"') +
      /* ネームプレート：ポケットの上寄り・真ん中。革は付く場所（サブ）と同じ */
      (c.name ? c.name(467, 531, 144, 56, s) : '');

    return frame(c, 'L字ファスナー財布のツートン見本', [
      { box: [70, 225, 790, 547], core: [358, 394], body: front }, /* 下＝革の下(752)＋20。上は輪の引き手の分を空ける */
      { box: [203, 345, 647, 427], body: inside } /* 正面と同じ大きさ。下＝革の下(752)＋20 */ /* 下＝革の下(752)＋20 */
    ]);
  };

  /* 小物（ツートンなし）：ac-1・ac-3・ac-8（標準・ビッグを並べる）・ac-9-10（ショート・ロングを上下に並べる）。写真の座標そのまま。刺繍は emb-new.js の革色連動のまま。
     シンプルな小物は金具（輪・フック・バックル・二重リング）も描く（財布などの「金具は描かない」の例外）2026.10.27 */
  var METAL = '#8C7A55';
  /* 小物の縫い目：製品が小さい分、糸が目立つので太さは財布の1.1倍に抑える（1.4倍は太すぎた）。目は長め（1.5倍）、すき間は詰める（0.8倍）。粗く離れて見えないように 2026.10.27 */
  function sStitch(c, tag, id, geo) {
    return c.stitch(tag, id, geo).replace(/stroke-width="([\d.]+)" stroke-dasharray="([\d. ]+)"/, function (all, w, dash) {
      var d = dash.trim().split(/\s+/).map(parseFloat);
      return 'stroke-width="' + (parseFloat(w) * 1.1) + '" stroke-dasharray="' + (d[0] * 1.5) + ' ' + (d[1] * 0.8) + '"';
    });
  }
  function embAt(c, cx, cy, size) { return embBig(c, cx - size / 2, cy - size / 2, size); }
  function rivet(cx, cy, r) { return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + METAL + '"' + EDGE_SMALL + '/>'; }
  /* 金具の線（輪・フック・バックル）：濃い縁＋金具色 */
  function metal(d, w) {
    return '<path d="' + d + '" fill="none" stroke="#2A241A" stroke-width="' + (w + 4) + '" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="' + d + '" fill="none" stroke="' + METAL + '" stroke-width="' + w + '" stroke-linecap="round" stroke-linejoin="round"/>';
  }
  function ring(cx, cy, r, w) { return metal('M' + (cx - r) + ' ' + cy + ' A' + r + ' ' + r + ' 0 1 0 ' + (cx + r) + ' ' + cy + ' A' + r + ' ' + r + ' 0 1 0 ' + (cx - r) + ' ' + cy, w); }
  /* 二重リングの先の小さな丸い革（色は製品の写真どおり固定）*/
  function washer(cx, cy, r, color) {
    return '<path d="M' + (cx - r) + ' ' + cy + ' a' + r + ' ' + r + ' 0 1 0 ' + (2 * r) + ' 0 a' + r + ' ' + r + ' 0 1 0 ' + (-2 * r) + ' 0 Z M' + (cx - r * 0.32) + ' ' + cy + ' a' + (r * 0.32) + ' ' + (r * 0.32) + ' 0 1 1 ' + (r * 0.64) + ' 0 a' + (r * 0.32) + ' ' + (r * 0.32) + ' 0 1 1 ' + (-r * 0.64) + ' 0 Z" fill-rule="evenodd" fill="' + color + '"' + EDGE_SMALL + '/>';
  }

  /* ac-1：キーホルダー（帯を折り返した形）。真ん中に縫い目1本（上からカシメまで）、カシメの下にイカリ。下に大きな輪、二重リング4つと丸い革3つ */
  shapes['ac-1'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var body =
      /* 輪と二重リング（半径32）は olk-1 と共通の大きさ・位置。丸い革は二重リングの先 2026.10.27 */
      ring(662, 640, 74, 10) +
      ring(600, 730, 32, 6) + ring(640, 740, 32, 6) + ring(684, 732, 32, 6) + ring(722, 742, 32, 6) +
      /* 丸い革は描かない（輪と二重リングだけ）2026.10.27 */
      /* 先は半円（olk-1 と共通）2026.10.27 */
      '<path id="ac1-body" d="M605 100 H717 V536 A56 56 0 0 1 605 536 Z" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac1-stitch', 'd="M661 106 V392"') +
      rivet(661, 425, 32) +
      embAt(c, 661, 512, 64);
    return frame(c, 'キーホルダーの見本', [{ box: [545, 90, 235, 760], core: [100, 492], body: body }]);
  };

  /* ac-3：フック付きキーホルダー。上の角を小さく落とした革のタブ（イカリの下にカシメ・縫い目なし）、上にフック、下に輪・二重リング4つ・丸い革3つ（ac-1 と同じ） */
  shapes['ac-3'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var body =
      /* フックは途中で切る（上の大きな輪は描かない）。タブの上に出た根元だけ 2026.10.27 */
      '<g clip-path="url(#' + c.uid + '-ac3cut)">' +
      /* フック：左の脚がタブから上がって左へ大きくふくらみ、上で回って右の先が下を向く。右の脚の上がばね式の留め具（ちょうつがい→先へ）2026.10.27 */
      metal('M850 690 C 862 640 860 600 820 560 C 760 500 718 440 735 370 C 755 290 900 268 975 298 C 1040 324 1062 392 1038 432', 40) +
      metal('M955 690 C 950 640 925 592 945 548', 34) +
      metal('M945 548 L 1022 395', 22) +
      '<circle cx="945" cy="548" r="13" fill="#2A241A"/>' +
      '</g>' +
      /* 下の金具：ac-1 と同じ並び（大きな輪から二重リング4つ、その先に丸い革3つ）。ac-1 の配置を輪の大きさに合わせて拡大 2026.10.27 */
      ring(906, 1045, 96, 16) +
      ring(825.6, 1161.8, 41.5, 7) + ring(877.5, 1174.7, 41.5, 7) + ring(934.5, 1164.4, 41.5, 7) + ring(983.8, 1177.3, 41.5, 7) +
      /* 丸い革は描かない（輪と二重リングだけ）2026.10.27 */
      '<path id="ac3-body" d="M832 688 H986 L1000 702 V990 Q1000 1004 986 1004 H832 Q818 1004 818 990 V702 Z" fill="' + m + '"' + EDGE + '/>' +
      embAt(c, 909, 772, 108) +
      rivet(909, 862, 22);
    body = '<defs><clipPath id="' + c.uid + '-ac3cut"><rect x="600" y="575" width="600" height="900"/></clipPath></defs>' + body;
    return frame(c, 'キーホルダーの見本', [{ box: [760, 560, 300, 760], core: [688, 316], body: body }]);
  };

  /* ac-8：キーカバー。1つの製品（ハンドル ac-8）でサイズ違い：標準＝幅3cm、ビッグ＝幅3.8cm、高さはどちらも2.8cm（商品説明の寸法）。
     見本は2つを左右に並べる。
     上の左右の角を斜めに落とす。縫い目は上と右（角は丸く）。キーの穴、その下にイカリ 2026.10.27 */
  var KC_H = 325, KC_U = KC_H / 2.8; /* 図の1cm */
  function keyCover(c, wcm) {
    var m = 'url(#' + c.uid + '-m)';
    var x0 = 742, y0 = 795, x1 = x0 + wcm * KC_U, y1 = y0 + KC_H, cx = (x0 + x1) / 2, I = INSET;
    return '<path d="M' + (x0 + 22) + ' ' + y0 + ' H' + (x1 - 22) + ' L' + x1 + ' ' + (y0 + 22) + ' V' + y1 + ' H' + x0 + ' V' + (y0 + 22) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac8-stitch', 'd="M' + (x0 + 28) + ' ' + (y0 + 22) + ' H' + (x1 - I - 26) + ' Q' + (x1 - I - 8) + ' ' + (y0 + 22) + ' ' + (x1 - I - 8) + ' ' + (y0 + 48) + ' V' + (y1 - 35) + '"') +
      '<circle cx="' + cx + '" cy="' + (y0 + 63) + '" r="20" fill="#FFFFFF"' + EDGE_SMALL + '/>' +
      embAt(c, cx, y0 + 205, 121);
  }
  shapes['ac-8'] = function (c) {
    /* 左に標準（ac-8）、右にビッグ（ac-8-big）を並べる。高さが同じなので、同じ縮尺で幅の違いが見える 2026.10.27 */
    /* 選んだ種類だけ描く（c.variant：0＝標準・1＝ビッグ）。枠はビッグの幅で固定して、標準は小さく見える（右寄せ）2026.11.02 */
    var big = c.variant === 1, w = (big ? 3.8 : 3.0) * KC_U + 40, W = 3.8 * KC_U + 40;
    return frame(c, 'キーカバーの見本', [
      { box: [722 - (W - w), 775, W, KC_H + 40], core: [795, 325], body: keyCover(c, big ? 3.8 : 3.0) }
    ]);
  };
  shapes['ac-8'].variants = ['標準', 'BIG'];

  /* ac-9-10 のブレスレット（ショート＝ac-9・ロング＝ac-10）。どちらも同じ縮尺（ac-10 の長さの枠）で描くので、長さの違いが見える。
     左はバックル（四角の枠＋真ん中の棒）で折り返す、右の先は斜めに切る（ac-9・ac-10 で同じ角度）。穴の並び、縫い目は真ん中に1本 2026.10.27 */
  function braceletBody(c, id, tipTop, tipBottom, stitchEnd, holes) {
    var m = 'url(#' + c.uid + '-m)';
    var y1 = 1230, y2 = 1274, cy = (y1 + y2) / 2;
    var body =
      '<path id="' + id + '-body" d="M150 ' + y1 + ' H' + tipTop + ' L' + tipBottom + ' ' + y2 + ' H150 Z" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', id + '-stitch', 'd="M205 ' + cy + ' H' + stitchEnd + '"') +
      holes.map(function (x) { return '<circle cx="' + x + '" cy="' + cy + '" r="6" fill="#FFFFFF"' + EDGE_SMALL + '/>'; }).join('') +
      /* バックル：四角の枠と真ん中の棒 */
      metal('M108 1216 H178 V1288 H108 Z', 9) + metal('M143 1216 V1288', 7);
    return body;
  }
  /* ac-9-10：ブレスレット。1つの製品（ハンドル ac-9-10）でタイプ違い：ショート（ac-9）／ロング（ac-10）。見本は2本を上下に並べる 2026.10.27 */
  shapes['ac-9-10'] = function (c) {
    /* 上にショート（ac-9）、下にロング（ac-10）を並べる。同じ幅の枠なので、同じ縮尺で長さの違いが見える 2026.10.27 */
    /* 選んだ種類だけ描く（c.variant：0＝ショート ac-9・1＝ロング ac-10）。枠は同じなので長さの違いは見える 2026.11.02 */
    return frame(c, 'ブレスレットの見本', [
      c.variant === 1 ?
        { box: [95, 1195, 2500, 110], body: braceletBody(c, 'ac10', 1835, 1880, 765, [1400, 1457, 1514, 1571, 1628, 1685, 1742, 1799]) } :
        { box: [95, 1195, 2500, 110], body: braceletBody(c, 'ac9', 985, 1030, 420, [690, 750, 810, 870, 930]) }
    ]);
  };
  shapes['ac-9-10'].variants = ['ショート', 'ロング'];

  /* ac-11-41-51：ストラップ（1つの製品でタイプ違い）。見本は3本を同じ向き・同じ縮尺で上から ac-11・ac-41・ac-51 と並べる。
     ac-11 と ac-51 はほぼ同じ長さ、ac-41 は約1.7倍長く、幅も広い。両端にカシメ、間に縫い目1本（小物の縫い目）。左の端にナスカン、右の端に輪（＋ナスカン）。
     ac-51 は右に輪＋リール（＋ナスカン）。リールのイカリは変更できないので描かない（変えられるのはミシン糸だけ）2026.10.27 */
  /* ナスカン：x＝付け根、dir＝向き（-1 で左へ、1 で右へ）*/
  function clasp(x, y, dir) {
    /* ナスカン：台座（四角い枠）→ 回転する首 → 本体（先が丸く広い・中に穴）。
       革の端を台座の内側の棒に巻いて、カシメで留める。だから台座の内側の半分は革の下、外側の半分が革の端から出て見える 2026.10.27 */
    var a = x - dir * 14, b = x + dir * 22;
    var n0 = b, b0 = x + dir * 40, b1 = x + dir * 134;
    var cx = x + dir * 99;
    var body = 'M' + b0 + ' ' + (y - 9) + ' C ' + (b0 + dir * 30) + ' ' + (y - 14) + ' ' + (b1 - dir * 40) + ' ' + (y - 36) + ' ' + b1 + ' ' + (y - 8) +
      ' C ' + (b1 + dir * 6) + ' ' + (y + 14) + ' ' + (b1 - dir * 20) + ' ' + (y + 34) + ' ' + (cx - dir * 6) + ' ' + (y + 26) +
      ' C ' + (b0 + dir * 30) + ' ' + (y + 16) + ' ' + (b0 + dir * 10) + ' ' + (y + 10) + ' ' + b0 + ' ' + (y + 9) + ' Z' +
      ' M' + (cx - dir * 22) + ' ' + y + ' a 22 13 0 1 0 ' + (dir * 44) + ' 0 a 22 13 0 1 0 ' + (-dir * 44) + ' 0 Z';
    var bx = Math.min(a, b), bw = Math.abs(b - a);
    return '<rect x="' + bx + '" y="' + (y - 27) + '" width="' + bw + '" height="54" rx="8" fill="none" stroke="#2A241A" stroke-width="10"/>' +
      '<rect x="' + bx + '" y="' + (y - 27) + '" width="' + bw + '" height="54" rx="8" fill="none" stroke="' + METAL + '" stroke-width="6"/>' +
      '<rect x="' + Math.min(n0, b0) + '" y="' + (y - 6) + '" width="' + Math.abs(b0 - n0) + '" height="12" rx="3" fill="' + METAL + '" stroke="#2A241A" stroke-width="2"/>' +
      '<path d="' + body + '" fill-rule="evenodd" fill="' + METAL + '" stroke="#2A241A" stroke-width="3" stroke-linejoin="round"/>' +
      metal('M' + (cx - dir * 4) + ' ' + (y + 13) + ' L' + (b0 + dir * 16) + ' ' + (y + 5), 4);
  }
  /* 金具の付き方：革の端を折り返して、金具（ナスカンの台座・丸い輪）をその折り返しに通し、カシメで留める。
     だから金具の内側の半分は革の下に入る。左端＝ナスカンの台座、右端＝丸い輪。
     右のナスカン（ac-51 はリール）は、その輪の線に目を掛けて下がる 2026.10.27 */
  function strapBody(c, len, w, reel) {
    var m = 'url(#' + c.uid + '-m)';
    var x0 = 200, x1 = x0 + len, y = 100, hw = w / 2;
    var rc = x1 + 30, rr = 45; /* 輪：革の折り返しに通るので、端に少し重なる */
    var hang = rc + rr; /* 輪の右の線（ここに次の金具の目が掛かる）*/
    var right = reel
      ? ring(hang + 12, y, 12, 5) +
        '<circle cx="' + (hang + 24 + 58) + '" cy="' + y + '" r="58" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
        '<circle cx="' + (hang + 24 + 58) + '" cy="' + y + '" r="44" fill="' + m + '"' + EDGE_SMALL + '/>' +
        metal('M' + (hang + 140) + ' ' + y + ' H' + (hang + 160), 4) +
        clasp(hang + 172, y, 1)
      : clasp(hang, y, 1);
    return clasp(x0 + 8, y, -1) + ring(rc, y, rr, 8) + right +
      '<rect x="' + x0 + '" y="' + (y - hw) + '" width="' + len + '" height="' + w + '" rx="10" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'strap-stitch-' + len, 'd="M' + (x0 + 66) + ' ' + y + ' H' + (x1 - 66) + '"') +
      rivet(x0 + 40, y, 16) + rivet(x1 - 40, y, 16);
  }
  shapes['ac-11-41-51'] = function (c) {
    var box = [40, 30, 1780, 140];
    /* 選んだ種類だけ描く（c.variant：0＝ac-11・1＝ac-41・2＝ac-51）。長さ：ac-11 と ac-51 はほぼ同じ、ac-41 は約1.7倍で幅も広い 2026.11.02 */
    var v = c.variant || 0;
    return frame(c, 'ストラップの見本', [
      { box: box, body: v === 1 ? strapBody(c, 1360, 88, false) : strapBody(c, 800, 70, v === 2) }
    ]);
  };
  shapes['ac-11-41-51'].variants = ['ac-11', 'ac-41', 'ac-51'];

  /* ac-50：ショルダーストラップ。分かりやすさ優先で、まっすぐ横1本に伸ばして描く。表から見える革だけ（裏のテープは描かない）。左から：
     ナスカン（目は革の折り返しに通す）→ 折り返した革（両ふちに縫い目・途中にベルト通し）→ 角カン（ふつうの四角い枠、革がくぐる）
     → 革（両ふちに縫い目）→ 先の丸い革のタブ（カシメ）→ ナスカン 2026.10.27 */
  function adjStrap(c, stitched, pad) {
    var m = 'url(#' + c.uid + '-m)';
    var y = 100, w = 60, hw = w / 2, e = 11;
    var A0 = 200, BK = 545, B1 = 1560, TAB1 = 1645;
    function edgeStitch(id, x0, x1) {
      return sStitch(c, 'path', id, 'd="M' + x0 + ' ' + (y - hw + e) + ' H' + x1 + ' M' + x0 + ' ' + (y + hw - e) + ' H' + x1 + '"');
    }
    var body =
      clasp(A0 + 8, y, -1) + clasp(TAB1 - 6, y, 1) +
      /* 革：左の端から右のタブの手前まで1本 */
      '<rect x="' + A0 + '" y="' + (y - hw) + '" width="' + (B1 - A0) + '" height="' + w + '" rx="8" fill="' + m + '"' + EDGE + '/>' +
      (stitched ? edgeStitch('ac50-stitch-a', A0 + 20, BK - 28) + edgeStitch('ac50-stitch-b', BK + 28, B1 - 15) : '') +
      /* ベルト通し */
      '<rect x="300" y="' + (y - hw - 8) + '" width="42" height="' + (w + 16) + '" rx="5" fill="' + m + '"' + EDGE + '/>' +
      /* 先の丸い革のタブとカシメ */
      '<path d="M' + B1 + ' ' + (y - hw) + ' H' + (TAB1 - hw) + ' A' + hw + ' ' + hw + ' 0 0 1 ' + (TAB1 - hw) + ' ' + (y + hw) + ' H' + B1 + ' Z" fill="' + m + '"' + EDGE + '/>' +
      rivet(B1 + 34, y, 15) +
      /* 肩当て（ac-20）：長い方の革の真ん中に、ストラップより太い革。縫い目は上の辺に沿って1本だけ 2026.10.27 */
      (pad
        /* 全長約120cmに対して肩当ては約17cm（革の長さ1445≒120cm）。長い方の真ん中 2026.10.27 */
        ? '<rect x="950" y="' + (y - 55) + '" width="205" height="110" rx="6" fill="' + m + '"' + EDGE + '/>' +
          sStitch(c, 'path', 'ac20-stitch', 'd="M962 ' + (y - 40) + ' H1130"')
        : '') +
      /* 角カン：ふつうの四角い枠（角は少し丸い）。革の上に枠の線だけ */
      '<rect x="' + (BK - 18) + '" y="' + (y - hw - 12) + '" width="36" height="' + (w + 24) + '" rx="7" fill="none" stroke="#2A241A" stroke-width="13"/>' +
      '<rect x="' + (BK - 18) + '" y="' + (y - hw - 12) + '" width="36" height="' + (w + 24) + '" rx="7" fill="none" stroke="' + METAL + '" stroke-width="9"/>';
    return frame(c, 'ショルダーストラップの見本', [{ box: [40, 30, 1760, 140], body: body }]);
  }
  shapes['ac-50'] = function (c) { return adjStrap(c, true, false); };
  /* ac-20：ac-50 と同じストラップから縫い目をなくし、肩当てを付けた形 2026.10.27 */
  shapes['ac-20'] = function (c) { return adjStrap(c, false, true); };

  /* ac-43-45：ネックストラップ（1つの製品でタイプ違い）。直線で描く：輪になったストラップを1本に伸ばし、左は続いている（端は描かない）。
     縫い目は長さ方向に1本。右の端は折り返してカシメで留め、そこに金具。上＝ac-43（輪→リール→ナスカン）、下＝ac-45（ナスカンだけ）2026.10.27 */
  function lanyardBody(c, reel) {
    var m = 'url(#' + c.uid + '-m)';
    var x0 = 60, x1 = 1250, y = 100, w = 46, hw = w / 2;
    var rc = x1 + 26, rr = 34, hang = rc + rr;
    var hw2 = reel
      ? ring(rc, y, rr, 7) + ring(hang + 12, y, 12, 5) +
        '<circle cx="' + (hang + 24 + 58) + '" cy="' + y + '" r="58" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
        '<circle cx="' + (hang + 24 + 58) + '" cy="' + y + '" r="44" fill="' + m + '"' + EDGE_SMALL + '/>' +
        metal('M' + (hang + 140) + ' ' + y + ' H' + (hang + 160), 4) +
        clasp(hang + 172, y, 1)
      : clasp(x1 - 8, y, 1);
    return hw2 +
      '<rect x="' + x0 + '" y="' + (y - hw) + '" width="' + (x1 - x0) + '" height="' + w + '" fill="' + m + '"/>' +
      line('M' + x0 + ' ' + (y - hw) + ' H' + (x1 - 8) + ' Q' + x1 + ' ' + (y - hw) + ' ' + x1 + ' ' + (y - hw + 8) + ' V' + (y + hw - 8) + ' Q' + x1 + ' ' + (y + hw) + ' ' + (x1 - 8) + ' ' + (y + hw) + ' H' + x0) +
      sStitch(c, 'path', 'ac43-stitch-' + (reel ? 'r' : 'c'), 'd="M' + x0 + ' ' + y + ' H' + (x1 - 70) + '"') +
      rivet(x1 - 40, y, 13);
  }
  shapes['ac-43-45'] = function (c) {
    var box = [40, 40, 1760, 120];
    /* 選んだ種類だけ描く（c.variant：0＝ac-43・1＝ac-45）2026.11.02 */
    return frame(c, 'ネックストラップの見本', [
      { box: box, body: lanyardBody(c, c.variant !== 1) }
    ]);
  };
  shapes['ac-43-45'].variants = ['ac-43', 'ac-45'];

  /* 首輪のプラスチックのバックル（黒の固定色）。差し込む側：付け根の台＋真ん中の舌と左右の爪。受ける側：箱形。x＝革の端、dir＝外向き 2026.10.27 */
  var PLASTIC = '#1E1E1E';
  function buckleMale(x, y, dir) {
    var b = x + dir * 40, t = x + dir * 110;
    var P = ' fill="' + PLASTIC + '" stroke="#080808" stroke-width="3" stroke-linejoin="round"';
    return '<rect x="' + Math.min(x - dir * 12, b) + '" y="' + (y - 34) + '" width="' + (Math.abs(b - x) + 12) + '" height="68" rx="6"' + P + '/>' +
      '<path d="M' + b + ' ' + (y - 8) + ' H' + t + ' V' + (y + 8) + ' H' + b + ' Z"' + P + '/>' +
      '<path d="M' + b + ' ' + (y - 34) + ' Q' + (b + dir * 50) + ' ' + (y - 34) + ' ' + (t - dir * 4) + ' ' + (y - 24) + ' L' + (t - dir * 18) + ' ' + (y - 14) + ' Q' + (b + dir * 40) + ' ' + (y - 22) + ' ' + b + ' ' + (y - 22) + ' Z"' + P + '/>' +
      '<path d="M' + b + ' ' + (y + 34) + ' Q' + (b + dir * 50) + ' ' + (y + 34) + ' ' + (t - dir * 4) + ' ' + (y + 24) + ' L' + (t - dir * 18) + ' ' + (y + 14) + ' Q' + (b + dir * 40) + ' ' + (y + 22) + ' ' + b + ' ' + (y + 22) + ' Z"' + P + '/>';
  }
  function buckleFemale(x, y, dir) {
    var x2 = x + dir * 110;
    return '<rect x="' + Math.min(x - dir * 15, x2) + '" y="' + (y - 40) + '" width="125" height="80" rx="14" fill="' + PLASTIC + '" stroke="#080808" stroke-width="3"/>' +
      '<rect x="' + Math.min(x + dir * 40, x + dir * 90) + '" y="' + (y - 22) + '" width="50" height="44" rx="6" fill="#3A3A3A"/>';
  }
  /* コキカン（長さ調節）：四角い枠と真ん中の棒、革がくぐる */
  function slider(cx, y, h) {
    return '<rect x="' + (cx - 20) + '" y="' + (y - h / 2) + '" width="40" height="' + h + '" rx="7" fill="none" stroke="#2A241A" stroke-width="12"/>' +
      '<rect x="' + (cx - 20) + '" y="' + (y - h / 2) + '" width="40" height="' + h + '" rx="7" fill="none" stroke="' + METAL + '" stroke-width="8"/>' +
      metal('M' + cx + ' ' + (y - h / 2) + ' V' + (y + h / 2), 6);
  }

  /* ac-28：首輪（ペット用・長さ調節付き）。直線で描く。左から：バックル（差し込む側）→ 革（折り返してカシメ）→ 縫い目1本
     → コキカン → 角カン → バックル（受ける側）。全長約28cm（1cm＝50）2026.10.27 */
  shapes['ac-28'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var y = 100, w = 50, hw = w / 2;
    var x0 = 200, x1 = 1250;
    var body =
      buckleMale(x0, y, -1) + buckleFemale(x1, y, 1) +
      /* 角カン：革をくぐらせてあるので、左の辺は革の下、右の辺だけ革の上に見える（Dカンではない）2026.10.27 */
      '<rect x="1140" y="' + (y - hw - 12) + '" width="44" height="' + (w + 24) + '" rx="6" fill="none" stroke="#2A241A" stroke-width="10"/>' +
      '<rect x="1140" y="' + (y - hw - 12) + '" width="44" height="' + (w + 24) + '" rx="6" fill="none" stroke="' + METAL + '" stroke-width="6"/>' +
      '<rect x="' + x0 + '" y="' + (y - hw) + '" width="' + (x1 - x0) + '" height="' + w + '" rx="6" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac28-stitch', 'd="M' + (x0 + 70) + ' ' + y + ' H' + (x1 - 40) + '"') +
      rivet(x0 + 38, y, 13) +
      slider(1030, y, w + 20) +
      metal('M1184 ' + (y - hw - 12) + ' V' + (y + hw + 12), 6);
    return frame(c, '首輪の見本', [{ box: [60, 40, 1320, 120], body: body }]);
  };

  /* ac-128：名札付きの首輪。ac-28 と同じ向きで直線に描く。左から：バックル（差し込む側）→ 折り返した端（裏が見える・カシメ）→ 革（縫い目1本）
     → 名札（ヌメ革の固定色・ストラップより太い板、左右の切れ込みにストラップを通す）→ 革 → コキカン → ベルト通し → 折り返してバックル（受ける側）2026.10.27 */
  shapes['ac-128'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var y = 100, w = 48, hw = w / 2;
    var x0 = 200, x1 = 1250, NUME = '#EBC2A3';
    var body =
      buckleMale(x0, y, -1) + buckleFemale(x1, y, 1) +
      '<rect x="' + x0 + '" y="' + (y - hw) + '" width="' + (x1 - x0) + '" height="' + w + '" rx="6" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac128-stitch', 'd="M' + (x0 + 80) + ' ' + y + ' H' + (x1 - 40) + '"') +
      /* 折り返した端：裏（起毛）が見える小さな当て。カシメ */
      suede('M' + x0 + ' ' + (y - hw) + ' H' + (x0 + 70) + ' Q' + (x0 + 80) + ' ' + y + ' ' + (x0 + 70) + ' ' + (y + hw) + ' H' + x0 + ' Z', m, false) +
      rivet(x0 + 38, y, 13) +
      /* 名札：ヌメ革の板（左右の辺は少しへこむ）。左右に切れ込みがあり、ストラップが通っている：
         板の両端（端から切れ込みまで）はストラップが上、真ん中は板が上 2026.10.27 */
      '<path d="M520 ' + (y - 52) + ' H700 Q690 ' + y + ' 700 ' + (y + 52) + ' H520 Q530 ' + y + ' 520 ' + (y - 52) + ' Z" fill="' + NUME + '"' + EDGE + '/>' +
      '<rect x="515" y="' + (y - hw) + '" width="35" height="' + w + '" fill="' + m + '"/>' +
      '<rect x="670" y="' + (y - hw) + '" width="35" height="' + w + '" fill="' + m + '"/>' +
      line('M515 ' + (y - hw) + ' H550 M515 ' + (y + hw) + ' H550 M670 ' + (y - hw) + ' H705 M670 ' + (y + hw) + ' H705') +
      sStitch(c, 'path', 'ac128-stitch-l', 'd="M515 ' + y + ' H550"') + sStitch(c, 'path', 'ac128-stitch-r', 'd="M670 ' + y + ' H705"') +
      /* 切れ込み（ストラップが差し込まれる線）*/
      '<path d="M550 ' + (y - hw - 5) + ' V' + (y + hw + 5) + ' M670 ' + (y - hw - 5) + ' V' + (y + hw + 5) + '" stroke="#080808" stroke-width="5" stroke-linecap="round"/>' +
      slider(940, y, w + 22) +
      /* ベルト通し */
      '<rect x="1080" y="' + (y - hw - 7) + '" width="34" height="' + (w + 14) + '" rx="5" fill="' + m + '"' + EDGE + '/>';
    return frame(c, '名札付き首輪の見本', [{ box: [60, 40, 1320, 120], body: body }]);
  };

  /* olk-1：ac-1 と同じ形のキーホルダー。違いは：縫い目が外周（左右のふちと下の丸み）、カシメの下にハンマー刺繍、丸い革なし（輪と二重リングだけ）。
     ハンマーは標準が1つ（アプリに固定の画像）なので、ここでも固定の色で描く 2026.10.27 */
  shapes['olk-1'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var L = 605, R = 717, T = 100, B = 592, i = 20;
    var hr = (R - L) / 2, cx = (L + R) / 2; /* 先は半円（もっと丸く）2026.10.27 */
    var hammer = hammerEmb(c, 661, 500, 1); /* 共通のハンマー刺繍 2026.10.27 */
    var body =
      ring(662, 640, 74, 10) +
      /* 二重リング：少し大きめ（半径32）2026.10.27 */
      ring(600, 730, 32, 6) + ring(640, 740, 32, 6) + ring(684, 732, 32, 6) + ring(722, 742, 32, 6) +
      '<path id="olk1-body" d="M' + L + ' ' + T + ' H' + R + ' V' + (B - hr) + ' A' + hr + ' ' + hr + ' 0 0 1 ' + L + ' ' + (B - hr) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'olk1-stitch', 'd="M' + (L + i) + ' ' + T + ' V' + (B - hr) + ' A' + (hr - i) + ' ' + (hr - i) + ' 0 0 0 ' + (R - i) + ' ' + (B - hr) + ' V' + T + '"') +
      rivet(661, 425, 22) + /* カシメは外周の縫い目に重ならない大きさ 2026.10.27 */
      hammer;
    return frame(c, 'キーホルダーの見本', [{ box: [545, 90, 235, 700], core: [100, 492], body: body }]);
  };

  /* ハンマー刺繍（標準は1つ。アプリに固定の画像なので、ここも固定の色：頭＝水色、柄＝赤）。k＝大きさの倍率（olk-1 が 1）2026.10.27 */
  /* ハンマー刺繍（標準）：頭＝横線（銀色がかった灰色）、柄＝頭の真ん中の下から縦に（赤茶）。T字。rot で向きを回す（olk-13 は 90＝頭が右で縦）2026.11.02 */
  function hammerAt(cx, cy, k, rot) {
    k = k || 1;
    var g = '<path d="M' + cx + ' ' + (cy - 10 * k) + ' V' + (cy + 24 * k) + '" stroke="#9C3B2C" stroke-width="' + (6 * k) + '" stroke-linecap="round"/>' +
      '<path d="M' + (cx - 15 * k) + ' ' + (cy - 14 * k) + ' H' + (cx + 15 * k) + '" stroke="#A3A7AB" stroke-width="' + (9 * k) + '" stroke-linecap="round"/>';
    return rot ? '<g transform="rotate(' + rot + ' ' + cx + ' ' + cy + ')">' + g + '</g>' : g;
  }

  /* ハンマーの製品の刺繍：「しない」＝標準のハンマー、「刺繍を無くす」＝描かない、ほかを選んだら選んだ刺繍（c.embKind が無い時は標準）2026.11.02 */
  function hammerEmb(c, cx, cy, k, rot) {
    var kind = c.embKind;
    if (kind === 'remove') return '';
    if (kind && kind !== 'none') return embAt(c, cx, cy, 50 * (k || 1));
    return hammerAt(cx, cy, k, rot);
  }

  /* st-5（イカリ）・ols-5（ハンマー・オイルレザー）：マウスパッド。幅約20.7cm×高さ約15cm（1cm＝40）、角は小さく丸い、外周に縫い目。
     刺繍は右下。ネームプレートは右の辺に挟んで縦向きに出る（下寄り・縫い目なし）2026.10.27 */
  function mousePad(c, hammer) {
    var m = 'url(#' + c.uid + '-m)';
    var x0 = 100, y0 = 100, W = 828, H = 600, r = 16, I = INSET;
    var x1 = x0 + W, y1 = y0 + H;
    var ex = x0 + W * 0.85, ey = y0 + H * 0.8;
    /* ネームプレート：2枚の革の間に挟んで外周の縫い目で留めるので、プレート自体の縫い目は描かない。一部はパッドの下に隠れる 2026.10.27 */
    var py = y0 + H * 0.72;
    var plate = c.name
      ? '<rect x="' + (x1 - 24) + '" y="' + (py - 68) + '" width="80" height="136" rx="28" fill="' + m + '"' + EDGE_SMALL + '/>'
      : '';
    return plate +
      '<rect x="' + x0 + '" y="' + y0 + '" width="' + W + '" height="' + H + '" rx="' + r + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('rect', 'pad-stitch', 'x="' + (x0 + I) + '" y="' + (y0 + I) + '" width="' + (W - I * 2) + '" height="' + (H - I * 2) + '" rx="' + Math.max(r - I, 4) + '"') +
      (hammer ? hammerEmb(c, ex, ey, 1.1) : embAt(c, ex, ey, 50));
  }
  shapes['st-5'] = function (c) { return frame(c, 'マウスパッドの見本', [{ box: [80, 80, 930, 640], core: [100, 600], body: mousePad(c, false) }]); };
  shapes['ols-5'] = function (c) { return frame(c, 'マウスパッドの見本', [{ box: [80, 80, 930, 640], core: [100, 600], body: mousePad(c, true) }]); };

  /* st-35：コースター（四角・角は丸い R）。外周に縫い目。刺繍なし。右の辺に「39」のタグ 2026.10.27 */
  shapes['st-35'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var x0 = 100, y0 = 100, W = 560, H = 500, r = 38, i = 30;
    /* 右の辺の下寄りに、白い布のタグ（赤い「39」）が出る。タグは縫い目に挟まっている 2026.10.27 */
    var tx = x0 + W, ty = y0 + H * 0.68;
    var tag = '<rect x="' + (tx - 14) + '" y="' + (ty - 46) + '" width="40" height="92" fill="#F7F1E3" stroke="#B8AE98" stroke-width="2"/>' +
      '<text x="' + (tx + 6) + '" y="' + ty + '" transform="rotate(90 ' + (tx + 6) + ' ' + ty + ')" text-anchor="middle" dominant-baseline="central" font-family="Georgia,serif" font-size="34" fill="#E0301E">39</text>';
    var body = tag +
      '<rect x="' + x0 + '" y="' + y0 + '" width="' + W + '" height="' + H + '" rx="' + r + '" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'rect', 'st35-stitch', 'x="' + (x0 + i) + '" y="' + (y0 + i) + '" width="' + (W - i * 2) + '" height="' + (H - i * 2) + '" rx="' + (r - i / 2) + '"');
    return frame(c, 'コースターの見本', [{ box: [80, 80, 620, 540], core: [100, 500], body: body }]);
  };


  /* st-1：ペンケース（1本差し・キャップ付き）。直線で横向きに描く：本体（左の先は丸い）と、右にかぶせたキャップ（先は丸い）。
     縫い目は本体の下のふちと、キャップの下のふち〜先の丸み。刺繍（イカリ）はキャップの上。刻印は描かない 2026.10.27 */
  shapes['st-1'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var y = 160, bh = 80, ch = 112;
    var b0 = 120, b1 = 1180, c0 = 1130, c1 = 1360; /* キャップは短め（全体の約2割）2026.10.27 */
    var body =
      '<path d="M' + (b0 + bh / 2) + ' ' + (y - bh / 2) + ' H' + b1 + ' V' + (y + bh / 2) + ' H' + (b0 + bh / 2) + ' A' + (bh / 2) + ' ' + (bh / 2) + ' 0 0 1 ' + (b0 + bh / 2) + ' ' + (y - bh / 2) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'st1-stitch-body', 'd="M' + (b0 + bh / 2) + ' ' + (y + bh / 2 - 15) + ' H' + (c0 - 10) + '"') +
      '<path d="M' + c0 + ' ' + (y - ch / 2) + ' H' + (c1 - ch / 2) + ' A' + (ch / 2) + ' ' + (ch / 2) + ' 0 0 1 ' + (c1 - ch / 2) + ' ' + (y + ch / 2) + ' H' + c0 + ' Z" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'st1-stitch-cap', 'd="M' + (c0 + 20) + ' ' + (y + ch / 2 - 15) + ' H' + (c1 - ch / 2) + ' A' + (ch / 2 - 15) + ' ' + (ch / 2 - 15) + ' 0 0 0 ' + (c1 - ch / 2) + ' ' + (y - ch / 2 + 15) + '"') +
      /* イカリは先（右）に頭を向ける（ペンの向きに沿って横倒し）2026.10.27 */
      '<g transform="rotate(90 1225 ' + y + ')">' + embAt(c, 1225, y, 66) + '</g>';
    return frame(c, 'ペンケースの見本', [{ box: [100, 90, 1280, 140], body: body }]);
  };

  /* 首輪（ピンバックル・穴あき）：左からバックル（受ける側）→ カシメ → 縫い目（短い）→ 穴 → ピンバックル → 遊環（金具）→ 穴 → イカリ → バックル（差し込む側）。
     ac-40 2026.10.27 */
  shapes['ac-40'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var y = 100, w = 50, hw = w / 2, x0 = 200, x1 = 1250;
    var holes = [620, 700, 780, 1040];
    /* 右の端：革を差し込む側のバックルに巻いて折り返し、表に重なる先（剣先）は丸い。剣先がバックルの付け根を隠す 2026.10.27 */
    var f0 = 1090, f1 = x1 + 28;
    var body =
      buckleFemale(x0, y, -1) + buckleMale(x1, y, 1) +
      '<rect x="' + x0 + '" y="' + (y - hw) + '" width="' + (x1 - x0) + '" height="' + w + '" rx="6" fill="' + m + '"' + EDGE + '/>' +
      rivet(x0 + 40, y, 13) +
      sStitch(c, 'path', 'ac40-stitch', 'd="M' + (x0 + 62) + ' ' + y + ' H560"') +
      holes.map(function (x) { return '<circle cx="' + x + '" cy="' + y + '" r="6" fill="#3A2A1E"/>'; }).join('') +
      /* ピンバックル：四角の枠と、真ん中から右へのびる棒 */
      '<rect x="900" y="' + (y - hw - 12) + '" width="70" height="' + (w + 24) + '" rx="8" fill="none" stroke="#2A241A" stroke-width="12"/>' +
      '<rect x="900" y="' + (y - hw - 12) + '" width="70" height="' + (w + 24) + '" rx="8" fill="none" stroke="' + METAL + '" stroke-width="8"/>' +
      metal('M900 ' + y + ' H975', 5) +
      /* 剣先（丸い）の重なり */
      '<path d="M' + f0 + ' ' + (y - hw) + ' H' + (f1 - hw) + ' A' + hw + ' ' + hw + ' 0 0 1 ' + (f1 - hw) + ' ' + (y + hw) + ' H' + f0 + '" fill="' + m + '"' + EDGE + '/>' +
      /* 遊環（金具の輪）：2枚の革をまとめる */
      metal('M1120 ' + (y - hw - 8) + ' V' + (y + hw + 8), 6) +
      /* イカリ：横倒し。頭は革の続く側（左）、Vは剣先側（右）2026.10.27 */
      '<g transform="rotate(-90 1205 ' + y + ')">' + embAt(c, 1205, y, 42) + '</g>';
    return frame(c, '首輪の見本', [{ box: [60, 40, 1320, 120], body: body }]);
  };


  /* ac-36：キーホルダー（帯の両端にカシメ、間に縫い目1本）。左はナスカン（目は革の折り返しに通す）、右は丸い輪に二重リング（丸い革は描かない）2026.10.27 */
  shapes['ac-36'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var x0 = 200, x1 = 1000, y = 100, w = 70, hw = w / 2;
    var rc = x1 + 30, rr = 45;
    var body =
      clasp(x0 + 8, y, -1) + ring(rc, y, rr, 8) +
      ring(rc + 62, y - 30, 30, 6) + ring(rc + 72, y + 6, 30, 6) + ring(rc + 60, y + 40, 30, 6) +
      '<rect x="' + x0 + '" y="' + (y - hw) + '" width="' + (x1 - x0) + '" height="' + w + '" rx="10" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac36-stitch', 'd="M' + (x0 + 66) + ' ' + y + ' H' + (x1 - 66) + '"') +
      rivet(x0 + 40, y, 16) + rivet(x1 - 40, y, 16);
    return frame(c, 'キーホルダーの見本', [{ box: [40, 30, 1160, 150], body: body }]);
  };

  /* ミシン糸もツートンも無い小物（ac-42・ac-89・ac-33・olk-5-sm）。縫い目は描かない。刺繍は emb-new.js の標準色、ハンマーは固定色 2026.10.27 */

  /* ac-42：リール。上に二重リング、真ん中にリール（金具の縁＋革の円・イカリ）、下にコードの口・小さな輪・ナスカン（下向き）*/
  shapes['ac-42'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var cx = 400, cy = 300;
    var body =
      ring(cx + 30, cy - 120, 44, 7) +
      '<circle cx="' + cx + '" cy="' + cy + '" r="92" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="72" fill="' + m + '"' + EDGE_SMALL + '/>' +
      embAt(c, cx, cy, 92) +
      '<rect x="' + (cx - 16) + '" y="' + (cy + 90) + '" width="32" height="46" rx="6" fill="' + METAL + '" stroke="#2A241A" stroke-width="3"/>' +
      ring(cx, cy + 158, 18, 5) +
      '<g transform="rotate(90 ' + cx + ' ' + (cy + 190) + ')">' + clasp(cx, cy + 190, 1) + '</g>';
    return frame(c, 'リールの見本', [{ box: [280, 120, 240, 520], body: body }]);
  };

  /* ac-89：バッグハンガー。直径約4.5cm。金具の丸い台（右下が切れた C の形・ちょうつがいの丸）＋中央の革の円（イカリ）*/
  shapes['ac-89'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var cx = 400, cy = 300, R = 150, r = 100;
    var arc = 'M' + (cx + 20) + ' ' + (cy + R) + ' A' + R + ' ' + R + ' 0 1 1 ' + (cx + R * 0.94) + ' ' + (cy + R * 0.34) +
      ' L' + (cx + R * 0.72) + ' ' + (cy + R * 0.26) + ' A' + (R * 0.78) + ' ' + (R * 0.78) + ' 0 1 0 ' + (cx + 22) + ' ' + (cy + R * 0.8) + ' Z';
    var body =
      '<path d="' + arc + '" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      [[-0.05, -1], [0.62, -0.78], [0.94, 0.0]].map(function (p) { return '<circle cx="' + (cx + p[0] * R * 0.9) + '" cy="' + (cy + p[1] * R * 0.9) + '" r="12" fill="#A89870"' + EDGE_SMALL + '/>'; }).join('') +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + (r + 10) + '" fill="#B9AE90"' + EDGE_SMALL + '/>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + m + '"' + EDGE_SMALL + '/>' +
      embAt(c, cx, cy, 80);
    return frame(c, 'バッグハンガーの見本', [{ box: [230, 130, 340, 340], body: body }]);
  };

  /* ac-33：輪にした革（筒）。正面から見た形：四角（角は少し丸い）、下に筒の内側（裏の起毛）がのぞく。イカリは右下 */
  shapes['ac-33'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var x0 = 200, y0 = 120, W = 420, H = 500;
    var body =
      suede('M' + (x0 + 14) + ' ' + (y0 + H - 20) + ' Q' + (x0 + W / 2) + ' ' + (y0 + H + 40) + ' ' + (x0 + W - 14) + ' ' + (y0 + H - 20) + ' Z', m, false) +
      '<rect x="' + x0 + '" y="' + y0 + '" width="' + W + '" height="' + (H - 20) + '" rx="24" fill="' + m + '"' + EDGE + '/>' +
      embAt(c, x0 + W * 0.73, y0 + H * 0.8, 80);
    return frame(c, '革の見本', [{ box: [180, 100, 460, 560], core: [120, 510], body: body }]);
  };

  /* olk-5-sm：コーン型のキーケース（1つの製品でサイズ違い）。左＝S の表（巻いた革の先をホックで留める・ネジのカシメ・その下にハンマー）、
     右＝M の裏（ネジのカシメの下にハンマー。M は表にハンマーが無い）。大きさはほぼ同じ 2026.10.27 */
  function coneS(c) {
    var m = 'url(#' + c.uid + '-m)';
    return '<path d="M335 330 Q450 300 600 335 L610 385 L600 820 Q530 838 462 822 L335 330 Z" fill="' + m + '"' + EDGE + '/>' +
      suede('M462 822 Q530 838 600 820 L598 800 Q530 812 470 800 Z', m, false) +
      /* 巻いた革（フタ）：右上から左へ下り、スナップの左を通って、下で右へ回り込む曲線（縦のまっすぐな辺は無い）2026.11.02 */
      '<path d="M602 380 Q505 425 456 535 Q440 700 600 812 Z" fill="' + m + '"' + EDGE + '/>' +
      rivet(518, 600, 30) + /* スナップはただの丸 */
      '<circle cx="480" cy="372" r="28" fill="#6E6656"' + EDGE_SMALL + '/>' +
      hammerEmb(c, 490, 450, 0.9);
  }
  function coneM(c) {
    /* M の裏：S とほぼ同じ大きさ（実物もほとんど変わらない）2026.10.27 */
    var m = 'url(#' + c.uid + '-m)';
    return '<path d="M330 320 Q450 285 615 300 L590 840 Q525 852 462 838 Z" fill="' + m + '"' + EDGE + '/>' +
      '<circle cx="480" cy="368" r="28" fill="#6E6656"' + EDGE_SMALL + '/>' +
      '<path d="M462 368 L498 368" stroke="#2A241A" stroke-width="5"/>' +
      hammerEmb(c, 490, 450, 0.9);
  }
  shapes['olk-5-sm'] = function (c) {
    /* 選んだサイズだけ描く（c.variant：0＝S の表・1＝M の裏）2026.11.02 */
    return frame(c, 'キーケースの見本', [
      { box: [320, 280, 310, 580], core: [316, 513], body: c.variant === 1 ? coneM(c) : coneS(c) }
    ]);
  };
  shapes['olk-5-sm'].variants = ['S', 'M'];

  /* ac-22：革のキーホルダー（1つの製品で種類違い）のうち4つ。上＝靴・ミニ財布、下＝ミニバッグ・サンダル。ツートン仕様の部品（持ち手・ベルト・靴底）はキャメル固定（変更できない）。
     刺繍はあるが変更できないので固定の色で描く（財布の3本線：上から赤・白・水色）。ミシン糸は変更できるので縫い目は糸の色 2026.10.27 */
  /* ac-22 の4種は金具を描かない（輪・カシメ・金具のタブなし）。どれもほぼ同じ大きさで、上2つ・下2つに並べる 2026.10.27 */
  function ac22Shoe(c) {
    /* ブーツ：ふつうの編み上げブーツを横から（手描き版より、この形が良いと確認）。全体をふっくら（つま先は丸く大きく）。靴底も同じ革。
       前に編み上げのひも（ベージュ固定）。靴底のすぐ上に縫い目。金具なし 2026.10.27 */
    var m = 'url(#' + c.uid + '-m)';
    var LACE = '#E8D9BC';
    var laces = '';
    /* 編み上げは甲の下の方まで。×の数は3つのまま、ひと目ひと目を大きく 2026.10.27 */
    var A = [[515, 360], [542, 450], [570, 540], [610, 615]], B = [[455, 370], [480, 462], [506, 552], [540, 628]];
    for (var k = 0; k < A.length - 1; k++) {
      laces += '<path d="M' + A[k][0] + ' ' + A[k][1] + ' L' + B[k + 1][0] + ' ' + B[k + 1][1] + ' M' + B[k][0] + ' ' + B[k][1] + ' L' + A[k + 1][0] + ' ' + A[k + 1][1] + '" stroke="' + LACE + '" stroke-width="12" stroke-linecap="round"/>';
    }
    /* 結び目：輪と垂れを大きく（約2倍）2026.10.27 */
    laces += '<path d="M485 350 Q385 250 330 330 Q400 375 485 350 Q585 250 640 315 Q585 375 485 350 M485 350 L395 470 M485 350 L575 460" fill="none" stroke="' + LACE + '" stroke-width="12" stroke-linecap="round" stroke-linejoin="round"/>';
    var sole = 'M205 880 H905 Q985 880 985 845 Q985 815 950 815 H205 Q180 815 180 848 Q180 880 205 880 Z';
    return '<path d="M200 815 V360 Q200 300 265 300 H455 Q502 300 514 342 L562 540 Q600 600 740 615 Q965 640 968 790 Q968 815 930 815 Z" fill="' + m + '"' + EDGE + '/>' +
      line('M448 310 L522 600 Q548 650 612 638') +
      '<path d="' + sole + '" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac22-boot', 'd="M225 795 H950"') +
      laces;
  }
  function ac22Purse(c) {
    var m = 'url(#' + c.uid + '-m)';
    var x0 = 300, y0 = 330, W = 420, H = 260;
    function line3(y, col) { return '<path d="M490 ' + y + ' H530" stroke="' + col + '" stroke-width="10" stroke-linecap="round"/>'; }
    return '<rect x="' + x0 + '" y="' + y0 + '" width="' + W + '" height="' + H + '" rx="22" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M' + x0 + ' ' + (y0 + 20) + ' Q' + x0 + ' ' + y0 + ' ' + (x0 + 20) + ' ' + y0 + ' H' + (x0 + W - 20) + ' Q' + (x0 + W) + ' ' + y0 + ' ' + (x0 + W) + ' ' + (y0 + 20) + ' V' + (y0 + 150) + ' Q' + (x0 + W / 2) + ' ' + (y0 + 230) + ' ' + (x0 + 20) + ' ' + (y0 + 160) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac22-flap', 'd="M' + (x0 + 30) + ' ' + (y0 + 150) + ' Q' + (x0 + W / 2) + ' ' + (y0 + 210) + ' ' + (x0 + W - 15) + ' ' + (y0 + 140) + '"') +
      sStitch(c, 'path', 'ac22-sides', 'd="M' + (x0 + 18) + ' ' + (y0 + 25) + ' V' + (y0 + H - 25) + ' M' + (x0 + W - 18) + ' ' + (y0 + 25) + ' V' + (y0 + H - 25) + ' M' + (x0 + W / 2) + ' ' + (y0 + 10) + ' V' + (y0 + 115) + ' M' + (x0 + W / 2) + ' ' + (y0 + 215) + ' V' + (y0 + H - 10) + '"') +
      /* 刺繍（変更不可・固定）：3本線 赤・白・水色、横の真ん中 */
      line3(y0 + 130, '#DE0913') + line3(y0 + 150, '#FCF6E8') + line3(y0 + 170, '#38A0FF');
  }
  function ac22Bag(c) {
    /* ミニバッグ：上はまっすぐ、左右はまっすぐ下りて底は半円。持ち手はキャメル固定（変更不可） */
    var m = 'url(#' + c.uid + '-m)', a = 'url(#' + c.uid + '-k)'; /* キャメル固定（革色・ツートンに関係なく）2026.10.27 */
    var arch = 'M435 400 V330 Q435 262 517 262 Q600 262 600 330 V400';
    return '<path d="' + arch + '" fill="none" stroke="#080808" stroke-width="46"/>' +
      '<path d="' + arch + '" fill="none" stroke="' + a + '" stroke-width="38"/>' +
      '<path d="M300 370 H725 V532 A212.5 212.5 0 0 1 300 532 Z" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac22-bag', 'd="M322 392 V532 A190.5 190.5 0 0 0 703 532 V386"') +
      '<rect x="416" y="362" width="38" height="80" rx="10" fill="' + a + '"' + EDGE_SMALL + '/>' +
      '<rect x="581" y="362" width="38" height="80" rx="10" fill="' + a + '"' + EDGE_SMALL + '/>';
  }
  function ac22Sandal(c) {
    /* サボサンダル：Taka さんの手描きのとおり（横から）。薄い靴底（キャメル固定）、甲はかかと側がまっすぐ立ち上がり、上は平らで、つま先へゆるく下がる。
       ベルト（キャメル固定）は甲のかかと寄りに縦の帯。縫い目は靴底 2026.10.27 */
    var m = 'url(#' + c.uid + '-m)', a = 'url(#' + c.uid + '-k)'; /* キャメル固定（革色・ツートンに関係なく）2026.10.27 */
    return '<path d="M440 788 V650 Q440 615 480 612 H640 Q760 625 860 700 Q910 745 932 788 Z" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M528 610 H588 L578 788 H540 Z" fill="' + a + '"' + EDGE_SMALL + '/>' +
      '<path d="M218 788 H942 Q958 788 958 812 Q958 836 942 838 H218 Q202 836 202 812 Q202 788 218 788 Z" fill="' + a + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'ac22-sandal', 'd="M230 813 H930"');
  }
  shapes['ac-22'] = function (c) {
    /* 上＝ミニ財布・ミニバッグ、下＝ブーツ・サボサンダル。どれもほぼ同じ大きさに見えるよう、面ごとに倍率 k をかける（いちばん長い辺を約450にそろえる）*/
    return frame(c, 'キーホルダーの見本（ミニ財布・ミニバッグ・ブーツ・サボサンダル）', [
      { box: [290, 320, 440, 280], core: [330, 260], body: ac22Purse(c), row: 0, k: 450 / 440 },
      { box: [290, 250, 445, 505], body: ac22Bag(c), row: 0, k: 450 / 505 },
      { box: [170, 250, 825, 640], body: ac22Shoe(c), row: 1, k: 450 / 825 * 1.15 },
      { box: [190, 590, 780, 265], body: ac22Sandal(c), row: 1, k: 450 / 600 }
    ]);
  };


  /* ac-13：キーケース（三つ折りではなく二つ折り）。正面・裏面・内部の3面（上の段＝正面・裏面、下の段＝内部）。
     ツートン（サブ革）はベルトと内部の鍵の台座。補強（縦の短い糸）は上の辺に2か所（正面と内部に見える）。
     裏面のベルトに縦三本の刺繍（emb-new.js の標準色）。小銭入れのファスナーは裏の左の辺と、内部の右の辺 2026.10.27 */
  shapes['ac-13'] = function (c) {
    /* 写真の角度より整合性を優先：正面と裏面は同じ大きさ、ベルトは同じ高さ・同じ太さ（BY〜BY+BH）2026.10.27
       ベルトの向き：裏面に縫い付けたベルトが、口の側（裏の左・表の右）を回って表へ来て、先（丸い）が左を向いてホックで留まる。
       表には左の背から短い受けの帯（縫い目つき）があり、その上にベルトの先が重なる。
       ファスナーの引き手の丸い革もツートン対象（ふだんキャメル） */
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', k = 'url(#' + c.uid + '-k)';
    var I = INSET, L = 300, R = 790, T = 160, B = 885, BY = 465, BH = 90, BM = BY + BH / 2;
    function pullTab(x, y) {
      /* 引き手の丸革はツートン対象：ふだんキャメル、ツートンを選んだらサブ革 2026.10.27 */
      return ring(x, y, 12, 4) + '<circle cx="' + x + '" cy="' + (y + 38) + '" r="26" fill="url(#' + c.uid + '-a)"' + EDGE_SMALL + '/>' + rivet(x, y + 38, 8);
    }
    var tipX = R - 170; /* ベルトの先（丸い）の位置 */
    var front =
      '<rect x="' + L + '" y="' + T + '" width="' + (R - L) + '" height="' + (B - T) + '" rx="14" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'ac13f-stitch', 'd="M' + L + ' ' + (T + I) + ' H' + (R - I) + ' V' + (B - I) + ' H' + L + '"') +
      reinLine(c, 'M450 148 V188') + reinLine(c, 'M690 148 V188') +
      pullTab(R + 14, 205) +
      /* 受けの帯（サブ）：左の背から、ホックの下まで。縫い目つき */
      '<rect x="' + (L - 10) + '" y="' + BY + '" width="' + (tipX + 60 - L + 10) + '" height="' + BH + '" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'ac13f-keep', 'd="M' + (L - 4) + ' ' + BM + ' H' + (tipX - 10) + '"') +
      /* ベルトの先（サブ）：右の口を回って来て、先は丸く左向き。ホックで留める */
      '<path d="M' + (R + 18) + ' ' + BY + ' H' + (tipX + BH / 2) + ' A' + (BH / 2) + ' ' + (BH / 2) + ' 0 0 0 ' + (tipX + BH / 2) + ' ' + (BY + BH) + ' H' + (R + 18) + ' Q' + (R + 34) + ' ' + BM + ' ' + (R + 18) + ' ' + BY + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<circle cx="' + (tipX + 60) + '" cy="' + BM + '" r="34" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    var VX = 696;
    var back =
      '<rect x="' + L + '" y="' + T + '" width="' + (R - L) + '" height="' + (B - T) + '" rx="14" fill="' + m + '"' + EDGE + '/>' +
      zip('ac13b-zip', 'M' + (L + 4) + ' 200 V845') + pullTab(L - 14, 205) +
      c.stitch('path', 'ac13b-stitch', 'd="M' + (L + I + 6) + ' ' + (T + I) + ' H' + R + ' M' + (L + I + 6) + ' ' + (B - I) + ' H' + R + ' M' + VX + ' ' + (T + I) + ' V' + (B - I) + '"') +
      /* ベルト（サブ）：右の背まで縫い付け、左の口の外へ回る（丸く折り返して見える）*/
      '<path d="M' + R + ' ' + BY + ' H' + (L - 20) + ' A' + (BH / 2) + ' ' + (BH / 2) + ' 0 0 0 ' + (L - 20) + ' ' + (BY + BH) + ' H' + R + ' Z" fill="' + s + '"' + EDGE + '/>' +
      /* ベルトの縫い目は刺繍の右から背の端まで途切れずに 2026.10.27 */
      c.stitch('path', 'ac13b-belt', 'd="M470 ' + BM + ' H' + R + '"') +
      /* 縦三本の刺繍：写真どおり、線の長さはベルトの太さより少し長く上下にはみ出す（本体まで通して縫う）。線は細め・間隔は狭め 2026.10.27 */
      (c.emb ? '<g transform="translate(398 ' + BM + ') scale(' + (BH * 1.3 / 76 * 0.62) + ' ' + (BH * 1.3 / 76) + ')">' + c.emb(-50, -50, 100) + '</g>' : '');
    /* 内部：外周をぐるりと縫い、真ん中（右寄り）に縦の縫い目1本。左の面は上から下までカードポケット（口の側の上寄りにゆるいえぐれ）。
       ポケットは縫い目の下。左上に鍵の台座（サブ）、上に補強。右の辺（口）にファスナーと引き手 */
    var IL = 120, IR = 1100, FOLD = 534;
    var inside =
      '<rect x="' + IL + '" y="' + T + '" width="' + (IR - IL) + '" height="' + (B - T) + '" rx="14" fill="' + m + '"' + EDGE + '/>' +
      /* えぐれは上下対称・高さの真ん中（写真の角度に引っぱられない）2026.10.27 */
      '<path d="M' + (IL + 14) + ' ' + T + ' H' + FOLD + ' V' + ((T + B) / 2 - 85) + ' Q' + (FOLD - 45) + ' ' + ((T + B) / 2 - 45) + ' ' + (FOLD - 45) + ' ' + ((T + B) / 2) + ' Q' + (FOLD - 45) + ' ' + ((T + B) / 2 + 45) + ' ' + FOLD + ' ' + ((T + B) / 2 + 85) + ' V' + B + ' H' + (IL + 14) + ' Q' + IL + ' ' + B + ' ' + IL + ' ' + (B - 14) + ' V' + (T + 14) + ' Q' + IL + ' ' + T + ' ' + (IL + 14) + ' ' + T + ' Z" fill="' + s + '"' + EDGE + '/>' + /* カードポケットもツートン対象 2026.10.27 */
      zip('ac13i-zip', 'M' + (IR - 4) + ' 200 V845') + pullTab(IR + 14, 205) +
      c.stitch('rect', 'ac13i-stitch', 'x="' + (IL + I) + '" y="' + (T + I) + '" width="' + (IR - IL - I * 2) + '" height="' + (B - T - I * 2) + '" rx="8"') +
      c.stitch('path', 'ac13i-mid', 'd="M737 ' + (T + I) + ' V' + (B - 60) + '"') +
      '<path d="M195 172 H430 V400 Q430 430 400 430 H225 Q195 430 195 400 Z" fill="' + s + '"' + EDGE + '/>' +
      reinLine(c, 'M235 150 V190') + reinLine(c, 'M390 150 V190') +
      /* ネーム：一回り大きく、カードポケットの横の真ん中 2026.10.27 */
      (c.name ? c.name((IL + FOLD) / 2 - 95, 745, 190, 76, s) : '');
    /* 3面は横に1列で並べる（全製品共通）2026.10.27 */
    return frame(c, 'キーケースの見本（左から正面・裏面・内部）', [
      { box: [250, 140, 610, 765], core: [160, 725], body: front },
      { box: [250, 140, 610, 765], body: back },
      { box: [100, 140, 1060, 765], body: inside }
    ]);
  };



  /* ac-14：キーケース（ac-13 の姉妹製品）。正面と内部を横に並べる。整合性を優先して左右・上下を対称に描く 2026.10.27
     正面：本体（メイン）に右からフタ（サブ）がかぶる。フタは左側の角を大きく丸め、ふちに縫い目。本体は上と下に縫い目。
     フタの真ん中に丸い革（サブ）と縦三本の刺繍（emb-new.js の標準色）。
     内部：左の面はカードポケット（縫い目の下）、真ん中の上に鍵の台座（サブ）と補強、右にホック。外周に縫い目。ネームはポケットの横の真ん中・下寄り */
  shapes['ac-14'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var I = INSET, L = 300, R = 860, T = 160, B = 1000, FX = 600, fr = 110;
    var front =
      '<rect x="' + L + '" y="' + T + '" width="' + (R - L) + '" height="' + (B - T) + '" rx="40" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'ac14f-stitch', 'd="M' + (L + 30) + ' ' + (T + I) + ' H' + FX + ' M' + (L + 30) + ' ' + (B - I) + ' H' + FX + '"') +
      /* フタはメイン（ツートン対象外）。正面のツートンは丸い当て革だけ 2026.10.27 */
      '<path d="M' + (R + 14) + ' ' + (T - 6) + ' H' + (FX + fr) + ' Q' + FX + ' ' + (T - 6) + ' ' + FX + ' ' + (T + fr) + ' V' + (B - fr) + ' Q' + FX + ' ' + (B + 6) + ' ' + (FX + fr) + ' ' + (B + 6) + ' H' + (R + 14) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'ac14f-flap', 'd="M' + (R + 8) + ' ' + (T - 6 + I) + ' H' + (FX + fr) + ' Q' + (FX + I) + ' ' + (T - 6 + I) + ' ' + (FX + I) + ' ' + (T + fr) + ' V' + (B - fr) + ' Q' + (FX + I) + ' ' + (B + 6 - I) + ' ' + (FX + fr) + ' ' + (B + 6 - I) + ' H' + (R + 8) + '"') +
      '<circle cx="' + ((FX + R) / 2 + 20) + '" cy="' + ((T + B) / 2) + '" r="62" fill="' + s + '"' + EDGE_SMALL + '/>' +
      embAt(c, (FX + R) / 2 + 20, (T + B) / 2, 70);
    /* 内部：左＝カードポケット（メイン）、真ん中＝メイン革の裏（白く重ねる）に鍵の台座、右＝フタの裏側（サブ・表と同じ幅、丸い角は右へ）とホック。
       正面のフタと同じ形・同じ幅を左右反転して使う 2026.10.27 */
    var IL = 120, PR = 470, CR = 860, FW = R + 14 - FX, IR = CR + FW, KX = (PR + CR) / 2;
    var inside =
      suede('M' + (IL + 30) + ' ' + T + ' H' + CR + ' V' + B + ' H' + (IL + 30) + ' Q' + IL + ' ' + B + ' ' + IL + ' ' + (B - 30) + ' V' + (T + 30) + ' Q' + IL + ' ' + T + ' ' + (IL + 30) + ' ' + T + ' Z', m, true) +
      /* 内部のツートンは3つ：カードポケット・鍵の台座・フタの裏側 2026.10.27 */
      '<path d="M' + (IL + 30) + ' ' + T + ' H' + PR + ' V' + B + ' H' + (IL + 30) + ' Q' + IL + ' ' + B + ' ' + IL + ' ' + (B - 30) + ' V' + (T + 30) + ' Q' + IL + ' ' + T + ' ' + (IL + 30) + ' ' + T + ' Z" fill="' + s + '"' + EDGE + '/>' +
      line('M' + (IL + 30) + ' ' + T + ' H' + CR + ' M' + (IL + 30) + ' ' + B + ' H' + CR + ' M' + IL + ' ' + (T + 30) + ' V' + (B - 30)) +
      '<path d="M' + CR + ' ' + (T - 6) + ' H' + (IR - fr) + ' Q' + IR + ' ' + (T - 6) + ' ' + IR + ' ' + (T + fr) + ' V' + (B - fr) + ' Q' + IR + ' ' + (B + 6) + ' ' + (IR - fr) + ' ' + (B + 6) + ' H' + CR + ' Z" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'ac14i-stitch', 'd="M' + CR + ' ' + (T + I) + ' H' + (IL + 30) + ' Q' + (IL + I) + ' ' + (T + I) + ' ' + (IL + I) + ' ' + (T + 30) + ' V' + (B - 30) + ' Q' + (IL + I) + ' ' + (B - I) + ' ' + (IL + 30) + ' ' + (B - I) + ' H' + CR + '"') +
      c.stitch('path', 'ac14i-flap', 'd="M' + CR + ' ' + (T - 6 + I) + ' H' + (IR - fr) + ' Q' + (IR - I) + ' ' + (T - 6 + I) + ' ' + (IR - I) + ' ' + (T + fr) + ' V' + (B - fr) + ' Q' + (IR - I) + ' ' + (B + 6 - I) + ' ' + (IR - fr) + ' ' + (B + 6 - I) + ' H' + CR + '"') +
      '<path d="M' + (KX - 130) + ' ' + (T + 12) + ' H' + (KX + 130) + ' V' + (T + 250) + ' Q' + (KX + 130) + ' ' + (T + 280) + ' ' + (KX + 100) + ' ' + (T + 280) + ' H' + (KX - 100) + ' Q' + (KX - 130) + ' ' + (T + 280) + ' ' + (KX - 130) + ' ' + (T + 250) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      reinLine(c, 'M' + (KX - 95) + ' ' + (T - 12) + ' V' + (T + 28)) + reinLine(c, 'M' + (KX + 95) + ' ' + (T - 12) + ' V' + (T + 28)) +
      rivet((CR + IR) / 2 + 20, (T + B) / 2, 26) +
      (c.name ? c.name((IL + PR) / 2 - 95, B - 170, 190, 76, s) : '');
    return frame(c, 'キーケースの見本（左＝正面・右＝内部）', [
      { box: [280, 135, 615, 890], core: [154, 852], body: front },
      { box: [100, 135, 1100, 890], body: inside } /* 内部は 120〜1134 */
    ]);
  };

  /* ac-54：L字ファスナーのキーケース。正面・内部・横（マチ）の3面を横に並べる。整合性を優先 2026.10.27
     ツートン（サブ）：引き手・内部のカードポケット・横のマチ（丸い当て革も）。内部はメイン革の裏（少し白く）。
     正面：右上の角だけ大きく丸い。縫い目は左・上・右上の丸み・右、下は右寄りだけ。上と右の辺にファスナー。左上に引き手。上の真ん中寄りにイカリ。
     ネームは内部のカードポケットの横の真ん中・下寄り */
  shapes['ac-54'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var I = INSET, L = 200, R = 780, T = 330, B = 690, CR = 110;
    var outline = 'M' + (L + 12) + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + (B - 24) + ' Q' + R + ' ' + B + ' ' + (R - 24) + ' ' + B + ' H' + (L + 12) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 12) + ' V' + (T + 12) + ' Q' + L + ' ' + T + ' ' + (L + 12) + ' ' + T + ' Z';
    var zipD = 'M' + (L + 70) + ' ' + (T - 8) + ' H' + (R - CR) + ' Q' + (R + 8) + ' ' + (T - 8) + ' ' + (R + 8) + ' ' + (T + CR) + ' V' + (B - 30);
    function pull(x, y) { return foldPull(x, y, s); } /* 共通部品 2026.11.02 */
    var front = zip('ac54-zip', zipD, tailDown(R + 8, B - 30)) +
      '<path d="' + outline + '" fill="' + m + '"' + EDGE + '/>' +
      pull(L + 70, T - 8) +
      c.stitch('path', 'ac54-stitch', 'd="M' + (L + I) + ' ' + (B - I) + ' V' + (T + I) + ' H' + (R - CR) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + CR) + ' V' + (B - 30) + ' Q' + (R - I) + ' ' + (B - I) + ' ' + (R - 34) + ' ' + (B - I) + ' H' + (R - 107) + '"') + /* 下の縫い目は右寄りの短い分だけ（前の半分）2026.11.02 */
      embAt(c, 455, 425, 56);
    var inside =
      suede(outline, m, false) +
      zip('ac54i-zip', zipD) +
      /* カードポケット（サブ）：左の端から右の端まで 2026.11.02 */
      '<clipPath id="' + c.uid + '-ac54clip"><path d="' + outline + '"/></clipPath>' +
      '<rect x="' + L + '" y="450" width="' + (R - L) + '" height="180" fill="' + s + '" clip-path="url(#' + c.uid + '-ac54clip)"/>' +
      line('M' + L + ' 450 H' + R + ' M' + L + ' 630 H' + R) + line(outline) +
      /* ブランド刻印は描かない（ネームはその下の位置のまま）2026.11.02 */
      (c.name ? c.name((L + R) / 2 - 75, 528, 150, 58, s) : '');
    var side =
      /* 横のマチ：U字。外側はメイン、内側は全部サブ。縫い目なし。カシメは上からやや下の真ん中 2026.11.02 */
      '<path d="M900 330 V575 Q900 690 1015 690 Q1130 690 1130 575 V330 Z" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M930 330 V575 Q930 660 1015 660 Q1100 660 1100 575 V330 Z" fill="' + s + '"' + EDGE + '/>' +
      rivet(1015, 400, 18);
    /* 並びは「外観 → 内部」：正面・横（マチ）・内部 2026.11.02 */
    return frame(c, 'キーケースの見本（左から正面・横・内部）', [
      { box: [180, 160, 630, 550], core: [323, 367], body: front },
      { box: [880, 160, 270, 550], body: side },
      { box: [180, 160, 630, 550], body: inside }
    ]);
  };

  /* st-33：バルカ（ラウンドファスナーの縦型・本型）。正面＝全部メイン、内部＝左右のポケット（サブ）＋中央はメイン革の裏、背（2本線の刺繍）。
     引き手（丸い革）はサブ。ブランド刻印は革に直接の型押しなので描かない。写真から 2026.10.27 */
  shapes['st-33'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var s = 'url(#' + c.uid + '-s)';
    var I = INSET;

    /* 正面：左が背（角は直角）、右の上下の角は丸い。ファスナーは上・右・下を回る（本体から少し離す）*/
    var front =
      zip('st33-zip', 'M262 278 H668 Q725 278 725 335 V855 Q725 912 668 912 H262') +
      /* 引き手：丸い革（サブ）＋中心の金具。閉じた時は左上 */
      '<circle id="st33-pull" cx="286" cy="264" r="17" fill="' + s + '"' + EDGE_SMALL + '/>' +
      '<circle cx="286" cy="264" r="7" fill="#8C7A55"' + EDGE_SMALL + '/>' +
      /* 本体（メイン革） */
      '<path id="st33-body" d="M260 285 H668 Q718 285 718 335 V855 Q718 905 668 905 H260 Z" fill="' + m + '"' + EDGE + '/>' +
      /* 縫い目：上・右・下（背の側は縫わない）。革の端から INSET */
      c.stitch('path', 'st33-stitch-front', 'd="M' + (260 + I) + ' ' + (285 + I) + ' H668 Q' + (718 - I) + ' ' + (285 + I) + ' ' + (718 - I) + ' 335 V855 Q' + (718 - I) + ' ' + (905 - I) + ' 668 ' + (905 - I) + ' H' + (260 + I) + '"');

    /* 内部：開いた状態。四隅とも丸い。左右のポケット（サブ）、中央はメイン革の裏（起毛）。ファスナーは外周（上の真ん中だけ切れ目）*/
    var L = 260, R = 1240, T = 300, B = 990, CR = 45, CX = (L + R) / 2;
    var outline = 'M' + (L + CR) + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) +
      ' V' + (B - CR) + ' Q' + R + ' ' + B + ' ' + (R - CR) + ' ' + B + ' H' + (L + CR) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - CR) +
      ' V' + (T + CR) + ' Q' + L + ' ' + T + ' ' + (L + CR) + ' ' + T + ' Z';
    var g = 7; /* ファスナーは革の線に沿わせる（重なってよい）2026.10.27 */
    var zipD = 'M' + (CX - 160) + ' ' + (T - g) + ' H' + (L + CR) + ' Q' + (L - g) + ' ' + (T - g) + ' ' + (L - g) + ' ' + (T + CR) +
      ' V' + (B - CR) + ' Q' + (L - g) + ' ' + (B + g) + ' ' + (L + CR) + ' ' + (B + g) + ' H' + (R - CR) +
      ' Q' + (R + g) + ' ' + (B + g) + ' ' + (R + g) + ' ' + (B - CR) + ' V' + (T + CR) + ' Q' + (R + g) + ' ' + (T - g) + ' ' + (R - CR) + ' ' + (T - g) + ' H' + (CX + 160);
    var ins = I;
    var stitchIn = 'M' + (L + CR) + ' ' + (T + ins) + ' H' + (R - CR) + ' Q' + (R - ins) + ' ' + (T + ins) + ' ' + (R - ins) + ' ' + (T + CR) +
      ' V' + (B - CR) + ' Q' + (R - ins) + ' ' + (B - ins) + ' ' + (R - CR) + ' ' + (B - ins) + ' H' + (L + CR) + ' Q' + (L + ins) + ' ' + (B - ins) + ' ' + (L + ins) + ' ' + (B - CR) +
      ' V' + (T + CR) + ' Q' + (L + ins) + ' ' + (T + ins) + ' ' + (L + CR) + ' ' + (T + ins) + ' Z';
    var PL = 495, PR = 1005; /* 左ポケットの右端・右ポケットの左端。左右のポケットは同じ幅（235）2026.10.27 */

    var inside =
      zip('st33c-zip', zipD) +
      /* 土台：メイン革の裏（塗りだけ。線は最後に1回）*/
      suede(outline, m, true) +
      /* 左右のポケット（サブ）：外周の形で切り抜く */
      '<clipPath id="' + c.uid + '-st33clip"><path d="' + outline + '"/></clipPath>' +
      '<g clip-path="url(#' + c.uid + '-st33clip)">' +
        '<rect id="st33c-left" x="' + L + '" y="' + T + '" width="' + (PL - L) + '" height="' + (B - T) + '" fill="' + s + '"/>' +
        '<rect id="st33c-right" x="' + PR + '" y="' + T + '" width="' + (R - PR) + '" height="' + (B - T) + '" fill="' + s + '"/>' +
      '</g>' +
      /* 黒い線：ポケットの境目と外周を1回だけ */
      line('M' + PL + ' ' + T + ' V' + B + ' M' + PR + ' ' + T + ' V' + B) +
      line(outline) +
      /* 縫い目：外周 */
      c.stitch('path', 'st33c-stitch', 'd="' + stitchIn + '"') +
      /* 上の切れ目：ファスナーの端が内側へ折り込まれている（写真）2026.10.27 */
      '<rect x="' + (CX - 172) + '" y="' + (T - 7) + '" width="24" height="44" fill="' + ZIP_TAPE + '"/>' +
      '<rect x="' + (CX + 148) + '" y="' + (T - 7) + '" width="24" height="44" fill="' + ZIP_TAPE + '"/>' +
      /* 下の真ん中：ファスナーの終わりが内側へ上がってくる（布＋歯）。引き手はその下（写真）2026.10.27 */
      '<rect x="' + (CX - 30) + '" y="' + (B - 150) + '" width="60" height="' + (150 + 7) + '" fill="' + ZIP_TAPE + '"/>' +
      '<path d="M' + CX + ' ' + (B - 150) + ' V' + (B + 7) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="9" stroke-dasharray="5 4"/>' +
      '<circle cx="' + CX + '" cy="' + (B + 14) + '" r="17" fill="' + s + '"' + EDGE_SMALL + '/>' +
      '<circle cx="' + CX + '" cy="' + (B + 14) + '" r="7" fill="#8C7A55"' + EDGE_SMALL + '/>' +
      /* ネームプレート：右ポケットの左下（写真の黄色い斜線）。革は付く場所（サブ）と同じ */
      (c.name ? c.name(PR + 22, B - 88, 86, 42, s) : '');

    /* 背：メイン革。2本線の刺繍（上から黄・水色）は下寄り。写真から */
    var spine =
      '<rect id="st33-spine" x="0" y="285" width="86" height="620" rx="10" fill="' + m + '"' + EDGE + '/>' +
      spineLines();

    /* 背の線の刺繍：実物は背の幅の1/3ほどの短い線。刺繍の選択（emb-new.js）から色と向きだけ読んで描く。
       線の刺繍の大きさは全製品共通の比率：長さ28・太さ9・間隔22。2本でも3本でも1本の大きさは同じで、本数が増えるだけ。
       ABC は少し小さめ、イカリはふつうの刺繍として描く 2026.10.27 */
    function spineLines() {
      var e = c.emb ? c.emb(0, 0, 100) : '';
      if (!e) return '';

      if (/<text/.test(e)) return embBig(c, 18, 820, 50);
      if (/<path|<circle/.test(e)) return embBig(c, 13, 815, 60);

      var rects = (e.match(/<rect[^>]*>/g) || []).map(function (r) {
        function n(k) { var m = r.match(new RegExp(' ' + k + '="([\\d.]+)"')); return m ? parseFloat(m[1]) : 0; }
        var f = r.match(/fill="(#[0-9A-Fa-f]{6})"/);
        return { w: n('width'), h: n('height'), hex: f ? f[1] : '' };
      }).filter(function (r) { return r.hex; });
      if (rects.length < 2 || rects.length > 3) return embBig(c, 13, 815, 60);

      var vertical = rects[0].h > rects[0].w;
      var n = rects.length;
      var LEN = 28, W = 9, GAP = 22, CXs = 43, CYs = 845; /* 背の下の端寄り（写真）2026.10.27 */

      return rects.map(function (r, i) {
        var off = (i - (n - 1) / 2) * GAP;
        var d = vertical
          ? 'M' + (CXs + off) + ' ' + (CYs - LEN / 2) + ' V' + (CYs + LEN / 2)
          : 'M' + (CXs - LEN / 2) + ' ' + (CYs + off) + ' H' + (CXs + LEN / 2);
        var edge = r.hex.toUpperCase() === '#FCF6E8' ? '<path d="' + d + '" fill="none" stroke="#999999" stroke-width="' + (W + 3) + '" stroke-linecap="round"/>' : '';
        return edge + '<path d="' + d + '" fill="none" stroke="' + r.hex + '" stroke-width="' + W + '" stroke-linecap="round"/>';
      }).join('');
    }

    return frame(c, 'バルカのツートン見本', [
      { box: [250, 245, 492, 680], core: [285, 620], body: front }, /* 箱の下＝革の下(905)＋20。3面とも革の下と上がそろう 2026.10.27 */
      /* 内部は正面と同じ高さに見えるよう倍率（正面620・内部690）*/
      { box: [235, 280, 1030, 990 + 20 * 690 / 620 - 280], body: inside, k: 620 / 690 },
      { box: [-4, 245, 94, 680], body: spine }
    ]);
  };

  /* g-2：L字ファスナー財布（スリム）。g-22 と同じ作り：正面＝本体（メイン）＋下の起毛の帯・引き手（サブ）、
     内部はポケットだけを取り出して描く（横長のポケット＝サブ、ネームはその上部中央）、引き手の拡大（定番のイカリ引き手）。写真から 2026.10.27 */
  shapes['g-2'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var s = 'url(#' + c.uid + '-s)';
    var I = INSET;
    var L = 100, R = 670, T = 300, BT = 640, B = 735, CR = 70; /* 左・右・上・帯の上・下・右上の角の丸み */

    var front =
      /* ファスナー：上と右（下まで）*/
      zip('g2-zip', 'M' + (L + 40) + ' ' + (T - 7) + ' H' + (R - CR) + ' Q' + (R + 7) + ' ' + (T - 7) + ' ' + (R + 7) + ' ' + (T + CR) + ' V' + (B - 30), tailDown(R + 7, B - 30)) /* 端から端までではない（g-22 と同じ考え）2026.10.27 */ +
      /* 引き手：サブ革（g-22 と同じ）*/
      zipPull(s, L + 40, T - 7, (R - L) / 12.5) + /* 引き手：ファスナーの始まりに付けて斜め上へ 2026.10.27 */
      /* 本体（メイン）と下の帯（サブの起毛）：塗りだけ、線は1回 */
      '<path id="g2-main" d="M' + L + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + BT + ' H' + L + ' Z" fill="' + m + '"/>' +
      suede('M' + L + ' ' + BT + ' H' + R + ' V' + B + ' H' + L + ' Z', s, true) +
      line('M' + L + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + B + ' H' + L + ' Z') +
      line('M' + L + ' ' + BT + ' H' + R) +
      /* 縫い目：左・上・右（下まで）、帯の上 */
      c.stitch('path', 'g2-stitch-edge', 'd="M' + (L + I) + ' ' + (B - I) + ' V' + (T + I) + ' H' + (R - CR) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + CR) + ' V' + (B - I) + '"') +
      c.stitch('path', 'g2-stitch-band', 'd="M' + (L + I) + ' ' + (BT + I) + ' H' + (R - I) + '"') +
      /* ブランド刻印の半円タブ：帯の上の左寄り。ツートン対象外なのでメイン革。文字は描かない 2026.10.27 */
      '<path id="g2-brand" d="M223 ' + BT + ' A48 48 0 0 1 319 ' + BT + ' Z" fill="' + m + '"' + EDGE_SMALL + '/>' +
      /* 補強：下の端のコの字 */
      reinBox(c, R, B, (R - L) / 12.5); /* g-2 の幅 12.5cm */

    /* 内部のポケット（取り出して描く）：横長・サブ革。下の左右の角は丸い。ネームは上部中央 */
    var PL = 150, PT = 470, PR = 630, PB = 735;
    var pocket =
      '<path id="g2-pocket" d="M' + PL + ' ' + PT + ' H' + PR + ' V' + PB + ' H' + PL + ' Z" fill="' + s + '"' + EDGE + '/>' + /* このポケットは下も直角 2026.10.27 */
      /* 縫い目は下だけ（長い革を折り曲げて、下部だけを縫う作り）2026.10.27 */
      c.stitch('path', 'g2-stitch-pocket', 'd="M' + (PL + I) + ' ' + (PB - I) + ' H' + (PR - I) + '"') +
      (c.name ? c.name((PL + PR) / 2 - 70, PT + 28, 140, 56, s) : '');

    var pull = anchorPull(c, s);

    return frame(c, 'L字ファスナー財布のツートン見本', [
      { box: [70, 228, 615, 527], core: [293, 442], body: front }, /* 箱の下＝革の下＋20（全製品そろえる）*/
      { box: [142, 462, 496, 293], body: pocket },
      { box: pull.box, body: pull.body, fixed: PULL_SCALE, pad: 16 }
    ]);
  };

  /* g-52：リネス（L字ファスナー財布・ハードレザー）。幅11.5cm×高さ9.5cm、下は折り（縫わない）。
     正面＝メイン（イカリ刺繍）、背面＝メイン（親指の切り欠きのあるカードポケット）、内部はポケットだけ取り出して描く（サブ・ネームは左下寄り）。
     ツートン（サブ）は引き手と内部のポケットだけ。写真から 2026.10.27 */
  shapes['g-52'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var s = 'url(#' + c.uid + '-s)';
    var I = INSET;
    var u = 50; /* 図の1cm */
    var L = 100, R = 675, T = 300, B = 775, CR = 75, SE = B - 58; /* SE＝縦の縫い目の終わり（下は折りなので縫わない）*/

    /* 正面・背面で共通の外形（右上が丸い）。背面はこれを左右反転して使う。黒い線はどの面も1回だけ 2026.10.27 */
    var outline = 'M' + L + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + B + ' H' + L + ' Z';
    var zipD = 'M' + (L + 40) + ' ' + (T - 7) + ' H' + (R - CR) + ' Q' + (R + 7) + ' ' + (T - 7) + ' ' + (R + 7) + ' ' + (T + CR) + ' V' + (B - 40);
    var edgeStitch = 'M' + (L + I) + ' ' + SE + ' V' + (T + I) + ' H' + (R - CR) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + CR) + ' V' + SE;

    var front =
      zip('g52-zip', zipD, tailDown(R + 7, B - 40)) +
      '<path d="' + outline + '" fill="' + m + '"' + EDGE + '/>' +
      zipPull(s, L + 40, T - 7, u, c) +
      c.stitch('path', 'g52-stitch-front', 'd="' + edgeStitch + '"') +
      /* イカリ刺繍：上寄りの真ん中（実寸 約1cm）*/
      embBig(c, L + 0.49 * (R - L) - 25, T + 0.2 * (B - T) - 25, 50);

    /* 背面：正面の左右反転。下は正面の革が折り返して回ってくるので、下の縫い目の上に革の端（黒い横線）がある。
       その上がカードポケット（サブ＝ツートン対象、上端の真ん中に親指の切り欠き）2026.10.27 */
    var PT = T + 108, CX = (L + R) / 2, WRAP = SE - I; /* WRAP＝折り返してきた革の端 */
    var pocketTop = 'M' + L + ' ' + PT + ' H' + (CX - 110) + ' Q' + CX + ' ' + (PT + 100) + ' ' + (CX + 110) + ' ' + PT + ' H' + R;
    var mirror = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">';
    var back =
      mirror + zip('g52b-zip', zipD, tailDown(R + 7, B - 40)) + '<path d="' + outline + '" fill="' + m + '"/></g>' +
      /* カードポケット：ツートン対象（サブ）。切り欠きの上端から、折り返してきた革の端まで 2026.10.27 */
      '<path id="g52-backpocket" d="' + pocketTop + ' V' + WRAP + ' H' + L + ' Z" fill="' + s + '"/>' +
      line(pocketTop) +
      line('M' + L + ' ' + WRAP + ' H' + R) +
      mirror + line(outline) + zipPull(s, L + 40, T - 7, u, c) +
        c.stitch('path', 'g52-stitch-back', 'd="' + edgeStitch + ' M' + (L + I) + ' ' + SE + ' H' + (R - I) + '"') +
      '</g>';

    /* 内部のポケット（取り出して描く）：サブ。長い革を折り曲げて下だけ縫う。
       ネームは g-2 と同じく横の真ん中。ただし上にブランド刻印があるので、その分だけ下げる 2026.10.27 */
    var QL = 150, QT = 500, QR = 625, QB = B;
    var pocket =
      '<path id="g52-pocket" d="M' + QL + ' ' + QT + ' H' + QR + ' V' + QB + ' H' + QL + ' Z" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'g52-stitch-inpocket', 'd="M' + (QL + I) + ' ' + (QB - I) + ' H' + (QR - I) + '"') +
      (c.name ? c.name((QL + QR) / 2 - 70, QT + 95, 140, 56, s) : '');

    return frame(c, 'L字ファスナー財布のツートン見本', [
      { box: [80, 228, 630, 567], core: [293, 482], body: front },
      { box: [70, 228, 630, 567], body: back },
      { box: [140, 490, 495, 305], body: pocket }
    ]);
  };

  /* g-65：リスコ（L字ファスナー長財布）。幅20cm×高さ10cm、下は折り（縫わない）。
     4面：正面（メイン）／内部1＝カード段（上の帯がサブ）／内部2＝小銭入れの面（サブ、真ん中のカードポケットはメイン、ネームはその中）／定番の引き手（サブ）。
     Taka さんのペイント図（黄＝ツートン、水色＝ネーム、赤＝縫い目）と写真から 2026.10.27 */
  shapes['g-65'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var s = 'url(#' + c.uid + '-s)';
    var I = INSET;
    var u = 40; /* 図の1cm */

    /* 正面 */
    var L = 100, R = 900, T = 300, B = 700, CR = 70, SE = B - 40;
    var front =
      zip('g65-zip', 'M' + (L + 35) + ' ' + (T - 7) + ' H' + (R - CR) + ' Q' + (R + 7) + ' ' + (T - 7) + ' ' + (R + 7) + ' ' + (T + CR) + ' V' + (B - 30), tailDown(R + 7, B - 30)) +
      '<path d="M' + L + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + B + ' H' + L + ' Z" fill="' + m + '"' + EDGE + '/>' +
      zipPull(s, L + 35, T - 7, u) +
      c.stitch('path', 'g65-stitch-front', 'd="M' + (L + I) + ' ' + SE + ' V' + (T + I) + ' H' + (R - CR) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + CR) + ' V' + SE + '"') +
      reinBox(c, R, B, u);

    /* 内部1：カード段。上の帯＝サブ、その下にカードの段（メイン）。真ん中に縦の縫い目、下に横の縫い目 */
    var L1 = 100, R1 = 850, T1 = 360, B1 = 700, BAND = T1 + 70, ROW = T1 + 130, C1 = (L1 + R1) / 2;
    var inner1 =
      '<rect x="' + L1 + '" y="' + T1 + '" width="' + (R1 - L1) + '" height="' + (B1 - T1) + '" fill="' + m + '"/>' +
      '<rect id="g65-band" x="' + L1 + '" y="' + T1 + '" width="' + (R1 - L1) + '" height="' + (BAND - T1) + '" fill="' + s + '"/>' +
      line('M' + L1 + ' ' + BAND + ' H' + R1 + ' M' + L1 + ' ' + ROW + ' H' + R1) +
      line('M' + L1 + ' ' + T1 + ' H' + R1 + ' V' + B1 + ' H' + L1 + ' Z') +
      c.stitch('path', 'g65-stitch-in1', 'd="M' + C1 + ' ' + BAND + ' V' + (B1 - I) + ' M' + (L1 + I) + ' ' + (B1 - I) + ' H' + (R1 - I) + '"');

    /* 内部2：小銭入れの面（サブ）。上にファスナー（革の小さな引き手＝サブ）。真ん中にカードポケット（メイン）、ネームはその中 */
    var L2 = 100, R2 = 770, T2 = 340, B2 = 700, MID = T2 + 294; /* 内部1より2cm（80）狭い（実物）2026.10.27 */
    var PL = 195, PR = 675, PT = T2 + 104, PB = T2 + 310;
    /* 内部のファスナーの小さな革の引き手（サブ）：小さく薄く、カシメは描かない 2026.10.27 */
    var tabPull = zipSlider(L2 + 20, T2 - 7, u) +
      '<g transform="rotate(-15 ' + (L2 + 20 + 0.45 * u) + ' ' + (T2 - 7 - 0.3 * u) + ')">' +
        '<rect x="' + (L2 + 20 + 0.3 * u) + '" y="' + (T2 - 7 - 0.3 * u - 0.45 * u) + '" width="' + (1.1 * u) + '" height="' + (0.45 * u) + '" rx="' + (0.18 * u) + '" fill="' + s + '"' + EDGE_SMALL + '/>' +
      '</g>';
    var inner2 =
      zip('g65c-zip', 'M' + (L2 + 20) + ' ' + (T2 - 7) + ' H' + (R2 - 20)) +
      '<rect id="g65-coin" x="' + L2 + '" y="' + T2 + '" width="' + (R2 - L2) + '" height="' + (B2 - T2) + '" fill="' + s + '"/>' +
      '<rect id="g65-cardpocket" x="' + PL + '" y="' + PT + '" width="' + (PR - PL) + '" height="' + (PB - PT) + '" fill="' + m + '"/>' +
      line('M' + PL + ' ' + PT + ' H' + PR + ' V' + PB + ' H' + PL + ' Z') +
      line('M' + L2 + ' ' + T2 + ' H' + R2 + ' V' + B2 + ' H' + L2 + ' Z') +
      tabPull +
      c.stitch('path', 'g65-stitch-in2', 'd="M' + (L2 + I) + ' ' + (T2 + I) + ' H' + (R2 - I) +
        ' M' + (L2 + I) + ' ' + MID + ' H' + (R2 - I) +
        ' M' + (L2 + I) + ' ' + (B2 - I) + ' H' + (R2 - I) +
        ' M' + (PL + I) + ' ' + (PT + I) + ' V' + MID + ' M' + (PR - I) + ' ' + (PT + I) + ' V' + MID + '"') +
      (c.name ? c.name((PL + PR) / 2 - 70, (PT + MID) / 2 - 10, 140, 56, m) : '');

    var pull = anchorPull(c, s);

    return frame(c, 'L字ファスナー長財布のツートン見本', [
      /* 面が多いので2段：上＝正面・引き手、下＝内部1・内部2（全体の高さが増える）2026.10.27 */
      { box: [80, 228, 860, 492], core: [293, 407], body: front },
      { box: pull.box, body: pull.body, fixed: PULL_SCALE, pad: 16 },
      { box: [90, 350, 770, 370], body: inner1, row: 1 },
      { box: [90, 300, 690, 420], body: inner2, row: 1 }
    ]);
  };

  /* ===== キーケース ac-52・ac-53（ラウンドファスナー・6連）2026.11.02 =====
     正面：左が背（角は小さく）、右の上下の角は大きく丸い。縫い目は上・右・下。ファスナーは上・右・下を回り、左上に革の引き手（サブ）。イカリは上の真ん中。
     内部：開いた2面。外周に縫い目、ファスナーは外周を回り下の真ん中で終わる（引き手は下へ垂れる）。
     左＝ポケット（サブ・上から下まで）、ネームはポケットの真ん中・下寄り。右＝キー金具の革（サブ・下の角を落とす）、その下に刻印。
     ac-53 は右の面に縦長の革（サブ）があり、その上にキー金具の革。背面に縦ファスナーの小銭入れ（引き手＝サブ）*/
  var KC = { L: 300, R: 700, T: 200, B: 800, CR: 60 };

  function kcFront(c, id, mirror) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = KC.L, R = KC.R, T = KC.T, B = KC.B, CR = KC.CR, I = INSET;
    var out = 'M' + (L + 12) + ' ' + T + ' H' + (R - CR) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + CR) + ' V' + (B - CR) + ' Q' + R + ' ' + B + ' ' + (R - CR) + ' ' + B + ' H' + (L + 12) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 12) + ' V' + (T + 12) + ' Q' + L + ' ' + T + ' ' + (L + 12) + ' ' + T + ' Z';
    var zipD = 'M' + (L + 50) + ' ' + (T - 8) + ' H' + (R - CR) + ' Q' + (R + 8) + ' ' + (T - 8) + ' ' + (R + 8) + ' ' + (T + CR) + ' V' + (B - CR) + ' Q' + (R + 8) + ' ' + (B + 8) + ' ' + (R - CR) + ' ' + (B + 8) + ' H' + (L + 60);
    var tail = ' Q' + (L + 42) + ' ' + (B + 8) + ' ' + (L + 40) + ' ' + (B - 30);
    var st = 'M' + (L + I) + ' ' + (T + I) + ' H' + (R - CR) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + CR) + ' V' + (B - CR) + ' Q' + (R - I) + ' ' + (B - I) + ' ' + (R - CR) + ' ' + (B - I) + ' H' + (L + I);
    return zip(id + '-zip', zipD, tail) +
      '<path d="' + out + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', id + '-stitch', 'd="' + st + '"') +
      foldPull(L + 50, T - 8, s) +
      embAt(c, (L + R) / 2, T + 140, 56);
  }

  /* 背面（ac-53）：正面の裏なので丸い角は左。右が背。縦ファスナーの小銭入れ（右寄り）、引き手はファスナーの上で右向き（サブ）*/
  function kcBack(c, id) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = KC.L, R = KC.R, T = KC.T, B = KC.B, CR = KC.CR, I = INSET, ZX = 605;
    var out = 'M' + (R - 12) + ' ' + T + ' H' + (L + CR) + ' Q' + L + ' ' + T + ' ' + L + ' ' + (T + CR) + ' V' + (B - CR) + ' Q' + L + ' ' + B + ' ' + (L + CR) + ' ' + B + ' H' + (R - 12) + ' Q' + R + ' ' + B + ' ' + R + ' ' + (B - 12) + ' V' + (T + 12) + ' Q' + R + ' ' + T + ' ' + (R - 12) + ' ' + T + ' Z';
    var st = 'M' + (R - I) + ' ' + (T + I) + ' H' + (L + CR) + ' Q' + (L + I) + ' ' + (T + I) + ' ' + (L + I) + ' ' + (T + CR) + ' V' + (B - CR) + ' Q' + (L + I) + ' ' + (B - I) + ' ' + (L + CR) + ' ' + (B - I) + ' H' + (R - I) + ' Z';
    return '<path d="' + out + '" fill="' + m + '"' + EDGE + '/>' +
      zip(id + '-zip', 'M' + ZX + ' ' + (T + 95) + ' V' + (B - 55)) +
      c.stitch('path', id + '-stitch', 'd="' + st + '"') +
      /* 小銭入れのまわり：上に横2本、ファスナーの左右に縦 */
      c.stitch('path', id + '-pocket', 'd="M' + (L + 60) + ' ' + (T + 55) + ' H' + (ZX - 25) + ' M' + (L + 60) + ' ' + (T + 90) + ' H' + (ZX - 25) + ' V' + (B - 40) + ' H' + (ZX + 25) + ' M' + (ZX + 25) + ' ' + (T + I) + ' V' + (B - I) + '"') +
      /* 小銭入れの引き手（サブ）：ファスナーの上から右へ。折った革にカシメ */
      '<rect x="' + (ZX - 10) + '" y="' + (T + 68) + '" width="20" height="24" rx="4" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
      '<rect x="' + (ZX + 8) + '" y="' + (T + 58) + '" width="100" height="44" rx="20" fill="' + s + '"' + EDGE + '/>' +
      rivet(ZX + 70, T + 80, 9);
  }

  function kcInside(c, id, panel) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var IL = 100, IR = 900, T = KC.T, B = KC.B, CR = KC.CR, I = INSET, CX = (IL + IR) / 2;
    var out = 'M' + (IL + CR) + ' ' + T + ' H' + (IR - CR) + ' Q' + IR + ' ' + T + ' ' + IR + ' ' + (T + CR) + ' V' + (B - CR) + ' Q' + IR + ' ' + B + ' ' + (IR - CR) + ' ' + B + ' H' + (IL + CR) + ' Q' + IL + ' ' + B + ' ' + IL + ' ' + (B - CR) + ' V' + (T + CR) + ' Q' + IL + ' ' + T + ' ' + (IL + CR) + ' ' + T + ' Z';
    var g = 8;
    var zipL = 'M' + (CX - 40) + ' ' + (T - g) + ' H' + (IL + CR) + ' Q' + (IL - g) + ' ' + (T - g) + ' ' + (IL - g) + ' ' + (T + CR) + ' V' + (B - CR) + ' Q' + (IL - g) + ' ' + (B + g) + ' ' + (IL + CR) + ' ' + (B + g) + ' H' + (CX - 30);
    var zipR = 'M' + (CX + 30) + ' ' + (B + g) + ' H' + (IR - CR) + ' Q' + (IR + g) + ' ' + (B + g) + ' ' + (IR + g) + ' ' + (B - CR) + ' V' + (T + CR) + ' Q' + (IR + g) + ' ' + (T - g) + ' ' + (IR - CR) + ' ' + (T - g) + ' H' + (CX + 40);
    var PW = 230;                      /* 左のポケットの幅 */
    var TC = panel ? 750 : 700;        /* キー金具の革は、下にある革の横の真ん中（ac-53＝縦長の革、ac-52＝右の面）2026.11.02 */
    var TL = TC - 95, TR = TC + 95, TB = 650;
    var clip = c.uid + '-' + id + 'clip';
    return zip(id + '-zl', zipL) + zip(id + '-zr', zipR) +
      suede(out, m, true) +
      '<clipPath id="' + clip + '"><path d="' + out + '"/></clipPath>' +
      '<g clip-path="url(#' + clip + ')">' +
        '<rect x="' + IL + '" y="' + T + '" width="' + PW + '" height="' + (B - T) + '" fill="' + s + '"/>' +
        (panel ? '<rect x="600" y="' + T + '" width="' + (IR - 600) + '" height="' + (B - T) + '" fill="' + s + '"/>' : '') +
      '</g>' +
      line('M' + (IL + PW) + ' ' + T + ' V' + B + (panel ? ' M600 ' + T + ' V' + B : '')) + line(out) +
      c.stitch('rect', id + '-stitch', 'x="' + (IL + I) + '" y="' + (T + I) + '" width="' + (IR - IL - I * 2) + '" height="' + (B - T - I * 2) + '" rx="' + (CR - I) + '"') +
      (panel ? c.stitch('path', id + '-panel', 'd="M' + (600 + I) + ' ' + (T + I) + ' V' + (B - I) + '"') : '') +
      /* キー金具の革（サブ）：上から下りて、下の角を落とす。下に刻印 */
      '<path d="M' + TL + ' ' + (T - 6) + ' H' + TR + ' V' + (TB - 30) + ' L' + (TR - 30) + ' ' + TB + ' H' + (TL + 30) + ' L' + TL + ' ' + (TB - 30) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      /* 下の真ん中：ファスナーの終わりが内側へ上がる（布＋歯）。引き手（サブ）は下へ垂れる */
      '<rect x="' + (CX - 30) + '" y="' + (B - 110) + '" width="60" height="' + (110 + g) + '" fill="' + ZIP_TAPE + '"/>' +
      '<path d="M' + CX + ' ' + (B - 110) + ' V' + (B + g) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="9" stroke-dasharray="5 4"/>' +
      foldPull(CX, B + g + 4, s, true) +
      (c.name ? c.name(IL + PW / 2 - 75, B - 190, 150, 58, s) : '');
  }

  shapes['ac-52'] = function (c) {
    return frame(c, 'キーケースの見本（左から正面・内部）', [
      { box: [280, 20, 450, 960], body: kcFront(c, 'ac52f'), core: [192, 616] },
      { box: [80, 20, 840, 960], body: kcInside(c, 'ac52i', false) }
    ]);
  };

  shapes['ac-53'] = function (c) {
    return frame(c, 'キーケースの見本（左から正面・背面・内部）', [
      { box: [280, 20, 450, 960], body: kcFront(c, 'ac53f'), core: [192, 616] },
      { box: [280, 20, 450, 960], body: kcBack(c, 'ac53b') },
      { box: [80, 20, 840, 960], body: kcInside(c, 'ac53i', true) }
    ]);
  };

  /* ===== キーケース olk-11（スマートキー＋5連）・olk-13（小銭入れ付き）：Martillo のオイルレザー 2026.11.02 =====
     正面：角は小さく丸い。左が背。縫い目は上・右・下。右から留め具の革（メイン）が回ってきてスナップで留まる。
     背面：右が背。左の端に留め具の革の付け根。刺繍はハンマー（固定色）。olk-11 は上の真ん中にカシメ、olk-13 は縦ファスナーの小銭入れ（金具の引き手）。
     内部：部品は全部サブ。左上にキー金具の革（下が丸い）、左にポケット（右の辺の上寄りにえぐれ）、左下に Martillo の刻印。
     右の端から留め具の革の裏（メインの裏）とスナップ。olk-11 は右の面の上にスマートキーの輪、olk-13 は右の面の背の側に縦の縫い目。
     留め具の革は、正面・背面・内部で同じ高さ・同じ太さ */
  var OK = { L: 300, R: 720, T: 200, B: 840, r: 24, BY: 420, BH: 200 };

  function okRect(L, R, T, B, r) {
    return 'M' + (L + r) + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + r) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - r) + ' V' + (T + r) + ' Q' + L + ' ' + T + ' ' + (L + r) + ' ' + T + ' Z';
  }

  function okFront(c, id) {
    var m = 'url(#' + c.uid + '-m)';
    var L = OK.L, R = OK.R, T = OK.T, B = OK.B, I = INSET, BY = OK.BY, BH = OK.BH, BL = 545;
    return '<path d="' + okRect(L, R, T, B, OK.r) + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', id + '-stitch', 'd="M' + (L + I) + ' ' + (T + I) + ' H' + (R - I) + ' V' + (B - I) + ' H' + (L + I) + '"') +
      /* 留め具の革（メイン）：右の口を回って来て、左の端は半円（長方形にしない）。スナップはただの丸 2026.11.02 */
      '<path d="M' + (R + 50) + ' ' + BY + ' H' + (BL + BH / 2) + ' A' + (BH / 2) + ' ' + (BH / 2) + ' 0 0 0 ' + (BL + BH / 2) + ' ' + (BY + BH) + ' H' + (R + 50) + ' Q' + (R + 72) + ' ' + (BY + BH / 2) + ' ' + (R + 50) + ' ' + BY + ' Z" fill="' + m + '"' + EDGE + '/>' +
      '<circle cx="' + (BL + BH / 2) + '" cy="' + (BY + BH / 2) + '" r="36" fill="' + METAL + '"' + EDGE_SMALL + '/>';
  }

  function okBack(c, id, coin) {
    var m = 'url(#' + c.uid + '-m)';
    var L = OK.L, R = OK.R, T = OK.T, B = OK.B, I = INSET, BY = OK.BY, BH = OK.BH, ZX = 630;
    var body = '<path d="M' + (L + 6) + ' ' + BY + ' H' + (L - 30) + ' Q' + (L - 44) + ' ' + (BY + BH / 2) + ' ' + (L - 30) + ' ' + (BY + BH) + ' H' + (L + 6) + ' Z" fill="' + m + '"' + EDGE + '/>' + /* 留め具の革の付け根（左の口の外）*/
      '<path d="' + okRect(L, R, T, B, OK.r) + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', id + '-stitch', 'd="M' + (R - I) + ' ' + (T + I) + ' H' + (L + I) + ' V' + (B - I) + ' H' + (R - I) + '"');
    if (coin) {
      body += zip(id + '-zip', 'M' + ZX + ' ' + (T + 80) + ' V' + (B - 45)) +
        c.stitch('path', id + '-pocket', 'd="M' + (L + 50) + ' ' + (T + 45) + ' H' + (ZX - 25) + ' M' + (L + 50) + ' ' + (T + 80) + ' H' + (ZX - 25) + ' V' + (B - 35) + ' H' + (ZX + 25) + ' V' + (T + I) + '"') +
        zipMetalPull(ZX - 27, T + 70, 60) +
        hammerEmb(c, 545, 540, 1.2, 90); /* 向きは「⊣」（頭が右で縦）2026.11.02 */
    } else {
      body += rivet((L + R) / 2, T + 45, 14) + hammerEmb(c, L + 72, B - 105, 1.2); /* もっと左下 2026.11.02 */
    }
    return body;
  }

  function okInside(c, id, rings) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var IL = 100, IR = 940, T = OK.T, B = OK.B, I = INSET, CX = (IL + IR) / 2, BY = OK.BY, BH = OK.BH;
    var out = okRect(IL, IR, T, B, OK.r);
    var PR = CX, PM = (T + B) / 2; /* ポケットの右の辺は背（折り目）。えぐれは上下の真ん中（PM）2026.11.02 */
    var pocket = 'M' + IL + ' ' + T + ' H' + PR + ' V' + (PM - 170) + ' Q' + (PR - 70) + ' ' + (PM - 90) + ' ' + (PR - 70) + ' ' + PM + ' Q' + (PR - 70) + ' ' + (PM + 90) + ' ' + PR + ' ' + (PM + 170) + ' V' + B + ' H' + IL + ' Z';
    var clip = c.uid + '-' + id + 'clip';
    var RX = CX + (IR - CX) / 2;
    /* 留め具の革の裏（メインの裏）：右の端から出る。スナップの受け */
    var BX = IR + 300 - BH / 2; /* 留め具の革は右へ長く伸び、先は正面と同じ半円。スナップは半円の中心 2026.11.02 */
    var beltIn = 'M' + (IR - 6) + ' ' + BY + ' H' + BX + ' A' + (BH / 2) + ' ' + (BH / 2) + ' 0 0 1 ' + BX + ' ' + (BY + BH) + ' H' + (IR - 6) + ' Z';
    return suede(beltIn, m, false) +
      '<circle cx="' + BX + '" cy="' + (BY + BH / 2) + '" r="30" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      /* 内部は全部サブ */
      '<path d="' + out + '" fill="' + s + '"/>' +
      '<clipPath id="' + clip + '"><path d="' + out + '"/></clipPath>' +
      line('M' + PR + ' ' + T + pocket.slice(pocket.indexOf(' V'), pocket.indexOf(' V' + B) + (' V' + B).length)) + /* ポケットの右の辺（えぐれ）2026.11.02 */
      line(out) + /* 背の縦線はポケットの辺そのもの（えぐれで湾曲）。えぐれの隣にまっすぐな線を別に引かない 2026.11.02 */
      c.stitch('rect', id + '-stitch', 'x="' + (IL + I) + '" y="' + (T + I) + '" width="' + (IR - IL - I * 2) + '" height="' + (B - T - I * 2) + '" rx="' + Math.max(OK.r - I, 4) + '"') +
      (rings ? '' : c.stitch('path', id + '-mid', 'd="M' + (CX + 90) + ' ' + (T + I) + ' V' + (B - I) + '"')) +
      /* キー金具の革（サブ）：左上。下が丸い */
      '<path d="M' + (IL + 60) + ' ' + (T - 6) + ' H' + (CX - 40) + ' V' + (T + 200) + ' Q' + (CX - 40) + ' ' + (T + 270) + ' ' + (CX - 110) + ' ' + (T + 270) + ' H' + (IL + 130) + ' Q' + (IL + 60) + ' ' + (T + 270) + ' ' + (IL + 60) + ' ' + (T + 200) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      (rings ? ring(RX - 25, T + 55, 30, 6) + ring(RX + 25, T + 55, 30, 6) + rivet(RX, T + 30, 12) : '') +
      (c.name ? c.name(rings ? RX + 10 - 75 : (CX + 90 + IR) / 2 - 75, B - 150, 150, 58, s) : '');
  }

  shapes['olk-11'] = function (c) {
    return frame(c, 'キーケースの見本（左から正面・背面・内部）', [
      { box: [250, 160, 540, 700], core: [200, 640], body: okFront(c, 'olk11f') },
      { box: [230, 160, 510, 700], body: okBack(c, 'olk11b', false) },
      { box: [80, 160, 1180, 700], body: okInside(c, 'olk11i', true) }
    ]);
  };

  shapes['olk-13'] = function (c) {
    return frame(c, 'キーケースの見本（左から正面・背面・内部）', [
      { box: [250, 160, 540, 700], core: [200, 640], body: okFront(c, 'olk13f') },
      { box: [230, 160, 510, 700], body: okBack(c, 'olk13b', true) },
      { box: [80, 160, 1180, 700], body: okInside(c, 'olk13i', false) }
    ]);
  };
  /* ===== olk-2：フタが右からかぶるキーケース（Martillo のオイルレザー）2026.11.02 =====
     形は上が広く下が細い扇形（正面も開いた面も）。
     正面：本体（メイン）に右からフタ（メイン）。フタの右の辺は扇の右の辺に沿い、左の辺は大きく曲がって辺に沿って縫い目。
       ハンマーはフタの上：横の真ん中より少し右、上から4分の1あたり、少し傾ける。上の真ん中に輪。
     内部：左＝本体の前の裏（起毛）、真ん中＝本体の後ろの裏（起毛）、右＝フタの裏（サブ・曲がった辺に縫い目）。
       キー金具の長方形の革（サブ）：開いた面全体の横の真ん中。幅は約3分の1、高さは約半分、上の端は開いた面の上の近く。上にハトメと輪。
     スナップは左の端（受け）とフタの裏（頭）。ネームなし */
  /* 扇形（4つの角を丸めた台形）：上の左右 Lt・Rt、下の左右 Lb・Rb 2026.11.02 */
  function fanPath(Lt, Rt, Lb, Rb, T, B, r) {
    function at(x0, y0, x1, y1, d) { var l = Math.hypot(x1 - x0, y1 - y0); return [x0 + (x1 - x0) * d / l, y0 + (y1 - y0) * d / l]; }
    var P = [[Lt, T], [Rt, T], [Rb, B], [Lb, B]], d = '';
    for (var i = 0; i < 4; i++) {
      var p = P[i], pv = P[(i + 3) % 4], nx = P[(i + 1) % 4];
      var a = at(p[0], p[1], pv[0], pv[1], r), b = at(p[0], p[1], nx[0], nx[1], r);
      d += (i ? ' L' : 'M') + a[0].toFixed(1) + ' ' + a[1].toFixed(1) + ' Q' + p[0] + ' ' + p[1] + ' ' + b[0].toFixed(1) + ' ' + b[1].toFixed(1);
    }
    return d + ' Z';
  }

  shapes['olk-2'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var T = 220, B = 840, I = INSET, r = 26;
    var Lt = 320, Rt = 650, Lb = 372, Rb = 598; /* 上の幅330・下の幅226（写真の比率）*/
    function rightX(y) { return Rt + (Rb - Rt) * (y - T) / (B - T); }
    var body = fanPath(Lt, Rt, Lb, Rb, T, B, r);
    /* フタ：右の辺は扇の右の辺に沿う（少し外へ重なる）。左の辺は上から左へふくらみ、下で右へ戻る */
    var flap = 'M556 ' + T + ' H' + (Rt - r + 8) + ' Q' + (Rt + 8) + ' ' + T + ' ' + (rightX(T + r) + 8) + ' ' + (T + r) +
      ' L' + (rightX(B - r) + 8) + ' ' + (B - r) + ' Q' + (Rb + 8) + ' ' + B + ' ' + (Rb - r + 8) + ' ' + B +
      ' H528 Q420 715 428 520 Q440 300 556 ' + T + ' Z';
    var front =
      ring((Lt + Rt) / 2, T - 30, 34, 7) +
      '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' +
      '<path d="' + flap + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'olk2f-stitch', 'd="M571 ' + (T + I) + ' Q456 305 445 520 Q438 707 540 ' + (B - I) + '"') +
      hammerEmb(c, 568, T + 155, 1.2, 15); /* フタの上：真ん中より少し右・上から4分の1、少し傾ける 2026.11.02 */
    /* 開いた面：左の辺は上から下へ内へ寄る。C＝本体とフタの折り目（扇の右の辺と同じ傾き）*/
    var ILt = 100, ILb = 152, Ct = 620, Cb = 574;
    var flapIn = 'M' + Ct + ' ' + T + ' H672 Q742 300 748 520 Q750 715 668 ' + B + ' H' + Cb + ' Z'; /* フタ裏は小さめ 2026.11.02 */
    var inner = 'M' + (ILt + r) + ' ' + T + ' H' + Ct + ' L' + Cb + ' ' + B + ' H' + (ILb + r) + ' Q' + ILb + ' ' + B + ' ' + (ILb - 3) + ' ' + (B - r) + ' L' + (ILt + 3) + ' ' + (T + r) + ' Q' + ILt + ' ' + T + ' ' + (ILt + r) + ' ' + T + ' Z';
    var OL = ILt, OR = 750, TC = (OL + OR) / 2, TW = Math.round((OR - OL) / 3), TH = Math.round((B - T) * 0.7); /* キー金具の革：全体の横の真ん中・幅1/3・縦に長く（高さの0.7）2026.11.02 */
    var inside =
      suede(inner, m, false) +
      '<path d="' + flapIn + '" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'olk2i-stitch', 'd="M660 ' + (T + I) + ' Q728 310 733 520 Q735 707 658 ' + (B - I) + '"') +
      ring(TC, T - 6, 34, 7) +
      '<rect x="' + (TC - TW / 2) + '" y="' + (T + 18) + '" width="' + TW + '" height="' + TH + '" rx="6" fill="' + s + '"' + EDGE + '/>' +
      '<circle cx="' + TC + '" cy="' + (T + 48) + '" r="14" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      '<circle cx="' + (ILt + 52) + '" cy="' + (T + 90) + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      '<circle cx="' + (Ct + 42) + '" cy="' + (T + 90) + '" r="24" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    return frame(c, 'キーケースの見本（左から正面・内部）', [
      { box: [300, 150, 380, 710], core: [220, 620], body: front },
      { box: [80, 150, 690, 710], body: inside }
    ]);
  };

  /* ===== ac-2：鐘の形のキーケース（S・M）。選んだサイズだけ描く。M は S より一回り大きい 2026.11.02 =====
     正面：上が細く下が広い。下の左右の角を落とす。縫い目は左右の辺に沿って縦。補強は左右の縫い目の上の端（横）。イカリは下の真ん中。上の真ん中にベルトの先（サブ）。
     背面：ベルト（サブ）が上から下りて、先でスナップ。受けの革（サブ）は S＝四角（左右と下に縫い目）＋丸い革、M＝上が丸いアーチ（アーチに沿って縫い目）。刻印は描かない */
  function ac2View(c, M, back) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var k = M ? 1 : 0.9, cx = 500, B = 820, I = INSET;
    var WB = 460 * k, WT = (M ? 0.85 : 0.74) * WB, H = 540 * k, T = B - H, YS = T + 0.45 * H, ch = 40 * k;
    var xl = cx - WT / 2, xr = cx + WT / 2, bl = cx - WB / 2, br = cx + WB / 2, q = T + 0.15 * H;
    var out = 'M' + xl + ' ' + T + ' H' + xr + ' Q' + br + ' ' + q + ' ' + br + ' ' + YS + ' V' + (B - ch) + ' L' + (br - ch) + ' ' + B + ' H' + (bl + ch) + ' L' + bl + ' ' + (B - ch) + ' V' + YS + ' Q' + bl + ' ' + q + ' ' + xl + ' ' + T + ' Z';
    var st = 'M' + (xl + I + 6) + ' ' + (T + I) + ' Q' + (bl + I) + ' ' + q + ' ' + (bl + I) + ' ' + YS + ' V' + (B - ch - 6) +
      ' M' + (xr - I - 6) + ' ' + (T + I) + ' Q' + (br - I) + ' ' + q + ' ' + (br - I) + ' ' + YS + ' V' + (B - ch - 6);
    var rein = reinLine(c, 'M' + (xl + 3) + ' ' + (T + 10) + ' H' + (xl + I + 14)) + reinLine(c, 'M' + (xr - 3) + ' ' + (T + 10) + ' H' + (xr - I - 14));
    var bw = 90 * k;
    if (!back) {
      return '<rect x="' + (cx - bw / 2) + '" y="' + (T - 26 * k) + '" width="' + bw + '" height="' + (36 * k) + '" rx="6" fill="' + s + '"' + EDGE + '/>' +
        '<path d="' + out + '" fill="' + m + '"' + EDGE + '/>' +
        c.stitch('path', 'ac2f-stitch', 'd="' + st + '"') + rein +
        embAt(c, cx, B - 90 * k, 56);
    }
    var sy = M ? B - 150 * k : B - 175 * k; /* スナップの高さ */
    var recv = M ?
      '<path d="M' + (cx - 80 * k) + ' ' + B + ' V' + (B - 150 * k) + ' A' + (80 * k) + ' ' + (80 * k) + ' 0 0 1 ' + (cx + 80 * k) + ' ' + (B - 150 * k) + ' V' + B + ' Z" fill="' + s + '"' + EDGE + '/>' +
        c.stitch('path', 'ac2b-recv', 'd="M' + (cx - 80 * k + I) + ' ' + (B - 4) + ' V' + (B - 150 * k) + ' A' + (80 * k - I) + ' ' + (80 * k - I) + ' 0 0 1 ' + (cx + 80 * k - I) + ' ' + (B - 150 * k) + ' V' + (B - 4) + '"') :
      '<rect x="' + (cx - 75 * k) + '" y="' + (B - 150 * k) + '" width="' + (150 * k) + '" height="' + (150 * k) + '" fill="' + s + '"' + EDGE + '/>' +
        c.stitch('path', 'ac2b-recv', 'd="M' + (cx - 75 * k + I) + ' ' + (B - 150 * k + 30) + ' V' + (B - I) + ' H' + (cx + 75 * k - I) + ' V' + (B - 150 * k + 30) + '"') +
        '<circle cx="' + cx + '" cy="' + sy + '" r="' + (68 * k) + '" fill="' + s + '"' + EDGE + '/>';
    var belt = '<path d="M' + (cx - bw / 2) + ' ' + sy + ' V' + (T - 100 * k) + ' Q' + (cx - bw / 2) + ' ' + (T - 120 * k) + ' ' + cx + ' ' + (T - 120 * k) + ' Q' + (cx + bw / 2) + ' ' + (T - 120 * k) + ' ' + (cx + bw / 2) + ' ' + (T - 100 * k) + ' V' + sy + ' A' + (bw / 2) + ' ' + (bw / 2) + ' 0 0 1 ' + (cx - bw / 2) + ' ' + sy + ' Z" fill="' + s + '"' + EDGE + '/>' +
      (M ? '<circle cx="' + cx + '" cy="' + sy + '" r="' + (55 * k) + '" fill="' + s + '"' + EDGE + '/>' : '');
    return '<path d="' + out + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'ac2b-stitch', 'd="' + st + '"') + rein +
      recv + belt +
      '<circle cx="' + cx + '" cy="' + sy + '" r="' + (32 * k) + '" fill="' + METAL + '"' + EDGE_SMALL + '/>';
  }
  shapes['ac-2'] = function (c) {
    var M = c.variant === 1;
    return frame(c, 'キーケースの見本（左から正面・背面）', [
      { box: [250, 140, 500, 700], core: [334, 486], body: ac2View(c, M, false) },
      { box: [250, 140, 500, 700], body: ac2View(c, M, true) }
    ]);
  };
  shapes['ac-2'].variants = ['S', 'M'];

  /* ===== 名刺入れ g-7・g-8・g-9 2026.11.02 ===== */
  /* 下の帯（起毛のサブ）：g-7 の底。上の辺に縫い目、左右寄りに縦の短い縫い目 */
  function g7Band(c, id, L, R, BT, B, ticks) {
    var s = 'url(#' + c.uid + '-s)', I = INSET;
    return suede('M' + L + ' ' + BT + ' H' + R + ' V' + (B - 14) + ' Q' + R + ' ' + B + ' ' + (R - 14) + ' ' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' Z', s, true) +
      line('M' + L + ' ' + BT + ' H' + R) +
      c.stitch('path', id + '-band', 'd="M' + (L + I) + ' ' + (BT + 16) + ' H' + (R - I) + (ticks ? ticks.map(function (x) { return ' M' + x + ' ' + (BT - 14) + ' V' + (BT + 16); }).join('') : '') + '"');
  }

  /* 名刺入れの横（サイド）の面 2026.11.02
     ・外側の前後の革（メイン）が細い帯で見え、その内側にU字のマチ（サブ）。下は丸い。
     ・前後の革の端の内側に沿って縫い目（名刺入れの横の面だけの例外。ほかの製品のサイドマチは縫い目なし）。
     ・フタは背面（右）の上から丸く回って、前（左）へかぶる。
     ・o.divider：真ん中のポケットの仕切り（縦長に丸くふくらむ・メイン）。g-7・g-9。マチはそのぶん厚い。
     ・o.band：底の帯（起毛のサブ）の上の位置。g-7。
     返り値 { box, body } は frame() の面にそのまま渡せる */
  /* o.rb：下の角の丸み（省略時は厚みの0.42）。o.flapDown が無ければフタなし。o.zipTop：口にファスナー（g-31 など）2026.11.02 */
  function cardSide(c, id, T, B, D, o) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var w = 14, x0 = 400, x1 = x0 + D, xc = x0 + D / 2, rb = o.rb != null ? o.rb : D * 0.42, I = 12;
    var Ro = (D + w) / 2, Ri = Ro - w, fc = x0 - w + Ro; /* フタの曲がり（外と内の半径・中心）*/
    var outer = 'M' + x0 + ' ' + T + ' V' + (B - rb) + ' Q' + x0 + ' ' + B + ' ' + (x0 + rb) + ' ' + B + ' H' + (x1 - rb) + ' Q' + x1 + ' ' + B + ' ' + x1 + ' ' + (B - rb) + ' V' + T + ' Z';
    var gL = x0 + w, gR = x1 - w, gB = B - w, gr = rb - w;
    var gusset = 'M' + gL + ' ' + T + ' V' + (gB - gr) + ' Q' + gL + ' ' + gB + ' ' + (gL + gr) + ' ' + gB + ' H' + (gR - gr) + ' Q' + gR + ' ' + gB + ' ' + gR + ' ' + (gB - gr) + ' V' + T + ' Z';
    var sL = gL + I, sR = gR - I, sB = gB - I, sr = Math.max(gr - I, 6);
    var st = 'M' + sL + ' ' + (T + 10) + ' V' + (sB - sr) + ' Q' + sL + ' ' + sB + ' ' + (sL + sr) + ' ' + sB + ' H' + (sR - sr) + ' Q' + sR + ' ' + sB + ' ' + sR + ' ' + (sB - sr) + ' V' + (T + 10);
    var flap = 'M' + x1 + ' ' + T + ' A' + Ro + ' ' + Ro + ' 0 0 0 ' + (x0 - w) + ' ' + T + ' V' + (T + o.flapDown) + ' Q' + (x0 - w) + ' ' + (T + o.flapDown + 8) + ' ' + (x0 - w / 2) + ' ' + (T + o.flapDown + 8) + ' Q' + x0 + ' ' + (T + o.flapDown + 8) + ' ' + x0 + ' ' + (T + o.flapDown) + ' V' + T + ' A' + Ri + ' ' + Ri + ' 0 0 1 ' + (x1 - w) + ' ' + T + ' Z';
    var body =
      '<path d="' + outer + '" fill="' + m + '"/>' +
      (o.band ? suede('M' + x0 + ' ' + o.band + ' V' + (B - rb) + ' Q' + x0 + ' ' + B + ' ' + (x0 + rb) + ' ' + B + ' H' + (x1 - rb) + ' Q' + x1 + ' ' + B + ' ' + x1 + ' ' + (B - rb) + ' V' + o.band + ' Z', s, true) +
        line('M' + x0 + ' ' + o.band + ' H' + gL + ' M' + gR + ' ' + o.band + ' H' + x1) : '') +
      '<path d="' + gusset + '" fill="' + s + '"/>' +
      line(gusset.replace(/ Z$/, '')) +
      (o.stitch ? c.stitch('path', id + '-side', 'd="' + st + '"') : ''); /* 縫い目は名刺入れ（g-7・g-8・g-9）だけ。ほかのサイドには描かない 2026.11.02 */
    if (o.divider) {
      var dw = D * 0.3;
      body += '<rect x="' + (xc - dw / 2) + '" y="' + (T + 6) + '" width="' + dw + '" height="' + (gB - 18 - T - 6) + '" rx="' + (dw / 2) + '" fill="' + s + '"' + EDGE + '/>'; /* 仕切りもマチと同じ色（マチは1色）2026.11.02 */
    }
    body += line(outer.replace(/ Z$/, '') + ' M' + x0 + ' ' + T + ' H' + gL + ' M' + gR + ' ' + T + ' H' + x1); /* 口の上は線でふさがない */
    if (o.zipTop) body += zip(id + '-zip', 'M' + (x0 + 4) + ' ' + (T - 4) + ' H' + (x1 - 4)) + zipSlider(xc - 27, T - 6, 60);
    if (o.flapDown != null) body += '<path d="' + flap + '" fill="' + m + '"' + EDGE + '/>';
    var top = o.flapDown != null ? T - Ro - 20 : T - 40;
    return { box: [x0 - w - 20, top, D + w + 40, B + 20 - top], body: body };
  }

  /* g-7：フタが上からかぶる名刺入れ。フタの下の辺は大きな半円、真ん中に上が丸い革（ふだんキャメル）とイカリ。
     底の帯・フタの裏・マチがツートン。下のカードの部分はメイン。背面の右下の帯の上にブランドタグ（ふだんキャメル・文字は描かない）、ネームはその上。
     フタは本体の高さの半分より短い（正面も開いた面も同じ長さ）。面は2段：上＝正面・背面、下＝開いた面・横 2026.11.02 */
  shapes['g-7'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var L = 200, R = 880, T = 250, B = 700, I = INSET, cx = (L + R) / 2, BT = B - 90;
    var FS = 70, FL = 200, FB = T + FL; /* フタ：縦の辺の長さ・全体の長さ（本体の高さ450の半分より短い）2026.11.02 */
    var rect = 'M' + (L + 14) + ' ' + T + ' H' + (R - 14) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + 14) + ' V' + (B - 14) + ' Q' + R + ' ' + B + ' ' + (R - 14) + ' ' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' V' + (T + 14) + ' Q' + L + ' ' + T + ' ' + (L + 14) + ' ' + T + ' Z';
    var sides = 'M' + (L + I) + ' ' + (T + I) + ' V' + (BT - 4) + ' M' + (R - I) + ' ' + (T + I) + ' V' + (BT - 4);
    var front =
      '<path d="' + rect + '" fill="' + m + '"/>' +
      g7Band(c, 'g7f', L, R, BT, B, [L + 150, R - 150]) + line(rect) +
      c.stitch('path', 'g7f-sides', 'd="' + sides + '"') +
      '<path d="M' + L + ' ' + T + ' H' + R + ' V' + (T + FS) + ' Q' + R + ' ' + FB + ' ' + cx + ' ' + FB + ' Q' + L + ' ' + FB + ' ' + L + ' ' + (T + FS) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g7f-flap', 'd="M' + (L + I) + ' ' + (T + 6) + ' V' + (T + FS) + ' Q' + (L + I) + ' ' + (FB - I) + ' ' + cx + ' ' + (FB - I) + ' Q' + (R - I) + ' ' + (FB - I) + ' ' + (R - I) + ' ' + (T + FS) + ' V' + (T + 6) + '"') +
      '<path d="M' + (cx - 70) + ' ' + (FB + 6) + ' V' + (FB - 75) + ' A70 70 0 0 1 ' + (cx + 70) + ' ' + (FB - 75) + ' V' + (FB + 6) + ' Z" fill="' + a + '"' + EDGE + '/>' +
      c.stitch('path', 'g7f-tab', 'd="M' + (cx - 70 + I) + ' ' + (FB + 2) + ' V' + (FB - 75) + ' A' + (70 - I) + ' ' + (70 - I) + ' 0 0 1 ' + (cx + 70 - I) + ' ' + (FB - 75) + ' V' + (FB + 2) + '"') +
      embAt(c, cx, FB - 62, 56);
    var tx = R - 160;
    var back =
      '<path d="' + rect + '" fill="' + m + '"/>' +
      g7Band(c, 'g7b', L, R, BT, B, [tx - 75, tx + 75]) + line(rect) +
      c.stitch('path', 'g7b-sides', 'd="' + sides + '"') +
      '<path d="M' + (tx - 60) + ' ' + (BT + 8) + ' V' + (BT - 20) + ' A60 40 0 0 1 ' + (tx + 60) + ' ' + (BT - 20) + ' V' + (BT + 8) + ' Z" fill="' + a + '"' + EDGE_SMALL + '/>' +
      (c.name ? c.name(L + 0.775 * (R - L) - 85, T + 0.53 * (B - T) - 35, 170, 70, m) : '');
    /* 開いた面：上＝フタの裏（サブ・正面と同じ長さ）、FY＝フタの付け根、口の帯（起毛）、カードの部分（メイン）、底の帯 2026.11.02 */
    var FY = 260, SB = FY + 90, CB = SB + 320, IB = CB + 90, FT = FY - FL;
    var flapIn = 'M' + L + ' ' + FY + ' V' + (FY - FS) + ' Q' + L + ' ' + FT + ' ' + cx + ' ' + FT + ' Q' + R + ' ' + FT + ' ' + R + ' ' + (FY - FS) + ' V' + FY + ' Z';
    var inside =
      '<path d="' + flapIn + '" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'g7i-flap', 'd="M' + (L + I) + ' ' + FY + ' V' + (FY - FS) + ' Q' + (L + I) + ' ' + (FT + I) + ' ' + cx + ' ' + (FT + I) + ' Q' + (R - I) + ' ' + (FT + I) + ' ' + (R - I) + ' ' + (FY - FS) + ' V' + FY + '"') +
      '<circle cx="' + cx + '" cy="' + (FT + 72) + '" r="44" fill="' + s + '"' + EDGE_SMALL + '/><circle cx="' + cx + '" cy="' + (FT + 72) + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      /* フタ裏の刺繍（横三本・標準は左から緑・白・赤）と39タグ */
      '<path d="M' + (R - 210) + ' ' + (FY - 34) + ' H' + (R - 180) + '" stroke="#029656" stroke-width="9" stroke-linecap="round"/>' +
      '<path d="M' + (R - 175) + ' ' + (FY - 34) + ' H' + (R - 145) + '" stroke="#999999" stroke-width="12" stroke-linecap="round"/><path d="M' + (R - 175) + ' ' + (FY - 34) + ' H' + (R - 145) + '" stroke="#FCF6E8" stroke-width="9" stroke-linecap="round"/>' +
      '<path d="M' + (R - 140) + ' ' + (FY - 34) + ' H' + (R - 110) + '" stroke="#DE0913" stroke-width="9" stroke-linecap="round"/>' +
      '<rect x="' + (R - 190) + '" y="' + (FY - 16) + '" width="60" height="42" fill="#FCF6E8" stroke="#999" stroke-width="2"/>' +
      '<text x="' + (R - 160) + '" y="' + (FY + 14) + '" text-anchor="middle" font-family="Georgia,serif" font-size="30" fill="#E0301E">39</text>' +
      suede('M' + L + ' ' + FY + ' H' + R + ' V' + SB + ' H' + L + ' Z', m, false) +
      '<rect x="' + L + '" y="' + SB + '" width="' + (R - L) + '" height="' + (CB - SB) + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g7i-card', 'd="M' + (L + I) + ' ' + (CB - 4) + ' V' + (SB + I) + ' H' + (R - I) + ' V' + (CB - 4) + '"') +
      '<circle cx="' + cx + '" cy="' + ((SB + CB) / 2) + '" r="46" fill="' + m + '"' + EDGE_SMALL + '/><circle cx="' + cx + '" cy="' + ((SB + CB) / 2) + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      g7Band(c, 'g7i', L, R, CB, IB, [L + 150, R - 150]) +
      line('M' + L + ' ' + CB + ' V' + (IB - 14) + ' Q' + L + ' ' + IB + ' ' + (L + 14) + ' ' + IB + ' H' + (R - 14) + ' Q' + R + ' ' + IB + ' ' + R + ' ' + (IB - 14) + ' V' + CB);
    var side = cardSide(c, 'g7s', T, B, 170, { divider: true, band: BT, flapDown: 150, stitch: true });
    return frame(c, '名刺入れの見本（上＝正面・背面、下＝開いた面・横）', [
      { box: [180, 10, 720, 710], body: front, core: [250, 450] },
      { box: [180, 10, 720, 710], body: back },
      { box: [180, FT - 20, 720, IB + 20 - (FT - 20)], body: inside, row: 1 },
      { box: side.box, body: side.body, row: 1 }
    ]);
  };

  /* g-8・g-9：封筒型の名刺入れ。フタは左右の辺が縦に少し下り、斜めに真ん中の先へ（五角形）。フタの先の上に横三本の刺繍（形は固定・色は変えられる）。
     正面の下の革（サブ）は左右の下から真ん中へ斜めに上がる（斜めの辺に縫い目）。マチもサブ。
     背面：上の折り返しの帯より下はポケット（正面の下の革と同じ革＝サブ）。左右に縫い目、ネームは右下（ネームの革もサブ）2026.11.02
     面は「正面・背面・横」。横は g-8＝ふくらみのないU字、g-9＝真ん中の仕切りのぶんふくらむ（g-7 と同じ）2026.11.02 */
  function envelope(c, id, sideH, pointY, embOff, divider) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 200, R = 900, T = 250, B = 650, I = INSET, cx = (L + R) / 2, AY = T + 200, PT = T + 40;
    var rect = 'M' + (L + 14) + ' ' + T + ' H' + (R - 14) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + 14) + ' V' + (B - 14) + ' Q' + R + ' ' + B + ' ' + (R - 14) + ' ' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' V' + (T + 14) + ' Q' + L + ' ' + T + ' ' + (L + 14) + ' ' + T + ' Z';
    var low = 'M' + L + ' ' + (B - 50) + ' L' + cx + ' ' + AY + ' L' + R + ' ' + (B - 50) + ' V' + (B - 14) + ' Q' + R + ' ' + B + ' ' + (R - 14) + ' ' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' Z';
    var front =
      '<path d="' + rect + '" fill="' + m + '"/>' +
      '<path d="' + low + '" fill="' + s + '"/>' +
      line('M' + L + ' ' + (B - 50) + ' L' + cx + ' ' + AY + ' L' + R + ' ' + (B - 50)) + line(rect) +
      c.stitch('path', id + 'f-diag', 'd="M' + (L + I + 4) + ' ' + (B - 32) + ' L' + cx + ' ' + (AY + 20) + ' L' + (R - I - 4) + ' ' + (B - 32) + '"') +
      c.stitch('path', id + 'f-sides', 'd="M' + (L + I) + ' ' + (T + sideH) + ' V' + (B - I) + ' M' + (R - I) + ' ' + (T + sideH) + ' V' + (B - I) + '"') +
      '<path d="M' + L + ' ' + T + ' H' + R + ' V' + (T + sideH) + ' L' + cx + ' ' + (T + pointY) + ' L' + L + ' ' + (T + sideH) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      embAt(c, cx, T + pointY - embOff, 70);
    /* 背面：上の帯（メイン）より下のポケットはサブ 2026.11.02 */
    var pocket = 'M' + L + ' ' + PT + ' H' + R + ' V' + (B - 14) + ' Q' + R + ' ' + B + ' ' + (R - 14) + ' ' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' Z';
    var back =
      '<path d="' + rect + '" fill="' + m + '"/>' +
      '<path d="' + pocket + '" fill="' + s + '"/>' +
      line('M' + L + ' ' + PT + ' H' + R) + line(rect) +
      c.stitch('path', id + 'b-sides', 'd="M' + (L + I) + ' ' + (PT + I) + ' V' + (B - I) + ' M' + (R - I) + ' ' + (PT + I) + ' V' + (B - I) + '"') +
      (c.name ? c.name(L + 0.755 * (R - L) - 100, T + 0.74 * (B - T) - 35, 200, 70, s) : '');
    var side = cardSide(c, id + 's', T, B, divider ? 150 : 120, { divider: divider, flapDown: sideH + 40, stitch: true });
    return frame(c, '名刺入れの見本（左から正面・背面・横）', [
      { box: [180, 20, 740, 650], body: front, core: [250, 400] },
      { box: [180, 20, 740, 650], body: back },
      side
    ]);
  }
  shapes['g-8'] = function (c) { return envelope(c, 'g8', 132, 320, 85, false); };
  shapes['g-9'] = function (c) { return envelope(c, 'g9', 140, 340, 120, true); };

  /* ===== 小銭入れの系統 g-14・g-30・g-4・g-5・g-31・g-56・g-60・g-61 2026.11.02 ===== */

  /* 丸いふくらみ（正面の真ん中の円）：少し明るく見せる */
  function dome(cx, cy, r, fill) {
    return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + fill + '"' + EDGE + '/>' +
      '<circle cx="' + (cx - r * 0.18) + '" cy="' + (cy - r * 0.2) + '" r="' + (r * 0.62) + '" fill="#FFFFFF" fill-opacity="0.07"/>';
  }

  /* 丸い引き手：丸い革に金具の頭（g-30・g-60）*/
  function discPull(cx, cy, r, fill) {
    return '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="' + fill + '"' + EDGE_SMALL + '/>' + rivet(cx, cy, r * 0.5);
  }

  /* 細い引き手（共通部品 slimPull）：細い革で、先は斜めに切って少し鋭角。付け根寄りにカシメ。x, y＝スライダーの位置（g-61・g-31）2026.11.02 */
  function slimPull(x, y, fill) {
    var w = 14;
    return '<rect x="' + (x - 10) + '" y="' + (y - 12) + '" width="20" height="24" rx="4" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + (x - w) + ' ' + (y - 20) + ' V' + (y - 140) + ' L' + (x + w) + ' ' + (y - 164) + ' V' + (y - 20) + ' Q' + (x + w) + ' ' + (y - 6) + ' ' + x + ' ' + (y - 6) + ' Q' + (x - w) + ' ' + (y - 6) + ' ' + (x - w) + ' ' + (y - 20) + ' Z" fill="' + fill + '"' + EDGE + '/>' +
      rivet(x, y - 38, 8);
  }

  /* 丸い小銭入れの横（マチ）：立てて描く（正面の円の高さと同じ）2026.11.02
     左右に前後の革（メイン）のふくらみ、真ん中にマチ。
     g-14＝マチの革が広く、真ん中にファスナー、その左右に縫い目。ふくらみも大きく、全体の幅が広い。
     g-30＝マチが細く、ファスナーの布（焦げ茶）が広く見える。下の端を革の当て（サブ・縫い目）が包む */
  function roundCoinSide(c, id, g30) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var cx = 500, T = 270, B = 730, cy = (T + B) / 2;
    var gw = g30 ? 76 : 124, bul = g30 ? 34 : 46, gL = cx - gw / 2, gR = cx + gw / 2, gr = gw / 2;
    var lens = function (x, dir) {
      return '<path d="M' + x + ' ' + (T + gr) + ' Q' + (x + dir * bul * 2) + ' ' + cy + ' ' + x + ' ' + (B - gr) + ' Z" fill="' + m + '"' + EDGE + '/>';
    };
    var band = 'M' + gL + ' ' + (T + gr) + ' A' + gr + ' ' + gr + ' 0 0 1 ' + gR + ' ' + (T + gr) + ' V' + (B - gr) + ' A' + gr + ' ' + gr + ' 0 0 1 ' + gL + ' ' + (B - gr) + ' Z';
    var body = lens(gL, -1) + lens(gR, 1);
    if (g30) {
      var pT = B - 110;
      body += '<path d="' + band + '" fill="' + ZIP_TAPE + '"' + EDGE + '/>' +
        '<path d="M' + cx + ' ' + (T + 24) + ' V' + (pT + 10) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="12" stroke-dasharray="6 5"/>' +
        /* ファスナーの終わりを包む革の当て（サブ）*/
        '<path d="M' + (gL - 4) + ' ' + pT + ' H' + (gR + 4) + ' V' + (B - gr) + ' A' + (gr + 4) + ' ' + (gr + 4) + ' 0 0 1 ' + (gL - 4) + ' ' + (B - gr) + ' Z" fill="' + s + '"' + EDGE + '/>' +
        sStitch(c, 'path', id + '-tab', 'd="M' + (gL + 10) + ' ' + (pT + 16) + ' H' + (gR - 10) + '"');
    } else {
      body += '<path d="' + band + '" fill="' + s + '"' + EDGE + '/>' +
        zip(id + '-zip', 'M' + cx + ' ' + (T + 30) + ' V' + (B - 30)) +
        sStitch(c, 'path', id + '-st', 'd="M' + (cx - 36) + ' ' + (T + 40) + ' V' + (B - 40) + ' M' + (cx + 36) + ' ' + (T + 40) + ' V' + (B - 40) + '"');
    }
    return { box: [gL - bul - 20, T - 20, gw + bul * 2 + 40, B - T + 40], body: body };
  }

  /* g-14・g-30：丸い小銭入れ。面は「正面・背面・横」2026.11.02
     正面＝外周の輪（マチ）とふくらんだ円。真ん中にイカリ。下の真ん中に縦の短い縫い目。
     背面＝正面の左右反転（イカリなし）。真ん中にネーム（正面にはネームを描かない）。
     g-14：マチ（サブ）が外周を1周。丸い引き手は革ひもの輪（ふだんキャメル）が左の横から出る。
     g-30：外周の上側はファスナーの布（焦げ茶・サブを塗らない）、下側がマチ（サブ）。右の終わりを革の当てが包む。丸い引き手は丸い革に金具（ふだんキャメル）で左上 */
  function roundCoin(c, id, g30) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var cx = 500, cy = 500, R = 230, r = 196;
    function ring(fid) {
      var d = '';
      if (g30) {
        var yz = cy + 20, xo = Math.sqrt(R * R - 400), xi = Math.sqrt(r * r - 400), rm = (R + r) / 2, xm = Math.sqrt(rm * rm - 400);
        d += '<circle cx="' + cx + '" cy="' + cy + '" r="' + R + '" fill="' + s + '"/>' +
          /* 上側＝ファスナーの布 */
          '<path d="M' + (cx - xo) + ' ' + yz + ' A' + R + ' ' + R + ' 0 1 1 ' + (cx + xo) + ' ' + yz + ' L' + (cx + xi) + ' ' + yz + ' A' + r + ' ' + r + ' 0 1 0 ' + (cx - xi) + ' ' + yz + ' Z" fill="' + ZIP_TAPE + '"/>' +
          '<path d="M' + (cx - xm) + ' ' + yz + ' A' + rm + ' ' + rm + ' 0 1 1 ' + (cx + xm) + ' ' + yz + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="9" stroke-dasharray="5 4"/>' +
          line('M' + (cx - R) + ' ' + cy + ' A' + R + ' ' + R + ' 0 1 1 ' + (cx + R) + ' ' + cy + ' A' + R + ' ' + R + ' 0 1 1 ' + (cx - R) + ' ' + cy) +
          '<path d="M' + (cx + R - 30) + ' ' + (cy + 10) + ' L' + (cx + R + 8) + ' ' + (cy + 10) + ' L' + (cx + R + 4) + ' ' + (cy + 62) + ' L' + (cx + R - 34) + ' ' + (cy + 60) + ' Z" fill="' + s + '"' + EDGE_SMALL + '/>' +
          dome(cx, cy, r, m) +
          discPull(cx - R + 10, cy - 70, 38, a);
      } else {
        d += '<path d="M' + (cx - R - 70) + ' ' + (cy - 8) + ' H' + (cx - R + 10) + ' V' + (cy + 30) + ' H' + (cx - R - 70) + ' A19 19 0 0 1 ' + (cx - R - 70) + ' ' + (cy - 8) + ' Z" fill="' + a + '"' + EDGE_SMALL + '/>' +
          '<circle cx="' + cx + '" cy="' + cy + '" r="' + R + '" fill="' + s + '"' + EDGE + '/>' +
          dome(cx, cy, r, m);
      }
      return d + sStitch(c, 'path', id + fid + '-seam', 'd="M' + cx + ' ' + (cy + r + 4) + ' V' + (cy + R - 6) + '"');
    }
    var front = ring('f') + embAt(c, cx, cy, 56);
    var back = '<g transform="translate(' + (2 * cx) + ' 0) scale(-1 1)">' + ring('b') + '</g>' +
      (c.name ? c.name(cx - 80, cy - 31, 160, 62, m) : '');
    var side = roundCoinSide(c, id + 's', g30);
    return frame(c, '小銭入れの見本（左から正面・背面・横）', [
      { box: [cx - R - 90, cy - R - 20, 2 * R + 110, 2 * R + 40], core: [cy - R, 2 * R], body: front },
      { box: [cx - R - 20, cy - R - 20, 2 * R + 110, 2 * R + 40], body: back },
      side
    ]);
  }
  shapes['g-14'] = function (c) { return roundCoin(c, 'g14', false); };
  shapes['g-30'] = function (c) { return roundCoin(c, 'g30', true); };

  /* g-4：半円形の小銭入れ。上に起毛の帯（メイン）、帯の下の辺に縫い目。本体は上がまっすぐで下が半円。
     サイドのパイピング（サブ）が左右と下の外周をふちどる。背面は帯の下の真ん中にブランドタグ（ふだんキャメル・文字なし）、右に39タグ 2026.11.02 */
  shapes['g-4'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var L = 230, R = 770, T = 200, BT = 335, B = 760, cx = (L + R) / 2, I = INSET, p = 18;
    function shape(l, r, t, b) {
      var k = (r - l) / 2;
      return 'M' + l + ' ' + t + ' H' + r + ' V' + (b - k * 0.82) + ' C' + r + ' ' + (b - k * 0.1) + ' ' + (cx + k * 0.55) + ' ' + b + ' ' + cx + ' ' + b + ' C' + (cx - k * 0.55) + ' ' + b + ' ' + l + ' ' + (b - k * 0.1) + ' ' + l + ' ' + (b - k * 0.82) + ' Z';
    }
    function face(back) {
      var bandD = 'M' + (L + 12) + ' ' + T + ' H' + (R - 12) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + 12) + ' V' + (BT + 6) + ' H' + L + ' V' + (T + 12) + ' Q' + L + ' ' + T + ' ' + (L + 12) + ' ' + T + ' Z';
      return '<path d="' + shape(L - 4, R + 4, BT - 10, B) + '" fill="' + s + '"' + EDGE + '/>' + /* パイピング */
        '<path d="' + shape(L + p - 4, R - p + 4, BT - 10, B - p) + '" fill="' + m + '"' + EDGE + '/>' +
        suede(bandD, m, false) +
        c.stitch('path', 'g4' + (back ? 'b' : 'f') + '-band', 'd="M' + (L + 28) + ' ' + (BT - 14) + ' H' + (R - 28) + '"') +
        (back
          ? '<path d="M' + (cx - 62) + ' ' + (BT + 4) + ' H' + (cx + 62) + ' V' + (BT + 40) + ' Q' + (cx + 62) + ' ' + (BT + 92) + ' ' + cx + ' ' + (BT + 92) + ' Q' + (cx - 62) + ' ' + (BT + 92) + ' ' + (cx - 62) + ' ' + (BT + 40) + ' Z" fill="' + a + '"' + EDGE_SMALL + '/>' +
            '<rect x="' + (cx + 95) + '" y="' + (BT + 10) + '" width="66" height="44" fill="#FCF6E8" stroke="#999" stroke-width="2"/>' +
            '<text x="' + (cx + 128) + '" y="' + (BT + 42) + '" text-anchor="middle" font-family="Georgia,serif" font-size="30" fill="#E0301E">39</text>'
          : embAt(c, cx, BT + 110, 58));
    }
    return frame(c, '小銭入れの見本（左から正面・背面）', [
      { box: [L - 30, T - 20, R - L + 60, B - T + 40], core: [T, B - T], body: face(false) },
      { box: [L - 30, T - 20, R - L + 60, B - T + 40], body: face(true) }
    ]);
  };

  /* g-5：ボックス型の小銭入れ。正面・サイド・中身。ツートン＝上が丸いタブ2個（フタの下の真ん中・中身の前の上）とマチ。補強は横線（emb-rein-h）2026.11.02 */
  shapes['g-5'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 240, R = 760, T = 300, B = 640, cx = (L + R) / 2, I = INSET, FB = 580, FR = 70;
    function tab(id, bottom, h, w) {
      var r = w / 2;
      return '<path d="M' + (cx - r) + ' ' + bottom + ' V' + (bottom - h + r) + ' A' + r + ' ' + r + ' 0 0 1 ' + (cx + r) + ' ' + (bottom - h + r) + ' V' + bottom + ' Z" fill="' + s + '"' + EDGE + '/>' +
        sStitch(c, 'path', id, 'd="M' + (cx - r + 12) + ' ' + (bottom - 4) + ' V' + (bottom - h + r) + ' A' + (r - 12) + ' ' + (r - 12) + ' 0 0 1 ' + (cx + r - 12) + ' ' + (bottom - h + r) + ' V' + (bottom - 4) + '"');
    }
    var bodyR = 'M' + L + ' ' + (T + 40) + ' H' + R + ' V' + (B - 14) + ' Q' + R + ' ' + B + ' ' + (R - 14) + ' ' + B + ' H' + (L + 14) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 14) + ' Z';
    var flap = 'M' + (L + 14) + ' ' + T + ' H' + (R - 14) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + 14) + ' V' + (FB - FR) + ' Q' + R + ' ' + FB + ' ' + (R - FR) + ' ' + FB + ' H' + (L + FR) + ' Q' + L + ' ' + FB + ' ' + L + ' ' + (FB - FR) + ' V' + (T + 14) + ' Q' + L + ' ' + T + ' ' + (L + 14) + ' ' + T + ' Z';
    var front =
      '<path d="' + bodyR + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g5f-body', 'd="M' + (L + I) + ' ' + (FB - 10) + ' V' + (B - I) + ' M' + (R - I) + ' ' + (FB - 10) + ' V' + (B - I) + '"') +
      '<path d="' + flap + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g5f-flap', 'd="M' + (L + I) + ' ' + (T + 10) + ' V' + (FB - FR) + ' Q' + (L + I) + ' ' + (FB - I) + ' ' + (L + FR) + ' ' + (FB - I) + ' H' + (R - FR) + ' Q' + (R - I) + ' ' + (FB - I) + ' ' + (R - I) + ' ' + (FB - FR) + ' V' + (T + 10) + '"') +
      reinLine(c, 'M' + (L - 6) + ' ' + (T + 70) + ' H' + (L + I + 14)) + reinLine(c, 'M' + (R + 6) + ' ' + (T + 70) + ' H' + (R - I - 14)) +
      tab('g5f-tab', FB + 6, 150, 130) +
      embAt(c, cx, FB - 58, 52);
    var side = cardSide(c, 'g5s', T + 40, B, 200, { flapDown: 190, rb: 70 });
    /* 中身：フタの裏（上の角は丸い・縫い目・スナップ）、箱の中は起毛、左右に三角のマチ（サブ）、前の壁（メイン）と上が丸いタブ（サブ・スナップの頭）*/
    var FT = 60, FY = 300, WY = 470, WB = 640;
    var flapIn = 'M' + L + ' ' + FY + ' V' + (FT + FR) + ' Q' + L + ' ' + FT + ' ' + (L + FR) + ' ' + FT + ' H' + (R - FR) + ' Q' + R + ' ' + FT + ' ' + R + ' ' + (FT + FR) + ' V' + FY + ' Z';
    var inside =
      '<path d="' + flapIn + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g5i-flap', 'd="M' + (L + I) + ' ' + FY + ' V' + (FT + FR) + ' Q' + (L + I) + ' ' + (FT + I) + ' ' + (L + FR) + ' ' + (FT + I) + ' H' + (R - FR) + ' Q' + (R - I) + ' ' + (FT + I) + ' ' + (R - I) + ' ' + (FT + FR) + ' V' + FY + '"') +
      '<circle cx="' + cx + '" cy="' + (FT + 110) + '" r="26" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      suede('M' + L + ' ' + FY + ' H' + R + ' V' + WY + ' H' + L + ' Z', m, false) +
      '<path d="M' + L + ' ' + FY + ' L' + (L + 150) + ' ' + WY + ' H' + L + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<path d="M' + R + ' ' + FY + ' L' + (R - 150) + ' ' + WY + ' H' + R + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<path d="M' + L + ' ' + WY + ' H' + R + ' V' + (WB - 14) + ' Q' + R + ' ' + WB + ' ' + (R - 14) + ' ' + WB + ' H' + (L + 14) + ' Q' + L + ' ' + WB + ' ' + L + ' ' + (WB - 14) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g5i-wall', 'd="M' + (L + I) + ' ' + (WY + 10) + ' V' + (WB - I) + ' M' + (R - I) + ' ' + (WY + 10) + ' V' + (WB - I) + '"') +
      tab('g5i-tab', WB, 150, 130) +
      '<circle cx="' + cx + '" cy="' + (WB - 70) + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    return frame(c, '小銭入れの見本（左から正面・サイド・中身）', [
      { box: [L - 30, T - 20, R - L + 60, B - T + 40], core: [T, B - T], body: front },
      side,
      { box: [L - 20, FT - 20, R - L + 40, WB - FT + 40], body: inside }
    ]);
  };

  /* g-31：L字ファスナーの小銭入れ（ハードレザー）。ほぼ正方形で、右上と左下の角は大きなR（丸い角）。ファスナーは上と右、縫い目は4辺とRに沿う。
     細い引き手（slimPull・ツートン）は左上。サイドはマチ（サブ）、下はまっすぐ・縫い目なし 2026.11.02 */
  shapes['g-31'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 300, R = 720, T = 300, B = 720, K = 70, I = INSET, cx = (L + R) / 2;
    var out = 'M' + (L + 12) + ' ' + T + ' H' + (R - K) + ' A' + K + ' ' + K + ' 0 0 1 ' + R + ' ' + (T + K) + ' V' + (B - 12) + ' Q' + R + ' ' + B + ' ' + (R - 12) + ' ' + B + ' H' + (L + K) + ' A' + K + ' ' + K + ' 0 0 1 ' + L + ' ' + (B - K) + ' V' + (T + 12) + ' Q' + L + ' ' + T + ' ' + (L + 12) + ' ' + T + ' Z';
    var k2 = K - I; /* 縫い目のR（同じ中心で回る）2026.11.02 */
    var st = 'M' + (L + I) + ' ' + (T + I) + ' H' + (R - K) + ' A' + k2 + ' ' + k2 + ' 0 0 1 ' + (R - I) + ' ' + (T + K) + ' V' + (B - I) + ' H' + (L + K) + ' A' + k2 + ' ' + k2 + ' 0 0 1 ' + (L + I) + ' ' + (B - K) + ' Z';
    var front =
      zip('g31-zip', 'M' + (L + 40) + ' ' + (T - 8) + ' H' + (R - K) + ' A' + (K + 8) + ' ' + (K + 8) + ' 0 0 1 ' + (R + 8) + ' ' + (T + K) + ' V' + (B - 30), tailDown(R + 8, B - 30)) +
      '<path d="' + out + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g31f-stitch', 'd="' + st + '"') +
      slimPull(L + 40, T - 8, s) +
      embAt(c, cx, T + 125, 58);
    var side = cardSide(c, 'g31s', T, B, 150, { rb: 24, zipTop: true });
    return frame(c, '小銭入れの見本（左から正面・サイド）', [
      { box: [L - 20, T - 170, R - L + 50, B - T + 190], core: [T, B - T], body: front },
      side
    ]);
  };

  /* g-56：カード入れの前に小銭のボックス。前面・背面。ツートン＝ボックスのフタと受け部分（前の壁）。本体はメイン 2026.11.02 */
  shapes['g-56'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 200, R = 800, T = 300, B = 680, I = INSET, cx = (L + R) / 2;
    var rect = 'M' + (L + 16) + ' ' + T + ' H' + (R - 16) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + 16) + ' V' + (B - 16) + ' Q' + R + ' ' + B + ' ' + (R - 16) + ' ' + B + ' H' + (L + 16) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 16) + ' V' + (T + 16) + ' Q' + L + ' ' + T + ' ' + (L + 16) + ' ' + T + ' Z';
    var u = 'd="M' + (L + I) + ' ' + (T + I) + ' V' + (B - I) + ' H' + (R - I) + ' V' + (T + I) + '"';
    var fL = L + 38, fR = R - 38, fT = T + 4, fB = B - 46, fr = 22;
    var front =
      '<path d="' + rect + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g56f-u', u) +
      '<rect x="' + fL + '" y="' + (fB - 60) + '" width="' + (fR - fL) + '" height="' + (B - 22 - fB + 60) + '" rx="10" fill="' + s + '"' + EDGE + '/>' + /* 受け部分（フタの下に少し見える）*/
      '<path d="M' + (fL + fr) + ' ' + fT + ' H' + (fR - fr) + ' Q' + fR + ' ' + fT + ' ' + fR + ' ' + (fT + fr) + ' V' + (fB - fr) + ' Q' + fR + ' ' + fB + ' ' + (fR - fr) + ' ' + fB + ' H' + (fL + fr) + ' Q' + fL + ' ' + fB + ' ' + fL + ' ' + (fB - fr) + ' V' + (fT + fr) + ' Q' + fL + ' ' + fT + ' ' + (fL + fr) + ' ' + fT + ' Z" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('rect', 'g56f-flap', 'x="' + (fL + I) + '" y="' + (fT + I) + '" width="' + (fR - fL - I * 2) + '" height="' + (fB - fT - I * 2) + '" rx="' + (fr - I + 4) + '"') +
      embAt(c, cx, fB - 75, 56);
    var back =
      '<path d="' + rect + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g56b-u', u) +
      '<circle cx="' + cx + '" cy="' + ((T + B) / 2) + '" r="80" fill="' + m + '"' + EDGE_SMALL + '/>' +
      '<circle cx="' + cx + '" cy="' + ((T + B) / 2) + '" r="80" fill="#000000" fill-opacity="0.12"/>'; /* 指穴：中の革が見える */
    return frame(c, '小銭入れの見本（左から前面・背面）', [
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], body: back }
    ]);
  };

  /* g-60：楕円の小銭入れ。ツートンなし。上下の真ん中に横一直線のファスナー（細長い口・両端は丸い）、口のまわりに縫い目。
     丸い引き手（丸い革に金具）は左の端でいつもキャメル（uid-k）。イカリは口の下の真ん中。背面は無地 2026.11.02 */
  shapes['g-60'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', k = 'url(#' + c.uid + '-k)';
    var cx = 500, cy = 500, rx = 320, ry = 170, zy = cy, /* ファスナーは上下の真ん中 2026.11.02 */ zl = cx - 255, zr = cx + 250, zh = 30;
    var oval = '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + ry + '" fill="' + m + '"' + EDGE + '/>' +
      '<ellipse cx="' + (cx - 60) + '" cy="' + (cy - 40) + '" rx="' + (rx * 0.6) + '" ry="' + (ry * 0.5) + '" fill="#FFFFFF" fill-opacity="0.05"/>';
    var slot = 'M' + (zl + zh / 2) + ' ' + (zy - zh / 2) + ' H' + (zr - zh / 2) + ' A' + (zh / 2) + ' ' + (zh / 2) + ' 0 0 1 ' + (zr - zh / 2) + ' ' + (zy + zh / 2) + ' H' + (zl + zh / 2) + ' A' + (zh / 2) + ' ' + (zh / 2) + ' 0 0 1 ' + (zl + zh / 2) + ' ' + (zy - zh / 2) + ' Z';
    var g = 18;
    var stD = 'M' + (zl + zh / 2) + ' ' + (zy - zh / 2 - g) + ' H' + (zr - zh / 2) + ' A' + (zh / 2 + g) + ' ' + (zh / 2 + g) + ' 0 0 1 ' + (zr - zh / 2) + ' ' + (zy + zh / 2 + g) + ' H' + (zl + zh / 2) + ' A' + (zh / 2 + g) + ' ' + (zh / 2 + g) + ' 0 0 1 ' + (zl + zh / 2) + ' ' + (zy - zh / 2 - g) + ' Z';
    var front = oval +
      '<path d="' + slot + '" fill="' + ZIP_TAPE + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + (zl + 30) + ' ' + zy + ' H' + (zr - 20) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="12" stroke-dasharray="6 5"/>' +
      sStitch(c, 'path', 'g60f-slot', 'd="' + stD + '"') +
      discPull(zl - 10, zy, 40, k) +
      embAt(c, cx, cy + 98, 58); /* 口の下の真ん中 2026.11.02 */
    return frame(c, '小銭入れの見本（左から正面・背面）', [
      { box: [cx - rx - 70, cy - ry - 20, 2 * rx + 90, 2 * ry + 40], core: [cy - ry, 2 * ry], body: front },
      { box: [cx - rx - 20, cy - ry - 20, 2 * rx + 40, 2 * ry + 40], body: oval }
    ]);
  };

  /* g-61：横長のファスナー小銭入れ。下の左右の角は大きく丸く、下の辺は真ん中が少しへこむ。上の口にファスナー、その下に横の縫い目。
     前面：ファスナー2本（上の口・カードスペース）。2本目より下がカードスペース（サブ）。引き手は2本とも左端。
     背面：下寄りに大きなポケット（サブ）。イカリはポケットの真ん中の上寄り、ネームはその下。引き手は右端。
     引き手は細い革で先が斜め（slimPull・ふだんキャメル）2026.11.02 */
  shapes['g-61'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var L = 180, R = 820, T = 340, B = 690, RC = 90, I = INSET, cx = (L + R) / 2;
    function lower(top) {
      return 'M' + L + ' ' + top + ' H' + R + ' V' + (B - RC) + ' Q' + R + ' ' + B + ' ' + (R - RC) + ' ' + B + ' Q' + cx + ' ' + (B - 22) + ' ' + (L + RC) + ' ' + B + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - RC) + ' Z';
    }
    var body = lower(T);
    function topZip(id, y) { return zip(id, 'M' + (L + 10) + ' ' + y + ' H' + (R - 10)); }
    var pL = L + 70, pR = R - 45, pT = T + 85, pB = B - 40;
    var front =
      topZip('g61f-zip', T - 6) +
      '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g61f-top', 'd="M' + (L + I) + ' ' + (T + 20) + ' H' + (R - I) + '"') +
      '<path d="M' + pL + ' ' + pT + ' H' + pR + ' V' + (pB - POCKET_R) + ' Q' + pR + ' ' + pB + ' ' + (pR - POCKET_R) + ' ' + pB + ' H' + (pL + POCKET_R) + ' Q' + pL + ' ' + pB + ' ' + pL + ' ' + (pB - POCKET_R) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'g61f-pocket', 'd="' + pocketStitch(pL, pT, pR, pB) + '"') +
      embAt(c, (pL + pR) / 2, pT + 70, 54) +
      (c.name ? c.name((pL + pR) / 2 - 80, pT + 130, 160, 60, s) : '') +
      '<g transform="rotate(-30 ' + (R - 40) + ' ' + (T - 6) + ')">' + slimPull(R - 40, T - 6, a) + '</g>'; /* 引き手は斜めに倒れる（写真どおり）*/
    var Z2 = T + 120;
    var back =
      topZip('g61b-zip', T - 6) +
      '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g61b-top', 'd="M' + (L + I) + ' ' + (T + 20) + ' H' + (R - I) + '"') +
      topZip('g61b-zip2', Z2 - 4) +
      '<path d="' + lower(Z2 + 6) + '" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'g61b-card', 'd="M' + (L + I) + ' ' + (Z2 + 26) + ' H' + (R - I) + '"') +
      '<g transform="rotate(-60 ' + (L + 30) + ' ' + (T - 6) + ')">' + slimPull(L + 30, T - 6, a) + '</g>' +
      '<g transform="rotate(-60 ' + (L + 40) + ' ' + (Z2 - 4) + ')">' + slimPull(L + 40, Z2 - 4, a) + '</g>'; /* 2本とも左端で左上へ倒れる（重ならない）*/
    /* 並びは「ファスナー2本の面（前面）→ ポケットの面（背面）」2026.11.02 */
    return frame(c, '小銭入れの見本（左から前面・背面）', [
      { box: [L - 150, T - 150, R - L + 170, B - T + 170], core: [T, B - T], body: back },
      { box: [L - 150, T - 150, R - L + 170, B - T + 170], body: front }
    ]);
  };

  /* ===== パスケース・カードケース・IDホルダー・ラゲッジタグ・マネークリップ g-15-45・g-18-19・g-38・g-69・g-26・olg-26・olg-27 2026.11.02 ===== */

  /* ハトメ：金具の輪だけ。真ん中は空白（革に穴を抜く・evenodd で使う穴の形）2026.11.02 */
  function holeD(cx, cy, r) { return ' M' + (cx - r) + ' ' + cy + ' a' + r + ' ' + r + ' 0 1 0 ' + (2 * r) + ' 0 a' + r + ' ' + r + ' 0 1 0 ' + (-2 * r) + ' 0 Z'; }
  function grommet(cx, cy) { return ring(cx, cy, 21, 10); }

  /* ポケットの口の浅いえぐれ（真ん中・切れ込みのルール：口の線そのものが曲がる）。左から右へ H で続ける部分 */
  function mouthDip(cx, y, w, d) {
    return ' H' + (cx - w) + ' C' + (cx - w * 0.6) + ' ' + y + ' ' + (cx - w * 0.55) + ' ' + (y + d) + ' ' + cx + ' ' + (y + d) +
      ' C' + (cx + w * 0.55) + ' ' + (y + d) + ' ' + (cx + w * 0.6) + ' ' + y + ' ' + (cx + w) + ' ' + y;
  }

  /* g-15-45：パスケース（横型 g-15・縦型 g-45）。選んだ形だけ描く（c.variant：0＝横型・1＝縦型）2026.11.02
     前面：右上に丸いタブ＋ハトメ（真ん中は空白）。上の帯（後ろの革）の下にポケット（メイン）、口は真ん中が浅くえぐれる。縫い目は左・下・右。イカリは右下。
     背面：左右反転（タブは左上）。全面メイン、真ん中の少し上に丸い窓（中の起毛が見える）、ネームは窓の下の真ん中。
     ツートン：前面の上の帯とハトメのまわり（タブ）＝サブ。背面のタブはメイン（背面の革と同じ）2026.11.02 */
  function passCase(c, vert) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var W = vert ? 400 : 620, H = vert ? 600 : 400, L = 200, T = 260, R = L + W, B = T + H, r = 16, I = INSET, cx = (L + R) / 2;
    var th = 100, tw = 75, gx = R + tw - th / 2, gy = T + th / 2, PT = T + (vert ? 125 : 95);
    var outer = 'M' + (L + r) + ' ' + T + ' H' + gx + ' A' + (th / 2) + ' ' + (th / 2) + ' 0 0 1 ' + gx + ' ' + (T + th) + ' H' + (R + 12) + ' Q' + R + ' ' + (T + th) + ' ' + R + ' ' + (T + th + 12) +
      ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + r) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - r) + ' V' + (T + r) + ' Q' + L + ' ' + T + ' ' + (L + r) + ' ' + T + ' Z';
    var hole = holeD(gx, gy, 14);
    var lobe = 'M' + R + ' ' + T + ' H' + gx + ' A' + (th / 2) + ' ' + (th / 2) + ' 0 0 1 ' + gx + ' ' + (T + th) + ' H' + R + ' Z';
    var st = 'd="M' + (L + I) + ' ' + (T + I) + ' V' + (B - I) + ' H' + (R - I) + ' V' + (T + th + 10) + '"';
    var dw = W * 0.16, dd = vert ? 26 : 22;
    var pocket = 'M' + L + ' ' + PT + mouthDip(cx, PT, dw, dd) + ' H' + R + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + r) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - r) + ' Z';
    var front =
      '<path d="' + outer + hole + '" fill-rule="evenodd" fill="' + s + '"/>' +
      '<path d="' + pocket + '" fill="' + m + '"/>' +
      line('M' + L + ' ' + PT + mouthDip(cx, PT, dw, dd) + ' H' + R) + line(outer + hole) +
      c.stitch('path', 'pc' + (vert ? 'v' : 'h') + 'f-u', st) +
      grommet(gx, gy) +
      embAt(c, R - 70, B - 75, 52);
    var wy = vert ? T + H * 0.4 : T + H * 0.42, wr = vert ? 95 : 82, wB = wy + wr;
    var back =
      '<g transform="translate(' + (2 * cx) + ' 0) scale(-1 1)">' +
      '<path d="' + outer + hole + '" fill-rule="evenodd" fill="' + m + '"/>' +
      line('M' + R + ' ' + T + ' V' + (T + th)) + line(outer + hole) +
      c.stitch('path', 'pc' + (vert ? 'v' : 'h') + 'b-u', st) +
      grommet(gx, gy) + '</g>' +
      suede('M' + (cx - wr) + ' ' + wy + ' a' + wr + ' ' + wr + ' 0 1 0 ' + (2 * wr) + ' 0 a' + wr + ' ' + wr + ' 0 1 0 ' + (-2 * wr) + ' 0 Z', m, false) +
      (c.name ? c.name(cx - 80, (wB + B) / 2 - 34, 160, 60, m) : '');
    return frame(c, 'パスケースの見本（左から前面・背面）', [
      { box: [L - 20, T - 20, W + tw + 40, H + 40], core: [T, 600], body: front }, /* 縮尺は縦型（g-45）の高さ600に合わせて共通 2026.11.02 */
      { box: [L - tw - 20, T - 20, W + tw + 40, H + 40], body: back }
    ]);
  }
  shapes['g-15-45'] = function (c) { return passCase(c, c.variant === 1); };
  shapes['g-15-45'].variants = ['横型', '縦型'];
  shapes['g-15'] = function (c) { return passCase(c, false); };
  shapes['g-45'] = function (c) { return passCase(c, true); };

  /* g-18-19：カードを仕分けるケース（12枚用・24枚用は同じ絵）。前面・内側 2026.11.02
     前面：縦長の二つ折り、左が背。縫い目は上・右・下。右の端からベルト（ふだんキャメル）が回って先は丸く、スナップ。刺繍なし。
     内側：左の面（カードのポケット）・右の面＝サブ、真ん中の背＝メインの裏（起毛）。リフィルは描かない。ベルトの裏が右の端から出てスナップ。ネームは左の面の左下 */
  shapes['g-18-19'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var L = 200, R = 600, T = 200, B = 760, r = 26, I = INSET, by = T + 0.43 * (B - T), bh = 92;
    var front =
      '<path d="M' + L + ' ' + (T + 6) + ' Q' + L + ' ' + T + ' ' + (L + 6) + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + 6) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 6) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g18f-u', 'd="M' + (L + 10) + ' ' + (T + I) + ' H' + (R - r) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + r) + ' V' + (B - r) + ' Q' + (R - I) + ' ' + (B - I) + ' ' + (R - r) + ' ' + (B - I) + ' H' + (L + 10) + '"') +
      '<path d="M' + (R + 34) + ' ' + by + ' H' + (R - 105) + ' A' + (bh / 2) + ' ' + (bh / 2) + ' 0 0 0 ' + (R - 105) + ' ' + (by + bh) + ' H' + (R + 34) + ' Q' + (R + 46) + ' ' + (by + bh) + ' ' + (R + 46) + ' ' + (by + bh - 12) + ' V' + (by + 12) + ' Q' + (R + 46) + ' ' + by + ' ' + (R + 34) + ' ' + by + ' Z" fill="' + a + '"' + EDGE + '/>' +
      '<circle cx="' + (R - 90) + '" cy="' + (by + bh / 2) + '" r="26" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    /* 内側：左の面 L2..X1、背 X1..X2、右の面 X2..R2 */
    var L2 = 120, X1 = 510, X2 = 590, R2 = 980;
    var outerIn = 'M' + (L2 + r) + ' ' + T + ' H' + (R2 - r) + ' Q' + R2 + ' ' + T + ' ' + R2 + ' ' + (T + r) + ' V' + (B - r) + ' Q' + R2 + ' ' + B + ' ' + (R2 - r) + ' ' + B + ' H' + (L2 + r) + ' Q' + L2 + ' ' + B + ' ' + L2 + ' ' + (B - r) + ' V' + (T + r) + ' Q' + L2 + ' ' + T + ' ' + (L2 + r) + ' ' + T + ' Z';
    var inside =
      /* ベルトの裏（起毛）：右の面の端から出る */
      suede('M' + (R2 - 20) + ' ' + by + ' H' + (R2 + 110) + ' A' + (bh / 2) + ' ' + (bh / 2) + ' 0 0 1 ' + (R2 + 110) + ' ' + (by + bh) + ' H' + (R2 - 20) + ' Z', a, false) +
      '<circle cx="' + (R2 + 100) + '" cy="' + (by + bh / 2) + '" r="26" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      '<path d="' + outerIn + '" fill="' + s + '"/>' +
      suede('M' + X1 + ' ' + T + ' H' + X2 + ' V' + B + ' H' + X1 + ' Z', m, true) +
      line('M' + X1 + ' ' + T + ' V' + B + ' M' + X2 + ' ' + T + ' V' + B) + line(outerIn) +
      c.stitch('path', 'g18i-l', 'd="M' + (X1 - 10) + ' ' + (T + I) + ' H' + (L2 + r) + ' Q' + (L2 + I) + ' ' + (T + I) + ' ' + (L2 + I) + ' ' + (T + r) + ' V' + (B - r) + ' Q' + (L2 + I) + ' ' + (B - I) + ' ' + (L2 + r) + ' ' + (B - I) + ' H' + (X1 - 10) + '"') +
      c.stitch('path', 'g18i-r', 'd="M' + (X2 + 10) + ' ' + (T + I) + ' H' + (R2 - r) + ' Q' + (R2 - I) + ' ' + (T + I) + ' ' + (R2 - I) + ' ' + (T + r) + ' V' + (B - r) + ' Q' + (R2 - I) + ' ' + (B - I) + ' ' + (R2 - r) + ' ' + (B - I) + ' H' + (X2 + 10) + '"') +
      (c.name ? c.name(L2 + 45, B - 150, 170, 64, s) : '');
    return frame(c, 'カードケースの見本（左から前面・内側）', [
      { box: [L - 20, T - 20, R - L + 90, B - T + 40], core: [T, B - T], body: front },
      { box: [L2 - 20, T - 20, R2 + 160 - L2, B - T + 40], body: inside }
    ]);
  };

  /* g-38：横型のIDカードホルダー。上の辺はゆるい弧、真ん中に革のタブ（サブ）とDカンの輪。下の左右の角は小さく落とす 2026.11.02
     前面：上の弧の帯（サブ）の下に窓の枠（メイン）、四角い窓（透明・中が見える）。イカリは窓の上の真ん中。縫い目は外周。
     背面：上の弧の帯（サブ）の下にポケット（メイン・口は真ん中が浅くえぐれる）。ネームはポケットの真ん中の下寄り */
  shapes['g-38'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 200, R = 820, cx = (L + R) / 2, TS = 300, TT = 250, B = 680, ch = 18, I = INSET, PT = 345;
    var qy = 2 * TT - TS;
    var outer = 'M' + L + ' ' + (TS + 14) + ' Q' + L + ' ' + TS + ' ' + (L + 14) + ' ' + (TS - 3) + ' Q' + cx + ' ' + qy + ' ' + (R - 14) + ' ' + (TS - 3) + ' Q' + R + ' ' + TS + ' ' + R + ' ' + (TS + 14) +
      ' V' + (B - ch) + ' L' + (R - ch) + ' ' + B + ' H' + (L + ch) + ' L' + L + ' ' + (B - ch) + ' Z';
    var st = 'd="M' + (L + I) + ' ' + (TS + I) + ' Q' + cx + ' ' + (qy + 2 * I) + ' ' + (R - I) + ' ' + (TS + I) + ' V' + (B - I - ch * 0.6) + ' L' + (R - I - ch * 0.6) + ' ' + (B - I) + ' H' + (L + I + ch * 0.6) + ' L' + (L + I) + ' ' + (B - I - ch * 0.6) + ' Z"';
    var low = 'M' + L + ' ' + PT + ' H' + R + ' V' + (B - ch) + ' L' + (R - ch) + ' ' + B + ' H' + (L + ch) + ' L' + L + ' ' + (B - ch) + ' Z';
    var dTop = ring(cx, TT - 48, 34, 9) + '<path d="M' + (cx - 36) + ' ' + (TT + 14) + ' V' + (TT - 46) + ' Q' + (cx - 36) + ' ' + (TT - 56) + ' ' + (cx - 26) + ' ' + (TT - 56) + ' H' + (cx + 26) + ' Q' + (cx + 36) + ' ' + (TT - 56) + ' ' + (cx + 36) + ' ' + (TT - 46) + ' V' + (TT + 14) + ' Z" fill="' + s + '"' + EDGE + '/>';
    var wL = L + 85, wR = R - 85, wT = PT + 75, wB = B - 80;
    var front = dTop +
      '<path d="' + outer + '" fill="' + s + '"/>' +
      '<path d="' + low + '" fill="' + m + '"/>' +
      line('M' + L + ' ' + PT + ' H' + R) + line(outer) +
      '<rect x="' + wL + '" y="' + wT + '" width="' + (wR - wL) + '" height="' + (wB - wT) + '" rx="6" fill="' + m + '"/>' +
      '<rect x="' + wL + '" y="' + wT + '" width="' + (wR - wL) + '" height="' + (wB - wT) + '" rx="6" fill="#000000" fill-opacity="0.22" stroke="#FCF6E8" stroke-opacity="0.7" stroke-width="5"/>' +
      c.stitch('path', 'g38f-st', st) +
      embAt(c, cx, (PT + wT) / 2 + 2, 48);
    var dw = 70, dd = 20;
    var pocket = 'M' + L + ' ' + PT + mouthDip(cx, PT, dw, dd) + ' H' + R + ' V' + (B - ch) + ' L' + (R - ch) + ' ' + B + ' H' + (L + ch) + ' L' + L + ' ' + (B - ch) + ' Z';
    var back = dTop +
      '<path d="' + outer + '" fill="' + s + '"/>' +
      '<path d="' + pocket + '" fill="' + m + '"/>' +
      line('M' + L + ' ' + PT + mouthDip(cx, PT, dw, dd) + ' H' + R) + line(outer) +
      c.stitch('path', 'g38b-st', st) +
      (c.name ? c.name(cx - 80, B - 140, 160, 60, m) : '');
    return frame(c, 'IDカードホルダーの見本（左から前面・背面）', [
      { box: [L - 20, TT - 110, R - L + 40, B - TT + 130], core: [TT, B - TT], body: front },
      { box: [L - 20, TT - 110, R - L + 40, B - TT + 130], body: back }
    ]);
  };

  /* g-69：ラゲッジタグ（アドレスカード付属）。縦長の本体、上の真ん中が少し盛り上がり、革のタブと輪、ベルト（ツートン）と四角いバックル 2026.11.02
     前面：真ん中の縦の帯（メイン）。上に下の辺が半円のフタ（サブ・イカリ）、帯の下の端に上が丸い留め（サブ・スナップ・低く縦横同じ 3×3）。本体の縫い目は左・下・右。
     背面：無地、盛り上がりにカシメ。ネームは下寄りの真ん中 */
  shapes['g-69'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 300, R = 640, cx = (L + R) / 2, T = 360, B = 850, r = 14, ch = 16, I = INSET, bw = 120, bump = 28;
    var outer = 'M' + (L + r) + ' ' + T + ' H' + (cx - bw) + ' Q' + (cx - bw + 22) + ' ' + T + ' ' + (cx - bw + 30) + ' ' + (T - bump) + ' H' + (cx + bw - 30) + ' Q' + (cx + bw - 22) + ' ' + T + ' ' + (cx + bw) + ' ' + T +
      ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - ch) + ' L' + (R - ch) + ' ' + B + ' H' + (L + ch) + ' L' + L + ' ' + (B - ch) + ' V' + (T + r) + ' Q' + L + ' ' + T + ' ' + (L + r) + ' ' + T + ' Z';
    var u = 'd="M' + (L + I) + ' ' + (T + 8) + ' V' + (B - I - ch * 0.6) + ' L' + (L + I + ch * 0.6) + ' ' + (B - I) + ' H' + (R - I - ch * 0.6) + ' L' + (R - I) + ' ' + (B - I - ch * 0.6) + ' V' + (T + 8) + '"';
    /* 上：ベルト（ツートン）・バックル・穴、輪、本体へ下りる革のタブ（メイン）*/
    var gT = T - 470, rY = T - 70;
    var top =
      '<path d="M' + (cx - 30) + ' ' + (rY + 4) + ' V' + (gT + 30) + ' A30 30 0 0 1 ' + (cx + 30) + ' ' + (gT + 30) + ' V' + (rY + 4) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<circle cx="' + cx + '" cy="' + (gT + 80) + '" r="7" fill="#2A241A"/>' +
      metal('M' + (cx - 46) + ' ' + (T - 270) + ' H' + (cx + 46) + ' V' + (T - 175) + ' H' + (cx - 46) + ' Z M' + cx + ' ' + (T - 270) + ' V' + (T - 230), 9) +
      ring(cx, rY, 30, 8) +
      '<path d="M' + (cx - 28) + ' ' + (T - bump + 4) + ' V' + (rY + 14) + ' Q' + (cx - 28) + ' ' + (rY + 2) + ' ' + (cx - 16) + ' ' + (rY + 2) + ' H' + (cx + 16) + ' Q' + (cx + 28) + ' ' + (rY + 2) + ' ' + (cx + 28) + ' ' + (rY + 14) + ' V' + (T - bump + 4) + ' Z" fill="' + m + '"' + EDGE + '/>';
    var sL = cx - 110, sR = cx + 110, FB = T + 120, ft = T - 6;
    var front = top +
      '<path d="' + outer + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g69f-u', u) +
      '<rect x="' + sL + '" y="' + (FB - 30) + '" width="' + (sR - sL) + '" height="' + (B - 30 - FB + 30) + '" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M' + (sL - 4) + ' ' + ft + ' H' + (sR + 4) + ' V' + (FB - 40) + ' Q' + (sR + 4) + ' ' + (FB + 20) + ' ' + cx + ' ' + (FB + 20) + ' Q' + (sL - 4) + ' ' + (FB + 20) + ' ' + (sL - 4) + ' ' + (FB - 40) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'g69f-flap', 'd="M' + (sL + 8) + ' ' + (ft + 14) + ' H' + (sR - 8) + ' M' + (sL + 12) + ' ' + (FB - 40) + ' Q' + (sL + 12) + ' ' + (FB + 4) + ' ' + cx + ' ' + (FB + 4) + ' Q' + (sR - 12) + ' ' + (FB + 4) + ' ' + (sR - 12) + ' ' + (FB - 40) + '"') +
      embAt(c, cx, ft + 70, 46) +
      '<path d="M' + (cx - 58) + ' ' + (B - 4) + ' V' + (B - 62) + ' A58 58 0 0 1 ' + (cx + 58) + ' ' + (B - 62) + ' V' + (B - 4) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<circle cx="' + cx + '" cy="' + (B - 64) + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    var back = top +
      '<path d="' + outer + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g69b-u', u) +
      rivet(cx, T - 4, 14) +
      (c.name ? c.name(cx - 80, B - 120, 160, 60, m) : '');
    return frame(c, 'ラゲッジタグの見本（左から前面・背面）', [
      { box: [L - 20, gT - 20, R - L + 40, B - gT + 40], core: [T, B - T], body: front },
      { box: [L - 20, gT - 20, R - L + 40, B - gT + 40], body: back }
    ], { tall: true }); /* 縦長で2枚：2段の高さまで使って大きく 2026.11.02 */
  };

  /* マネークリップの二つ折り財布（g-26・g-26-c・olg-26・olg-27 共通）2026.11.02
     前面：ほぼ正方形、左が背。右の上下の角は丸い。縫い目は上・右・下と、背の近くに縦1本。
     背面：左右反転（右が背、背の下にクリップの先がのぞく）。刺繍は左下、ネームは g-26 はその上。
     内側：真ん中の背にクリップ。右の面の右下に角のポケット（左上の辺は大きく丸い・刻印は描かない）*/
  function clipWallet(c, o) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 300, R = 740, T = 250, B = 690, rr = 30, I = INSET, sx = L + 45;
    var outer = 'M' + (L + 6) + ' ' + T + ' H' + (R - rr) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + rr) + ' V' + (B - rr) + ' Q' + R + ' ' + B + ' ' + (R - rr) + ' ' + B + ' H' + (L + 6) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 6) + ' V' + (T + 6) + ' Q' + L + ' ' + T + ' ' + (L + 6) + ' ' + T + ' Z';
    var st = 'd="M' + (L + 8) + ' ' + (T + I) + ' H' + (R - rr) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + rr) + ' V' + (B - rr) + ' Q' + (R - I) + ' ' + (B - I) + ' ' + (R - rr) + ' ' + (B - I) + ' H' + (L + 8) + ' M' + sx + ' ' + (T + I) + ' V' + (B - I) + '"';
    var by = T + 55, bh = 90;
    function face(id, back) {
      var g = '<path d="' + outer + '" fill="' + m + '"' + EDGE + '/>' + line('M' + (L + 30) + ' ' + T + ' V' + B) + c.stitch('path', id, st);
      if (o.belt && !back) g += '<path d="M' + (R + 30) + ' ' + by + ' H' + (R - 110) + ' A' + (bh / 2) + ' ' + (bh / 2) + ' 0 0 0 ' + (R - 110) + ' ' + (by + bh) + ' H' + (R + 30) + ' Q' + (R + 42) + ' ' + (by + bh) + ' ' + (R + 42) + ' ' + (by + bh - 12) + ' V' + (by + 12) + ' Q' + (R + 42) + ' ' + by + ' ' + (R + 30) + ' ' + by + ' Z" fill="' + m + '"' + EDGE + '/>' +
        sStitch(c, 'path', id + '-belt', 'd="M' + (R + 20) + ' ' + (by + I) + ' H' + (R - 110) + ' A' + (bh / 2 - I) + ' ' + (bh / 2 - I) + ' 0 0 0 ' + (R - 110) + ' ' + (by + bh - I) + ' H' + (R + 20) + '"');
      return g;
    }
    var front = face(o.id + 'f', false);
    /* 背面：左右反転。クリップの先は背（右）の下にのぞく。ベルトの付け根は左の端の外に少し */
    var back = (o.belt ? '<path d="M' + (L + 20) + ' ' + by + ' H' + (L - 26) + ' Q' + (L - 38) + ' ' + by + ' ' + (L - 38) + ' ' + (by + 12) + ' V' + (by + bh - 12) + ' Q' + (L - 38) + ' ' + (by + bh) + ' ' + (L - 26) + ' ' + (by + bh) + ' H' + (L + 20) + ' Z" fill="' + m + '"' + EDGE + '/>' : '') +
      '<rect x="' + (R - 70) + '" y="' + (B - 14) + '" width="52" height="30" rx="6" fill="#C9CCCF"' + EDGE_SMALL + '/>' +
      '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + face(o.id + 'b', true) + '</g>' +
      (o.hammer ? hammerEmb(c, L + 85, B - 75, 1.3) : embAt(c, L + 80, B - 75, 52)) +
      (c.name && o.nameBack ? c.name(L + 30, B - 205, 160, 60, m) : '');
    /* 内側：左の面 L2..X1、右の面 X2..R2、真ん中の背にクリップ */
    var L2 = 120, X1 = 556, X2 = 584, R2 = 1020, cxs = (X1 + X2) / 2;
    var outerIn = 'M' + (L2 + rr) + ' ' + T + ' H' + (R2 - rr) + ' Q' + R2 + ' ' + T + ' ' + R2 + ' ' + (T + rr) + ' V' + (B - rr) + ' Q' + R2 + ' ' + B + ' ' + (R2 - rr) + ' ' + B + ' H' + (L2 + rr) + ' Q' + L2 + ' ' + B + ' ' + L2 + ' ' + (B - rr) + ' V' + (T + rr) + ' Q' + L2 + ' ' + T + ' ' + (L2 + rr) + ' ' + T + ' Z';
    var panel = o.inSub ? '<path d="' + outerIn + '" fill="' + s + '"/>' : suede(outerIn, m, true);
    var cp = 'M' + R2 + ' ' + (B - 165) + ' H' + (R2 - 95) + ' Q' + (R2 - 185) + ' ' + (B - 165) + ' ' + (R2 - 185) + ' ' + (B - 75) + ' V' + B + ' H' + (R2 - rr) + ' Q' + R2 + ' ' + B + ' ' + R2 + ' ' + (B - rr) + ' Z';
    var inside = panel + line('M' + cxs + ' ' + T + ' V' + B);
    if (o.cards) {
      /* カードポケット（左右とも背の側・サブ）。口（背と反対の縦の辺）は真ん中が大きく波打つ（線そのものが曲がる）*/
      var pw = 190;
      inside += '<path d="M' + X1 + ' ' + T + ' H' + (X1 - pw) + ' C' + (X1 - pw) + ' ' + (T + 140) + ' ' + (X1 - pw + 55) + ' ' + (T + 150) + ' ' + (X1 - pw + 55) + ' ' + ((T + B) / 2) + ' C' + (X1 - pw + 55) + ' ' + (B - 150) + ' ' + (X1 - pw) + ' ' + (B - 140) + ' ' + (X1 - pw) + ' ' + B + ' H' + X1 + ' Z" fill="' + s + '"' + EDGE + '/>' +
        '<path d="M' + X2 + ' ' + T + ' H' + (X2 + pw) + ' C' + (X2 + pw) + ' ' + (T + 140) + ' ' + (X2 + pw - 55) + ' ' + (T + 150) + ' ' + (X2 + pw - 55) + ' ' + ((T + B) / 2) + ' C' + (X2 + pw - 55) + ' ' + (B - 150) + ' ' + (X2 + pw) + ' ' + (B - 140) + ' ' + (X2 + pw) + ' ' + B + ' H' + X2 + ' Z" fill="' + s + '"' + EDGE + '/>';
    }
    if (o.leftPocket) {
      /* 左の面のカードポケット（口の線が横に1本）*/
      var py = T + 0.36 * (B - T);
      inside += line('M' + (L2 + 2) + ' ' + py + ' H' + (X1 - 2));
    }
    inside += '<path d="' + cp + '" fill="' + s + '"/>' + line('M' + R2 + ' ' + (B - 165) + ' H' + (R2 - 95) + ' Q' + (R2 - 185) + ' ' + (B - 165) + ' ' + (R2 - 185) + ' ' + (B - 75) + ' V' + B) +
      line(outerIn) +
      c.stitch('rect', o.id + 'i-st', 'x="' + (L2 + I) + '" y="' + (T + I) + '" width="' + (R2 - L2 - 2 * I) + '" height="' + (B - T - 2 * I) + '" rx="' + (rr - I) + '"') +
      metal('M' + cxs + ' ' + (T + 150) + ' V' + (B - 10), 9) + '<circle cx="' + cxs + '" cy="' + (T + 150) + '" r="9" fill="#C9CCCF"' + EDGE_SMALL + '/>';
    if (o.belt) inside = suede('M' + (R2 - 20) + ' ' + by + ' H' + (R2 + 60) + ' Q' + (R2 + 72) + ' ' + by + ' ' + (R2 + 72) + ' ' + (by + 12) + ' V' + (by + bh - 12) + ' Q' + (R2 + 72) + ' ' + (by + bh) + ' ' + (R2 + 60) + ' ' + (by + bh) + ' H' + (R2 - 20) + ' Z', m, false) + inside;
    if (c.name && o.nameIn) inside += c.name(L2 + 70, B - 140, 160, 60, s);
    var views = [
      { box: [L - 20, T - 20, R - L + (o.belt ? 82 : 40), B - T + 40], core: [T, B - T], body: front },
      { box: [L - (o.belt ? 58 : 20), T - 20, R - L + (o.belt ? 78 : 40), B - T + 40], body: back },
      { box: [L2 - 20, T - 20, R2 - L2 + (o.belt ? 112 : 40), B - T + 40], body: inside }
    ];
    if (o.noBack) views.splice(1, 1);
    return frame(c, 'マネークリップ財布の見本（左から' + (o.noBack ? '前面・内側' : '前面・背面・内側') + '）', views);
  }

  /* g-26：マネークリップ財布。前面＝イカリの無い面。ツートン＝内側の右下の角のポケット（内側はメインの裏・起毛）。ネームは背面のイカリの上 2026.11.02
     バリエーション：0＝カード無し（g-26）・1＝カード有り（g-26-c・内側の左右の背の側にカードポケット＝サブ）。並びは仮決め */
  shapes['g-26'] = function (c) { return clipWallet(c, { id: 'g26', cards: c.variant === 1, nameBack: true }); };
  shapes['g-26'].variants = ['カード無し', 'カード有り'];
  shapes['g-26-c'] = function (c) { return clipWallet(c, { id: 'g26c', cards: true, nameBack: true }); };

  /* olg-26・olg-27：オイルレザー（Martillo）。違いはベルトの有無だけ。ハンマーは背面の左下。内部はすべてサブ。
     内側：左の面にカードポケット（口の線1本）、右下に角のポケット。ネームは左の面のポケットの左下寄り。olg-27 のベルトはメイン（仮決め）2026.11.02 */
  shapes['olg-26'] = function (c) { return clipWallet(c, { id: 'olg26', hammer: true, inSub: true, leftPocket: true, nameIn: true }); };
  shapes['olg-27'] = function (c) { return clipWallet(c, { id: 'olg27', hammer: true, inSub: true, leftPocket: true, nameIn: true, belt: true }); };

  /* ===== カードケース・通帳ケース・スマホケース・ポーチ g-39・g-37・g-28・olc-10・g-24・sb-15・sb-123・sb-5 2026.11.02 ===== */

  /* 角の丸い四角の道すじ（r＝角の丸み）*/
  function rrect(L, T, R, B, r) {
    return 'M' + (L + r) + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + r) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - r) + ' V' + (T + r) + ' Q' + L + ' ' + T + ' ' + (L + r) + ' ' + T + ' Z';
  }
  /* 下の辺に口のふくらみ（上へ）がある上部カード（g-37・g-28 の内側）。y＝口の高さ、h＝ふくらみ */
  function bumpUp(cx, y, w, h) {
    return ' H' + (cx + w) + ' C' + (cx + w * 0.6) + ' ' + y + ' ' + (cx + w * 0.55) + ' ' + (y - h) + ' ' + cx + ' ' + (y - h) + ' C' + (cx - w * 0.55) + ' ' + (y - h) + ' ' + (cx - w * 0.6) + ' ' + y + ' ' + (cx - w) + ' ' + y;
  }

  /* g-39：横型のカードケース（ポケット1つ）。前面・背面。ツートン＝前面の上部（ポケットより上の帯）。
     縫い目は左右の縦だけ（下は折り返しの底）。刺繍は左右の縫い目の上の端に、革の端を巻く短い糸（左右2色・標準 左＝緑・右＝赤）。ネームは背面の右下寄り 2026.11.02 */
  shapes['g-39'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 200, R = 820, T = 300, B = 680, r = 14, I = INSET, cx = (L + R) / 2, PT = T + 55;
    var outer = rrect(L, T, R, B, r);
    var sides = 'd="M' + (L + I + 4) + ' ' + (T + 18) + ' V' + (B - 40) + ' M' + (R - I - 4) + ' ' + (T + 18) + ' V' + (B - 40) + '"';
    function wraps(swap) {
      return reinLine(c, 'M' + (L - 4) + ' ' + (T + 22) + ' H' + (L + I + 12), swap ? 1 : 0) + reinLine(c, 'M' + (R + 4) + ' ' + (T + 22) + ' H' + (R - I - 12), swap ? 0 : 1);
    }
    var pocket = 'M' + L + ' ' + PT + mouthDip(cx, PT, 95, 26) + ' H' + R + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + r) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - r) + ' Z';
    var front = '<path d="' + outer + '" fill="' + s + '"/>' + '<path d="' + pocket + '" fill="' + m + '"/>' +
      line('M' + L + ' ' + PT + mouthDip(cx, PT, 95, 26) + ' H' + R) + line(outer) + c.stitch('path', 'g39f-s', sides) + wraps(false);
    var back = '<path d="' + outer + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'g39b-s', sides) + wraps(true) +
      (c.name ? c.name(R - 215, B - 112, 160, 60, m) : ''); /* ネームはもう少し右下 2026.11.02 */
    return frame(c, 'カードケースの見本（左から前面・背面）', [
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], body: back }
    ]);
  };

  /* g-37：フタ付きの横型カードケース。前面・背面・内側。ツートン＝背面のカード（ポケット）と内側の上部のカード。内側の下部（本体が折れ曲がった所）はメイン。
     前面：縫い目は左・下・右、刺繍は下の真ん中寄りに横2本（標準 赤・緑）。内側は開いて縦に置いた絵。ネームは内側の上部のカードの左寄り 2026.11.02 */
  shapes['g-37'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 200, R = 820, T = 300, B = 680, r = 14, I = INSET, cx = (L + R) / 2, PT = T + 50;
    var outer = rrect(L, T, R, B, r);
    var u = 'd="M' + (L + I) + ' ' + (T + 6) + ' V' + (B - I) + ' H' + (R - I) + ' V' + (T + 6) + '"';
    var front = '<path d="' + outer + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'g37f-u', u) + embAt(c, cx, B - 80, 56);
    var pocket = 'M' + L + ' ' + PT + mouthDip(cx, PT, 100, 34) + ' H' + R + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + r) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - r) + ' Z';
    var back = '<path d="' + outer + '" fill="' + m + '"/>' + '<path d="' + pocket + '" fill="' + s + '"/>' +
      line('M' + L + ' ' + PT + mouthDip(cx, PT, 100, 34) + ' H' + R) + line(outer) + c.stitch('path', 'g37b-u', u);
    /* 内側：上＝上部のカード（サブ）、真ん中＝折り目の帯（起毛）、下＝本体（メイン）*/
    var iT = 100, CB = 470, FB = 560, iB = 900;
    var whole = rrect(L, iT, R, iB, r);
    var card = 'M' + (L + r) + ' ' + iT + ' H' + (R - r) + ' Q' + R + ' ' + iT + ' ' + R + ' ' + (iT + r) + ' V' + CB + bumpUp(cx, CB, 100, 32) + ' H' + L + ' V' + (iT + r) + ' Q' + L + ' ' + iT + ' ' + (L + r) + ' ' + iT + ' Z';
    var inside = suede(whole, m, true) +
      '<path d="M' + L + ' ' + FB + ' H' + R + ' V' + (iB - r) + ' Q' + R + ' ' + iB + ' ' + (R - r) + ' ' + iB + ' H' + (L + r) + ' Q' + L + ' ' + iB + ' ' + L + ' ' + (iB - r) + ' Z" fill="' + m + '"/>' +
      '<path d="' + card + '" fill="' + s + '"/>' +
      line('M' + R + ' ' + CB + bumpUp(cx, CB, 100, 32) + ' H' + L) + line('M' + L + ' ' + FB + ' H' + R) + line(whole) +
      c.stitch('path', 'g37i-st', 'd="M' + (L + I) + ' ' + (iB - 20) + ' V' + (iT + I) + ' H' + (R - I) + ' V' + (iB - 20) + '"') +
      (c.name ? c.name(L + 50, CB - 105, 160, 60, s) : ''); /* ネームは上部のカードの下寄り 2026.11.02 */
    return frame(c, 'カードケースの見本（左から前面・背面・内側）', [
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], body: back },
      { box: [L - 20, iT - 20, R - L + 40, iB - iT + 40], body: inside }
    ]);
  };

  /* g-28：真ん中に帯の付いたフタ付きカードケース（ボックス型）。前面・内側・横。ツートン＝センターの帯・内部の上部カード・マチ。
     前面：上からフタ（縫い目は左・下・右）、真ん中に縦の帯（サブ・真ん中に縫い目1本）、フタの下の端あたりで帯を横切る横2本の刺繍（標準 紺・赤）。
     内側：上＝上部のカード（サブ・口は上へふくらむ・上の真ん中に丸い革とスナップ）、真ん中＝起毛の帯（縫い目1本）、下＝本体（メイン）に帯（サブ）とスナップ。ネームは上部のカードの左下寄り 2026.11.02 */
  shapes['g-28'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 200, R = 780, T = 300, B = 640, r = 22, I = INSET, cx = (L + R) / 2, FB = B - 70, bw = 34;
    var band = function (t, b) { return '<rect x="' + (cx - bw) + '" y="' + t + '" width="' + (2 * bw) + '" height="' + (b - t) + '" fill="' + s + '"' + EDGE + '/>'; };
    var front = '<path d="' + rrect(L, T + 40, R, B, 12) + '" fill="' + m + '"' + EDGE + '/>' +
      '<path d="' + rrect(L, T, R, FB, r) + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g28f-flap', 'd="M' + (L + I) + ' ' + (T + 8) + ' V' + (FB - r) + ' Q' + (L + I) + ' ' + (FB - I) + ' ' + (L + r) + ' ' + (FB - I) + ' H' + (R - r) + ' Q' + (R - I) + ' ' + (FB - I) + ' ' + (R - I) + ' ' + (FB - r) + ' V' + (T + 8) + '"') +
      band(T - 4, B) +
      c.stitch('path', 'g28f-band', 'd="M' + cx + ' ' + (T + 10) + ' V' + (FB - 75) + ' M' + cx + ' ' + (FB + 10) + ' V' + (B - 8) + '"') +
      embAt(c, cx, FB - 38, 64);
    var iT = 100, CB = 450, BB = 540, iB = 880;
    var whole = rrect(L, iT, R, iB, r);
    var card = 'M' + (L + r) + ' ' + iT + ' H' + (R - r) + ' Q' + R + ' ' + iT + ' ' + R + ' ' + (iT + r) + ' V' + CB + bumpUp(cx, CB, 110, 34) + ' H' + L + ' V' + (iT + r) + ' Q' + L + ' ' + iT + ' ' + (L + r) + ' ' + iT + ' Z';
    var inside = suede(whole, m, true) +
      '<path d="M' + L + ' ' + BB + ' H' + R + ' V' + (iB - r) + ' Q' + R + ' ' + iB + ' ' + (R - r) + ' ' + iB + ' H' + (L + r) + ' Q' + L + ' ' + iB + ' ' + L + ' ' + (iB - r) + ' Z" fill="' + m + '"/>' +
      '<path d="' + card + '" fill="' + s + '"/>' +
      line('M' + R + ' ' + CB + bumpUp(cx, CB, 110, 34) + ' H' + L) + line('M' + L + ' ' + BB + ' H' + R) + line(whole) +
      c.stitch('path', 'g28i-st', 'd="M' + (L + I) + ' ' + (iB - 20) + ' V' + (iT + I) + ' H' + (R - I) + ' V' + (iB - 20) + ' M' + cx + ' ' + (CB - 10) + ' V' + BB + '"') +
      '<circle cx="' + cx + '" cy="' + (iT + 70) + '" r="36" fill="' + m + '"' + EDGE_SMALL + '/><circle cx="' + cx + '" cy="' + (iT + 70) + '" r="20" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      band(BB - 4, iB) + c.stitch('path', 'g28i-band', 'd="M' + cx + ' ' + (BB + 12) + ' V' + (iB - 10) + '"') +
      '<circle cx="' + cx + '" cy="' + (iB - 110) + '" r="26" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      (c.name ? c.name(L + 45, CB - 115, 160, 60, s) : '');
    var side = cardSide(c, 'g28s', T + 40, B, 160, { flapDown: FB - T - 40, rb: 26 });
    return frame(c, 'カードケースの見本（左から前面・内側・横）', [
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 20, iT - 20, R - L + 40, iB - iT + 40], body: inside },
      side
    ]);
  };

  /* olc-10：Martillo のオイルレザーのカードケース。1枚の長い革で箱を巻き、右からフタがかぶる。前面・背面・内側。ツートン＝フタの裏パーツ。
     本体はカードが入る程度の箱（横長にしすぎない）。前面：ただの長方形、右からフタ（左の角は丸い・縫い目コの字）、ハンマーはフタの左寄り（頭が縦・柄が左）。
     背面：前面と同じ大きさの無地。刻印は中央より少し下（描かない）、ネームはその上（中央あたり）。
     内側：フタだけ右へ開いた形（本体は閉じたまま）。フタの裏（サブ）とスナップ、本体の前にスナップの受け 2026.11.02 */
  shapes['olc-10'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 200, R = 660, T = 330, B = 640, I = INSET, fr = 34, FW = 165, FL = R - FW, r = 10, cx = (L + R) / 2, cy = (T + B) / 2;
    var front = '<path d="' + rrect(L, T, R, B, r) + '" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M' + R + ' ' + T + ' H' + (FL + fr) + ' Q' + FL + ' ' + T + ' ' + FL + ' ' + (T + fr) + ' V' + (B - fr) + ' Q' + FL + ' ' + B + ' ' + (FL + fr) + ' ' + B + ' H' + R + ' Z" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'olc10f-flap', 'd="M' + (R - 4) + ' ' + (T + I) + ' H' + (FL + fr) + ' Q' + (FL + I) + ' ' + (T + I) + ' ' + (FL + I) + ' ' + (T + fr) + ' V' + (B - fr) + ' Q' + (FL + I) + ' ' + (B - I) + ' ' + (FL + fr) + ' ' + (B - I) + ' H' + (R - 4) + '"') +
      hammerEmb(c, FL + 55, cy, 1.2, 90);
    var back = '<path d="' + rrect(L, T, R, B, r) + '" fill="' + m + '"' + EDGE + '/>' +
      (c.name ? c.name(cx - 80, cy - 40, 160, 60, m) : '');
    /* 内側：フタだけ右へ開く。付け根は本体の右の端 */
    var X0 = R + 4, X1 = X0 + FW;
    var inner = '<path d="' + rrect(L, T, R, B, r) + '" fill="' + m + '"' + EDGE + '/>' +
      '<circle cx="' + (R - 55) + '" cy="' + cy + '" r="20" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + X0 + ' ' + T + ' H' + (X1 - fr) + ' Q' + X1 + ' ' + T + ' ' + X1 + ' ' + (T + fr) + ' V' + (B - fr) + ' Q' + X1 + ' ' + B + ' ' + (X1 - fr) + ' ' + B + ' H' + X0 + ' Z" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'olc10i-flap', 'd="M' + (X0 + 4) + ' ' + (T + I) + ' H' + (X1 - fr) + ' Q' + (X1 - I) + ' ' + (T + I) + ' ' + (X1 - I) + ' ' + (T + fr) + ' V' + (B - fr) + ' Q' + (X1 - I) + ' ' + (B - I) + ' ' + (X1 - fr) + ' ' + (B - I) + ' H' + (X0 + 4) + '"') +
      '<circle cx="' + (X1 - 55) + '" cy="' + cy + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    return frame(c, 'カードケースの見本（左から前面・背面・内側）', [
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], body: back },
      { box: [L - 20, T - 20, X1 - L + 40, B - T + 40], body: inner }
    ]);
  };

  /* g-24：通帳ケース。前面・背面・開いた面。ツートン＝フタの裏・タグ（ふだんキャメル）・丸い革。
     前面：上からフタ（下の辺は少し斜め・左が高い）、右の辺の下寄りにタグ。背面：タグは左、イカリは右下（標準 水色・黒・白）、ネームはその上。
     開いた面：フタの裏（サブ）の左右にスナップ、本体の前の上寄りの左右に丸い革（サブ）とスナップの頭。中の通帳・カードは描かない 2026.11.02 */
  shapes['g-24'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var L = 200, R = 840, T = 280, B = 700, r = 10, I = INSET, yL = T + 170, yR = T + 225;
    var tag = function (x, dir) { return '<rect x="' + (dir > 0 ? x - 8 : x - 34) + '" y="' + (B - 112) + '" width="42" height="78" rx="5" fill="' + a + '"' + EDGE_SMALL + '/>'; };
    var rect = rrect(L, T, R, B, r);
    var front = tag(R, 1) + '<path d="' + rect + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g24f-body', 'd="M' + (L + I) + ' ' + (yL + 10) + ' V' + (B - I) + ' H' + (R - I) + ' V' + (yR + 10) + '"') +
      '<path d="M' + L + ' ' + (T + r) + ' Q' + L + ' ' + T + ' ' + (L + r) + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + yR + ' L' + L + ' ' + yL + ' Z" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g24f-flap', 'd="M' + (L + I) + ' ' + (T + 8) + ' V' + (yL - I) + ' L' + (R - I) + ' ' + (yR - I) + ' V' + (T + 8) + '"');
    var back = tag(L, -1) + '<path d="' + rect + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('rect', 'g24b-st', 'x="' + (L + I) + '" y="' + (T + I) + '" width="' + (R - L - 2 * I) + '" height="' + (B - T - 2 * I) + '" rx="4"') +
      embAt(c, R - 120, B - 85, 52) + (c.name ? c.name(R - 205, B - 190, 170, 62, m) : ''); /* ネームはイカリのすぐ上 2026.11.02 */
    var oT = 170, MT = 330, PT = 400; /* フタの裏は控えめに（短く）・タグは下へ 2026.11.02 */
    var open = tag(R, 1) +
      '<path d="M' + L + ' ' + MT + ' V' + (oT + 50) + ' L' + R + ' ' + oT + ' V' + MT + ' Z" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'g24o-flap', 'd="M' + (L + I) + ' ' + (MT - 4) + ' V' + (oT + 50 + I) + ' L' + (R - I) + ' ' + (oT + I) + ' V' + (MT - 4) + '"') +
      '<circle cx="' + (L + 80) + '" cy="' + (MT - 50) + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/><circle cx="' + (R - 80) + '" cy="' + (MT - 50) + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      suede('M' + L + ' ' + MT + ' H' + R + ' V' + PT + ' H' + L + ' Z', m, false) +
      '<path d="M' + L + ' ' + PT + ' H' + R + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + r) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - r) + ' Z" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'g24o-body', 'd="M' + (L + I) + ' ' + (PT + 6) + ' V' + (B - I) + ' H' + (R - I) + ' V' + (PT + 6) + '"') +
      '<circle cx="' + (L + 80) + '" cy="' + (PT + 70) + '" r="34" fill="' + s + '"' + EDGE_SMALL + '/><circle cx="' + (L + 80) + '" cy="' + (PT + 70) + '" r="17" fill="' + METAL + '"' + EDGE_SMALL + '/>' +
      '<circle cx="' + (R - 80) + '" cy="' + (PT + 70) + '" r="34" fill="' + s + '"' + EDGE_SMALL + '/><circle cx="' + (R - 80) + '" cy="' + (PT + 70) + '" r="17" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    return frame(c, '通帳ケースの見本（左から前面・背面・開いた面）', [
      { box: [L - 60, T - 20, R - L + 120, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 60, T - 20, R - L + 120, B - T + 40], body: back },
      { box: [L - 60, oT - 20, R - L + 120, B - oT + 40], body: open }
    ]);
  };

  /* sb-15：手帳型のスマホケース。前面・背面・内側。ツートン＝ベルト・内部の左右。
     前面：左が背、右の端からベルト（サブ・先は丸い・縫い目U字）。背面：右が背、左上にカメラの窓、イカリは窓の下（標準 紺・白・赤）。
     内側：左の面（サブ・カードの差し込み口1本・金具なし）、背は起毛、右の面（サブ・スマホのケースは描かない）、ベルトの裏にも金具なし。ネームは左の面の左下 2026.11.02 */
  shapes['sb-15'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 300, R = 640, T = 200, B = 780, r = 18, I = INSET, by = T + 0.4 * (B - T), bh = 100;
    var body = 'M' + (L + 6) + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + (L + 6) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 6) + ' V' + (T + 6) + ' Q' + L + ' ' + T + ' ' + (L + 6) + ' ' + T + ' Z';
    var st = 'd="M' + (L + 8) + ' ' + (T + I) + ' H' + (R - r) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + r) + ' V' + (B - r) + ' Q' + (R - I) + ' ' + (B - I) + ' ' + (R - r) + ' ' + (B - I) + ' H' + (L + 8) + '"';
    function belt(x1, x0, id) { /* x1＝付け根側の端、x0＝先の端（丸い）*/
      var h = bh / 2;
      return '<path d="M' + x1 + ' ' + by + ' H' + (x0 + h) + ' A' + h + ' ' + h + ' 0 0 0 ' + (x0 + h) + ' ' + (by + bh) + ' H' + x1 + ' Z" fill="' + s + '"' + EDGE + '/>' +
        sStitch(c, 'path', id, 'd="M' + (x1 - 8) + ' ' + (by + I) + ' H' + (x0 + h) + ' A' + (h - I) + ' ' + (h - I) + ' 0 0 0 ' + (x0 + h) + ' ' + (by + bh - I) + ' H' + (x1 - 8) + '"');
    }
    var front = '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'sb15f-u', st) + belt(R + 34, R - 150, 'sb15f-belt');
    var back = '<rect x="' + (L - 34) + '" y="' + by + '" width="44" height="' + bh + '" rx="10" fill="' + s + '"' + EDGE + '/>' +
      '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)"><path d="' + body + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'sb15b-u', st) + '</g>' +
      '<rect x="' + (L + 28) + '" y="' + (T + 28) + '" width="125" height="125" rx="16" fill="' + m + '"/>' +
      '<rect x="' + (L + 28) + '" y="' + (T + 28) + '" width="125" height="125" rx="16" fill="#000000" fill-opacity="0.38"' + EDGE_SMALL + '/>' +
      embAt(c, L + 100, T + 210, 48);
    var L2 = 100, X1 = 440, X2 = 500, R2 = 840;
    var inside = belt(R2 - 20, R2 + 90, 'sb15i-belt') + /* ベルトの裏に金具は無い 2026.11.02 */
      '<path d="' + rrect(L2, T, R2, B, r) + '" fill="' + s + '"/>' +
      suede('M' + X1 + ' ' + T + ' H' + X2 + ' V' + B + ' H' + X1 + ' Z', m, true) +
      line('M' + X1 + ' ' + T + ' V' + B + ' M' + X2 + ' ' + T + ' V' + B) + line(rrect(L2, T, R2, B, r)) +
      c.stitch('rect', 'sb15i-st', 'x="' + (L2 + I) + '" y="' + (T + I) + '" width="' + (R2 - L2 - 2 * I) + '" height="' + (B - T - 2 * I) + '" rx="' + (r - 8) + '"') +
      line('M' + (L2 + 60) + ' ' + (T + 0.42 * (B - T)) + ' H' + (X1 - 60)) +
      (c.name ? c.name((L2 + X1) / 2 - 80, B - 120, 160, 60, s) : ''); /* ネームは左の面の真ん中の下部 2026.11.02 */
    return frame(c, 'スマホケースの見本（左から前面・背面・内側）', [
      { box: [L - 20, T - 20, R - L + 60, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 54, T - 20, R - L + 74, B - T + 40], body: back },
      { box: [L2 - 20, T - 20, R2 - L2 + 190, B - T + 40], body: inside }
    ]);
  };

  /* sb-123：ティコ（アタッチメントポーチ）。前面・背面。ツートン＝マチ（左右と下をふちどる細い帯）。細い引き手（slimPull）はふだんキャメル。
     前面：上の辺にファスナー、その下に横の縫い目。下の左右の角は大きく丸く、下の辺は真ん中が少しへこむ。下の真ん中にマチの合わせ目。両端の金具は描かない（2026.11.02）。イカリは上寄りの真ん中（標準 赤・白・緑）。
     背面：左右反転、ネームは上寄りの真ん中 2026.11.02 */
  shapes['sb-123'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var L = 200, R = 820, T = 300, B = 640, RC = 80, I = INSET, cx = (L + R) / 2, p = 16;
    function shape(l, r, t, b) {
      return 'M' + l + ' ' + t + ' H' + r + ' V' + (b - RC) + ' Q' + r + ' ' + b + ' ' + (r - RC) + ' ' + b + ' Q' + cx + ' ' + (b - 18) + ' ' + (l + RC) + ' ' + b + ' Q' + l + ' ' + b + ' ' + l + ' ' + (b - RC) + ' Z';
    }
    function face(id) {
      return zip(id + '-zip', 'M' + (L + 10) + ' ' + (T - 6) + ' H' + (R - 10)) +
        '<path d="' + shape(L, R, T, B) + '" fill="' + s + '"' + EDGE + '/>' +
        '<path d="' + shape(L + p, R - p, T, B - p) + '" fill="' + m + '"' + EDGE + '/>' +
        c.stitch('path', id + '-top', 'd="M' + (L + p + 12) + ' ' + (T + 22) + ' H' + (R - p - 12) + '"') +
        sStitch(c, 'path', id + '-seam', 'd="M' + cx + ' ' + (B - 30) + ' V' + (B - 4) + '"') +
        '<g transform="rotate(62 ' + (L + 36) + ' ' + (T - 6) + ')">' + slimPull(L + 36, T - 6, a) + '</g>';
    }
    var front = face('sb123f') + embAt(c, cx, T + 85, 50);
    var back = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + face('sb123b') + '</g>' + (c.name ? c.name(cx - 80, T + 50, 160, 60, m) : '');
    return frame(c, 'ポーチの見本（左から前面・背面）', [
      { box: [L - 50, T - 120, R - L + 100, B - T + 140], core: [T, B - T], body: front },
      { box: [L - 50, T - 120, R - L + 100, B - T + 140], body: back }
    ]);
  };

  /* sb-5：縦型のL字ファスナーポーチ（S・M・L）。選んだサイズだけ描く（c.variant：0＝S・1＝M・2＝L）。一回りずつ大きく（core は L で共通）。
     前面・背面・サイド。ツートン＝マチ（左と下をふちどる帯）と丸い引き手（ふだんキャメル）。刺繍の標準色はサイズで違う（S＝赤・白・紺、M＝白・緑・赤、L＝赤・白・水色）。
     前面：ファスナーは上の辺から右上の角を回って右の辺を下へ、右下で革の当てに入る。金具は描かない（2026.11.02）。引き手は左上。イカリは上寄りの真ん中。背面：左右反転、ネームは下寄りの真ん中 2026.11.02 */
  shapes['sb-5'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var v = c.variant || 0, k = [0.82, 0.91, 1][v] || 1;
    var W = 360 * k, H = 560 * k, B = 820, T = B - H, L = 400 - W / 2, R = L + W, cx = (L + R) / 2, r = 60 * k, p = 18, I = INSET;
    var outer = rrect(L, T, R, B, r);
    function face(id) {
      return '<path d="' + outer + '" fill="' + s + '"' + EDGE + '/>' +
        '<path d="M' + (L + p + r) + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - p - r) + ' Q' + R + ' ' + (B - p) + ' ' + (R - r) + ' ' + (B - p) + ' H' + (L + p + r) + ' Q' + (L + p) + ' ' + (B - p) + ' ' + (L + p) + ' ' + (B - p - r) + ' V' + (T + r) + ' Q' + (L + p) + ' ' + T + ' ' + (L + p + r) + ' ' + T + ' Z" fill="' + m + '"' + EDGE + '/>' +
        zip(id + '-zip', 'M' + (L + p + 30) + ' ' + (T + 2) + ' H' + (R - r) + ' Q' + (R - 2) + ' ' + (T + 2) + ' ' + (R - 2) + ' ' + (T + r) + ' V' + (B - 100 * k)) +
        '<path d="M' + (R - 22) + ' ' + (B - 110 * k) + ' H' + (R + 4) + ' V' + (B - r) + ' Q' + (R + 4) + ' ' + (B - p) + ' ' + (R - r * 0.6) + ' ' + (B - p) + ' H' + (R - 22) + ' Z" fill="' + s + '"' + EDGE_SMALL + '/>' + /* ファスナーの終わりの当てもマチ（サブ）2026.11.02 */
        sStitch(c, 'path', id + '-tab', 'd="M' + (R - 18) + ' ' + (B - 96 * k) + ' H' + (R - 2) + '"') +
        '<rect x="' + (L + p + 20) + '" y="' + (T - 8) + '" width="22" height="20" rx="4" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
        discPull(L + p + 8, T - 34, 22, a);
    }
    var front = face('sb5f') + embAt(c, cx, T + 0.24 * H, 44);
    var back = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + face('sb5b') + '</g>' + (c.name ? c.name(cx - 70, B - 130 * k, 140, 56, m) : '');
    /* サイド＝ファスナー側の面（写真どおり）2026.11.02
       真ん中にファスナー（布と歯）が上から下近くまで縦に通り、上は丸く回る。左右に前後の革（メイン）のふくらみ。
       ファスナーの終わりは下の革の当て（マチ＝サブ）が包み、当ての上の端に白い縫い目。下の端は丸い。引き手・金具は描かない */
    var sx = 300, tw = 42, bul = 30, tL = sx - tw / 2, tR = sx + tw / 2, pT = B - 105 * k, pr = tw / 2 + 8;
    var lens = function (x, dir) { return '<path d="M' + x + ' ' + (T + 24) + ' Q' + (x + dir * bul * 2) + ' ' + ((T + B) / 2) + ' ' + x + ' ' + (B - 4) + ' Z" fill="' + m + '"' + EDGE + '/>'; }; /* ふくらみは下の端まで 2026.11.02 */
    var side = lens(tL, -1) + lens(tR, 1) +
      '<rect x="' + tL + '" y="' + T + '" width="' + tw + '" height="' + (pT + 20 - T) + '" rx="' + (tw / 2) + '" fill="' + ZIP_TAPE + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + sx + ' ' + (T + 18) + ' V' + (pT - 4) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="14" stroke-dasharray="6 5"/>' +
      '<rect x="' + (sx - 9) + '" y="' + (pT - 14) + '" width="18" height="10" rx="2" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + (sx - pr) + ' ' + pT + ' H' + (sx + pr) + ' V' + (B - pr) + ' A' + pr + ' ' + pr + ' 0 0 1 ' + (sx - pr) + ' ' + (B - pr) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'sb5s-tab', 'd="M' + (sx - pr + 6) + ' ' + (pT + 14) + ' H' + (sx + pr - 6) + '"');
    var box = [L - 50, B - 560 - 90, 460, 560 + 110];
    return frame(c, 'ポーチの見本（左から前面・背面・サイド）', [
      { box: box, core: [B - 560, 560], body: front },
      { box: box, body: back },
      { box: [sx - 80, B - 560 - 90, 160, 560 + 110], body: side }
    ]);
  };
  shapes['sb-5'].variants = ['S', 'M', 'L'];

  /* ===== スマホポーチ・ポーチ・ベルトポーチ・バッグ・たばこケース sb-8・sb-9・sb-14・sb-17・olb-17・sb-29・sb-1-2・ola-15・ola-16 2026.11.02 ===== */

  /* 太いひも・帯を線で描く（革ひも・ストラップ）。fill は模様。黒い縁は #111 で描き、frame の線の太さ補正に掛からないようにする */
  function strapLine(d, w, fill) {
    return '<path d="' + d + '" fill="none" stroke="#111111" stroke-width="' + (w + 6) + '" stroke-linecap="round"/>' +
      '<path d="' + d + '" fill="none" stroke="' + fill + '" stroke-width="' + w + '" stroke-linecap="round"/>';
  }
  /* ナスカン（小さな留め具）：金具の輪と細長い本体 */
  function nasukan(x, y) {
    return metal('M' + x + ' ' + y + ' V' + (y + 46) + ' M' + (x - 9) + ' ' + (y + 46) + ' Q' + x + ' ' + (y + 70) + ' ' + (x + 9) + ' ' + (y + 46), 7) + ring(x, y - 8, 10, 5);
  }

  /* sb-8・sb-9：縦長のスマホポーチ。前面・背面。下の左右の角は小さく落とし、縫い目は左・下・右。
     前面：上の真ん中から短いボタンベルト（サブ・先は丸い・スナップ）、イカリは右下。
     sb-8 の背面：上の口の少し下に横の縫い目、真ん中に背面ベルト（サブ・上は幅広く下へ細くなって先は丸い・スナップ）。
     sb-9：手提げのストラップ（サブ）。背面の上の端にカシメ3つ（左＝ストラップの付け根・真ん中＝ボタンベルトの付け根・右＝ナスカンの金具）。前面は左右反転で見える。
     ネームは背面の下寄りの真ん中 2026.11.02 */
  function phonePouch(c, strap) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 300, R = 660, T = 230, B = 800, ch = 24, I = INSET, cx = (L + R) / 2, r = 8;
    var body = 'M' + (L + r) + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - ch) + ' L' + (R - ch) + ' ' + B + ' H' + (L + ch) + ' L' + L + ' ' + (B - ch) + ' V' + (T + r) + ' Q' + L + ' ' + T + ' ' + (L + r) + ' ' + T + ' Z';
    var u = 'd="M' + (L + I) + ' ' + (T + 18) + ' V' + (B - I - ch * 0.6) + ' L' + (L + I + ch * 0.6) + ' ' + (B - I) + ' H' + (R - I - ch * 0.6) + ' L' + (R - I) + ' ' + (B - I - ch * 0.6) + ' V' + (T + 18) + '"';
    var bw = 46, bT = T - 30, bB = T + 120;
    var tab = '<path d="M' + (cx - bw) + ' ' + bT + ' V' + (bB - bw) + ' A' + bw + ' ' + bw + ' 0 0 0 ' + (cx + bw) + ' ' + (bB - bw) + ' V' + bT + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<circle cx="' + cx + '" cy="' + (bB - bw) + '" r="24" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    /* ストラップ：左の付け根から上へ大きく輪になり、右のナスカンへ（背面の向き）*/
    var sL = L + 55, sR = R - 55, sTop = T - 420;
    var strapBack = strap ? strapLine('M' + sL + ' ' + (T + 40) + ' C' + (sL - 20) + ' ' + sTop + ' ' + (sR + 10) + ' ' + sTop + ' ' + (sR + 10) + ' ' + (T - 170), 38, s) + nasukan(sR + 10, T - 150) : '';
    var front = (strap ? '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + strapBack + '</g>' : '') +
      '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'sb8f-u', u) + tab + embAt(c, R - 75, B - 95, 50);
    var back = strapBack + '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'sb8b-u', u);
    if (strap) {
      back += sStitch(c, 'path', 'sb9b-h', 'd="M' + (L + I) + ' ' + (T + 95) + ' H' + (R - I) + '"') +
        '<path d="M' + (cx - 34) + ' ' + (T - 24) + ' V' + (T + 30) + ' A34 34 0 0 0 ' + (cx + 34) + ' ' + (T + 30) + ' V' + (T - 24) + ' Z" fill="' + s + '"' + EDGE + '/>' +
        rivet(sL, T + 40, 13) + rivet(cx, T + 32, 13) +
        '<rect x="' + (sR - 2) + '" y="' + (T - 40) + '" width="24" height="80" rx="6" fill="' + METAL + '"' + EDGE_SMALL + '/>' + rivet(sR + 10, T + 30, 13);
    } else {
      var w1 = 70, w2 = 40, eB = T + 300;
      back += sStitch(c, 'path', 'sb8b-h', 'd="M' + (L + I) + ' ' + (T + 70) + ' H' + (R - I) + '"') +
        '<path d="M' + (cx - w1) + ' ' + (T - 30) + ' H' + (cx + w1) + ' L' + (cx + w2) + ' ' + (eB - w2) + ' A' + w2 + ' ' + w2 + ' 0 0 1 ' + (cx - w2) + ' ' + (eB - w2) + ' Z" fill="' + s + '"' + EDGE + '/>' +
        '<circle cx="' + cx + '" cy="' + (eB - w2 - 4) + '" r="22" fill="' + METAL + '"' + EDGE_SMALL + '/>';
    }
    back += c.name ? c.name(cx - 80, B - 150, 160, 60, m) : '';
    var top = strap ? T - 330 : T - 50;
    return frame(c, 'スマホポーチの見本（左から前面・背面）', [
      { box: [L - 30, top, R - L + 60, B + 20 - top], core: [T, B - T], body: front },
      { box: [L - 30, top, R - L + 60, B + 20 - top], body: back }
    ]);
  }
  shapes['sb-8'] = function (c) { return phonePouch(c, false); };
  shapes['sb-9'] = function (c) { return phonePouch(c, true); };

  /* sb-14：半月形のファスナーポーチ。前面・背面・サイド。ツートン＝マチ（上の弧をふちどる帯）と底面（下の帯）。
     前面：下の帯（底面）は控えめな高さ、上の弧のファスナーは描かない。引き手（細い革）は左下の端から上へ立ち上がる。イカリは上寄りの真ん中。
     背面：左右反転、底の帯の上の真ん中に半月のブランドタグ（メイン・文字なし）、ネームは右下寄り。
     サイド：上が細い山形。真ん中にマチ（サブ・太め）が上から下の端まで通り、その真ん中にファスナー（縫い目はマチの両縁）。下の横の帯・縫い目は描かない 2026.11.02 */
  shapes['sb-14'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var L = 200, R = 820, B = 700, cx = (L + R) / 2, YA = B - 150, RX = 310, RY = 250, BT = B - 52, p = 26;
    var outer = 'M' + L + ' ' + (B - 40) + ' V' + YA + ' A' + RX + ' ' + RY + ' 0 0 1 ' + R + ' ' + YA + ' V' + (B - 40) + ' Q' + R + ' ' + B + ' ' + (R - 40) + ' ' + B + ' H' + (L + 40) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 40) + ' Z';
    var inner = 'M' + (L + p) + ' ' + BT + ' V' + YA + ' A' + (RX - p) + ' ' + (RY - p) + ' 0 0 1 ' + (R - p) + ' ' + YA + ' V' + BT + ' Z';
    function face(id) {
      return '<g transform="rotate(-8 ' + (L - 2) + ' ' + (YA + 60) + ')">' + slimPull(L - 2, YA + 60, a) + '</g>' + /* 引き手は上へ立ち上げる 2026.11.02 */
        '<path d="' + outer + '" fill="' + s + '"/>' + '<path d="' + inner + '" fill="' + m + '"/>' +
        line(inner.replace(/ Z$/, '')) + line('M' + L + ' ' + BT + ' H' + R) + line(outer) +
        c.stitch('path', id + '-arc', 'd="M' + (L + 12) + ' ' + BT + ' V' + YA + ' A' + (RX - 12) + ' ' + (RY - 12) + ' 0 0 1 ' + (R - 12) + ' ' + YA + ' V' + BT + '"') +
        c.stitch('path', id + '-band', 'd="M' + (L + 10) + ' ' + (BT + 14) + ' H' + (R - 10) + '"');
    }
    var front = face('sb14f') + embAt(c, cx, YA - RY + 95, 50);
    var back = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + face('sb14b') + '</g>' +
      '<path d="M' + (cx - 46) + ' ' + (BT + 4) + ' Q' + (cx - 46) + ' ' + (BT - 26) + ' ' + cx + ' ' + (BT - 26) + ' Q' + (cx + 46) + ' ' + (BT - 26) + ' ' + (cx + 46) + ' ' + (BT + 4) + ' Z" fill="' + m + '"' + EDGE_SMALL + '/>' +
      (c.name ? c.name(cx - 80, BT - 104, 160, 60, m) : ''); /* ネームは背面の真ん中、タグのすぐ上 2026.11.02 */
    var sx = 300, T2 = YA - RY, hw = 120, gw = 56;
    var sOut = 'M' + (sx - hw) + ' ' + (B - 30) + ' V' + (BT - 10) + ' C' + (sx - hw + 10) + ' ' + (T2 + 90) + ' ' + (sx - 50) + ' ' + T2 + ' ' + sx + ' ' + T2 + ' C' + (sx + 50) + ' ' + T2 + ' ' + (sx + hw - 10) + ' ' + (T2 + 90) + ' ' + (sx + hw) + ' ' + (BT - 10) + ' V' + (B - 30) + ' Q' + (sx + hw) + ' ' + B + ' ' + (sx + hw - 30) + ' ' + B + ' H' + (sx - hw + 30) + ' Q' + (sx - hw) + ' ' + B + ' ' + (sx - hw) + ' ' + (B - 30) + ' Z';
    var side = '<path d="' + sOut + '" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M' + (sx - gw) + ' ' + (T2 + 40) + ' Q' + (sx - gw) + ' ' + (T2 + 4) + ' ' + sx + ' ' + (T2 + 4) + ' Q' + (sx + gw) + ' ' + (T2 + 4) + ' ' + (sx + gw) + ' ' + (T2 + 40) + ' V' + (B - 2) + ' H' + (sx - gw) + ' Z" fill="' + s + '"' + EDGE + '/>' + /* マチ（サブ）は上から下の端まで（太め）2026.11.02 */
      '<rect x="' + (sx - 15) + '" y="' + (T2 + 20) + '" width="30" height="' + (B - T2 - 90) + '" rx="15" fill="' + ZIP_TAPE + '"/>' +
      '<path d="M' + sx + ' ' + (T2 + 30) + ' V' + (B - 84) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="11" stroke-dasharray="5 4"/>' +
      '<rect x="' + (sx - 12) + '" y="' + (B - 86) + '" width="24" height="14" rx="3" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>';
    return frame(c, 'ポーチの見本（左から前面・背面・サイド）', [
      { box: [L - 40, YA - RY - 20, R - L + 80, B - YA + RY + 40], core: [YA - RY, B - YA + RY], body: front },
      { box: [L - 40, YA - RY - 20, R - L + 80, B - YA + RY + 40], body: back },
      { box: [sx - hw - 20, YA - RY - 20, 2 * hw + 40, B - YA + RY + 40], body: side }
    ]);
  };

  /* ベルト通しの帯（2本・縦）：x＝真ん中、t〜b、w＝幅 */
  function beltLoops(c, id, xs, t, b, w, fill, stitch) {
    var g = '';
    xs.forEach(function (x, i) {
      g += '<rect x="' + (x - w / 2) + '" y="' + t + '" width="' + w + '" height="' + (b - t) + '" rx="8" fill="' + fill + '"' + EDGE + '/>';
      if (stitch) g += sStitch(c, 'path', id + i, 'd="M' + (x - w / 2 + 10) + ' ' + (t + 12) + ' V' + (b - 6) + ' M' + (x + w / 2 - 10) + ' ' + (t + 12) + ' V' + (b - 6) + '"');
    });
    return g;
  }

  /* sb-17：ベルトに通すフタ付きのポーチ（縦長・下は大きく丸い）。前面・背面。ツートン＝マチ・フタ全体・ベルト・背面ポケット。ネームはひも付きタグなので描かない。
     前面：左右と下をマチ（サブ）がふちどる。フタ（サブ）は下の辺が大きな半円。真ん中に当て革（サブ・上が半円・下は四角）、縫い目は四角い部分の上と左右、イカリは四角い部分の真ん中。
     当て革の下に差し込み錠（銀：上は細い板、下は盾形で下の角が尖る）。上にベルト通し2本（サブ）。
     背面：上の帯（フタの付け根・サブ）に横の縫い目とカシメ2つ、金具の輪からベルト（サブ）。真ん中の下寄りに縦長のポケット（サブ）。右上に小さなタグ（ふだんキャメル）2026.11.02 */
  shapes['sb-17'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var L = 250, R = 750, T = 300, B = 820, RC = 190, p = 22, I = INSET, cx = (L + R) / 2, FB = T + 210; /* 縦を詰める 2026.11.02 */
    function shape(l, r, t, b, rc) { return 'M' + l + ' ' + t + ' H' + r + ' V' + (b - rc) + ' C' + r + ' ' + (b - rc * 0.3) + ' ' + (r - rc * 0.45) + ' ' + b + ' ' + ((l + r) / 2) + ' ' + b + ' C' + (l + rc * 0.45) + ' ' + b + ' ' + l + ' ' + (b - rc * 0.3) + ' ' + l + ' ' + (b - rc) + ' Z'; }
    var bx = [cx - 135, cx + 135];
    var body = '<path d="' + shape(L, R, T, B, RC) + '" fill="' + s + '"' + EDGE + '/>' + '<path d="' + shape(L + p, R - p, T, B - p, RC - p) + '" fill="' + m + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'sb17-seam', 'd="M' + cx + ' ' + (B - 26) + ' V' + (B - 4) + '"');
    var tw = 50, tT = FB - 120, sq = FB - 75, tB = FB + 25;
    var lock = '<path d="M' + (cx - 16) + ' ' + (tB - 10) + ' H' + (cx + 16) + ' V' + (tB + 30) + ' H' + (cx - 16) + ' Z" fill="#C9CCCF"' + EDGE_SMALL + '/>' +
      '<path d="M' + (cx - 34) + ' ' + (tB + 26) + ' H' + (cx + 34) + ' V' + (tB + 92) + ' L' + cx + ' ' + (tB + 118) + ' L' + (cx - 34) + ' ' + (tB + 92) + ' Z" fill="#C9CCCF"' + EDGE_SMALL + '/>' +
      '<path d="M' + (cx - 22) + ' ' + (tB + 38) + ' H' + (cx + 22) + ' V' + (tB + 86) + ' L' + cx + ' ' + (tB + 102) + ' L' + (cx - 22) + ' ' + (tB + 86) + ' Z" fill="#9EA3A8"/>';
    var front = beltLoops(c, 'sb17f-b', bx, T - 190, T + 20, 52, s, false) + body +
      '<path d="M' + (L + 26) + ' ' + (T - 10) + ' H' + (R - 26) + ' V' + (T + 50) + ' Q' + (R - 26) + ' ' + FB + ' ' + cx + ' ' + FB + ' Q' + (L + 26) + ' ' + FB + ' ' + (L + 26) + ' ' + (T + 50) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      lock +
      '<path d="M' + (cx - tw) + ' ' + tB + ' V' + (tT + tw) + ' A' + tw + ' ' + tw + ' 0 0 1 ' + (cx + tw) + ' ' + (tT + tw) + ' V' + tB + ' Z" fill="' + s + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'sb17f-tab', 'd="M' + (cx - tw + 12) + ' ' + (tB - 8) + ' V' + sq + ' H' + (cx + tw - 12) + ' V' + (tB - 8) + '"') + /* 縫い目は四角い部分の上と左右 */
      embAt(c, cx, (sq + tB) / 2, 32);
    var back = beltLoops(c, 'sb17b-b', bx, T - 190, T - 30, 52, s, false) + ring(bx[0], T - 20, 18, 6) + ring(bx[1], T - 20, 18, 6) + body +
      '<rect x="' + (L + 26) + '" y="' + (T - 10) + '" width="' + (R - L - 52) + '" height="80" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'sb17b-top', 'd="M' + (L + 26 + I) + ' ' + (T + 55) + ' H' + (R - 26 - I) + '"') +
      rivet(bx[0], T + 22, 12) + rivet(bx[1], T + 22, 12) + rivet(bx[0], T - 150, 10) + rivet(bx[1], T - 150, 10) +
      '<rect x="' + (R - 90) + '" y="' + (T + 64) + '" width="50" height="20" rx="8" fill="' + a + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + (cx - 95) + ' ' + (T + 150) + ' H' + (cx + 95) + ' V' + (B - 110 - POCKET_R) + ' Q' + (cx + 95) + ' ' + (B - 110) + ' ' + (cx + 95 - POCKET_R) + ' ' + (B - 110) + ' H' + (cx - 95 + POCKET_R) + ' Q' + (cx - 95) + ' ' + (B - 110) + ' ' + (cx - 95) + ' ' + (B - 110 - POCKET_R) + ' Z" fill="' + s + '"' + EDGE + '/>' + /* 背面ポケットは縦長 */
      c.stitch('path', 'sb17b-pocket', 'd="' + pocketStitch(cx - 95, T + 150, cx + 95, B - 110) + '"');
    return frame(c, 'ベルトポーチの見本（左から前面・背面）', [
      { box: [L - 20, T - 210, R - L + 40, B - T + 230], core: [T, B - T], body: front },
      { box: [L - 20, T - 210, R - L + 40, B - T + 230], body: back }
    ]);
  };

  /* olb-17：Martillo のオイルレザーのベルトポーチ（縦型・フタ付き）。前面・背面。ツートン＝ベルト・ベルトの付け根・フタのベロ・ベロの受け。ネームは描かない。
     前面：フタ（メイン）の真ん中から縦長のベロ（サブ・先は丸い・縫い目U字・真ん中に横の縫い目とハンマー・刻印は描かない）、その下にベロの受け（サブ・下が半円）。
     ベルト通し2本（サブ・縫い目は両側）。背面：上の左右にベルトの付け根（サブ）と金具の輪、カシメ 2026.11.02 */
  shapes['olb-17'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 260, R = 740, T = 300, B = 860, RC = 70, I = INSET, cx = (L + R) / 2, FB = T + 200, bx = [cx - 165, cx + 165];
    var body = 'M' + L + ' ' + T + ' H' + R + ' V' + (B - RC) + ' Q' + R + ' ' + B + ' ' + (R - RC) + ' ' + B + ' H' + (L + RC) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - RC) + ' Z';
    var front = beltLoops(c, 'olb17f-b', bx, T - 270, T + 10, 64, s, true) + rivet(bx[0], T - 10, 13) + rivet(bx[1], T - 10, 13) +
      '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' +
      line('M' + (L + 26) + ' ' + (FB + 10) + ' V' + (B - RC) + ' Q' + (L + 26) + ' ' + (B - 26) + ' ' + (L + RC) + ' ' + (B - 26) + ' H' + (R - RC) + ' Q' + (R - 26) + ' ' + (B - 26) + ' ' + (R - 26) + ' ' + (B - RC) + ' V' + (FB + 10)) +
      sStitch(c, 'path', 'olb17-seam', 'd="M' + cx + ' ' + (B - 26) + ' V' + (B - 4) + '"') +
      '<path d="' + rrect(L - 4, T - 6, R + 4, FB, 12) + '" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M' + (cx - 50) + ' ' + (FB + 140) + ' H' + (cx + 50) + ' V' + (FB + 190) + ' A50 50 0 0 1 ' + (cx - 50) + ' ' + (FB + 190) + ' Z" fill="' + s + '"' + EDGE + '/>' + /* ベロの受け（下が半円・ベロの先より下に見える）2026.11.02 */
      sStitch(c, 'path', 'olb17-rec', 'd="M' + (cx - 36) + ' ' + (FB + 190) + ' A36 36 0 0 0 ' + (cx + 36) + ' ' + (FB + 190) + '"') +
      '<path d="M' + (cx - 60) + ' ' + (FB - 110) + ' V' + (FB + 100) + ' A60 60 0 0 0 ' + (cx + 60) + ' ' + (FB + 100) + ' V' + (FB - 110) + ' A60 60 0 0 0 ' + (cx - 60) + ' ' + (FB - 110) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'olb17-tab', 'd="M' + (cx - 46) + ' ' + (FB - 110) + ' V' + (FB + 100) + ' A46 46 0 0 0 ' + (cx + 46) + ' ' + (FB + 100) + ' V' + (FB - 110) + ' A46 46 0 0 0 ' + (cx - 46) + ' ' + (FB - 110) + ' M' + (cx - 46) + ' ' + (FB + 10) + ' H' + (cx + 46) + '"') +
      hammerEmb(c, cx, FB + 60, 1.1);
    var back = beltLoops(c, 'olb17b-b', bx, T - 270, T - 50, 64, s, true) + ring(bx[0], T - 42, 20, 6) + ring(bx[1], T - 42, 20, 6) + rivet(bx[0], T - 220, 11) + rivet(bx[1], T - 220, 11) +
      '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'olb17b-st', 'd="M' + (L + I) + ' ' + (T + 10) + ' V' + (B - RC) + ' Q' + (L + I) + ' ' + (B - I) + ' ' + (L + RC) + ' ' + (B - I) + ' H' + (R - RC) + ' Q' + (R - I) + ' ' + (B - I) + ' ' + (R - I) + ' ' + (B - RC) + ' V' + (T + 10) + '"') +
      '<rect x="' + (bx[0] - 32) + '" y="' + (T - 30) + '" width="64" height="80" rx="10" fill="' + s + '"' + EDGE + '/>' + rivet(bx[0], T + 20, 12) +
      '<rect x="' + (bx[1] - 32) + '" y="' + (T - 30) + '" width="64" height="80" rx="10" fill="' + s + '"' + EDGE + '/>' + rivet(bx[1], T + 20, 12);
    return frame(c, 'ベルトポーチの見本（左から前面・背面）', [
      { box: [L - 20, T - 290, R - L + 40, B - T + 310], core: [T, B - T], body: front },
      { box: [L - 20, T - 290, R - L + 40, B - T + 310], body: back }
    ]);
  };

  /* sb-29：巾着のバケツ形バッグ。前面・背面。ツートン＝底面（下の端に細く見える）・ひも収納パーツ・ブランドタグ（ふだんキャメル）。ネームは描かない。
     上の口の帯の下に横の縫い目、左右寄りに2つのハトメ（真ん中は空白）から革ひも（いつもキャメル）。イカリは上寄りの真ん中。
     右の側面にひも収納パーツ（サブ）、右の下寄りにブランドタグ。背面は左右反転でイカリなし 2026.11.02 */
  shapes['sb-29'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)', k = 'url(#' + c.uid + '-k)';
    var L = 260, R = 740, T = 330, B = 860, cx = (L + R) / 2, gx = [cx - 135, cx + 135];
    /* 上が少し狭まり、下へ向けて少しふくらむ（長方形にしない）2026.11.02 */
    function shape(b) { return 'M' + (L + 28) + ' ' + T + ' H' + (R - 28) + ' C' + (R - 10) + ' ' + (T + 160) + ' ' + (R + 14) + ' ' + (b - 220) + ' ' + (R + 10) + ' ' + (b - 100) + ' Q' + (R + 4) + ' ' + b + ' ' + (R - 60) + ' ' + b + ' H' + (L + 60) + ' Q' + (L - 4) + ' ' + b + ' ' + (L - 10) + ' ' + (b - 100) + ' C' + (L - 14) + ' ' + (b - 220) + ' ' + (L + 10) + ' ' + (T + 160) + ' ' + (L + 28) + ' ' + T + ' Z'; }
    var holes = holeD(gx[0], T + 34, 12) + holeD(gx[1], T + 34, 12);
    function face(id) {
      var clip = c.uid + '-' + id + '-clip';
      return strapLine('M' + gx[0] + ' ' + (T + 34) + ' L' + (gx[0] + 30) + ' ' + (T - 330), 14, k) + strapLine('M' + gx[1] + ' ' + (T + 34) + ' L' + (gx[1] - 30) + ' ' + (T - 330), 14, k) +
        '<rect x="' + (L + 40) + '" y="' + (T - 22) + '" width="' + (R - L - 80) + '" height="30" rx="10" fill="' + m + '"' + EDGE + '/>' +
        '<path d="M' + (R - 20) + ' ' + (T + 70) + ' H' + (R + 22) + ' Q' + (R + 48) + ' ' + (T + 70) + ' ' + (R + 48) + ' ' + (T + 120) + ' Q' + (R + 48) + ' ' + (T + 190) + ' ' + (R - 14) + ' ' + (T + 190) + ' Z" fill="' + s + '"' + EDGE + '/>' +
        sStitch(c, 'path', id + '-holder', 'd="M' + (R - 6) + ' ' + (T + 84) + ' Q' + (R + 34) + ' ' + (T + 84) + ' ' + (R + 34) + ' ' + (T + 125) + ' Q' + (R + 34) + ' ' + (T + 176) + ' ' + (R - 6) + ' ' + (T + 176) + '"') +
        '<rect x="' + (R + 2) + '" y="' + (B - 250) + '" width="24" height="56" rx="4" fill="' + a + '"' + EDGE_SMALL + '/>' +
        '<defs><clipPath id="' + clip + '"><path d="' + shape(B) + '"/></clipPath></defs>' +
        '<path d="' + shape(B) + holes + '" fill-rule="evenodd" fill="' + m + '"/>' +
        '<g clip-path="url(#' + clip + ')"><rect x="' + (L - 40) + '" y="' + (B - 22) + '" width="' + (R - L + 80) + '" height="40" fill="' + s + '"/>' + line('M' + (L - 40) + ' ' + (B - 22) + ' H' + (R + 40)) + '</g>' + /* 底（サブ）は下の端のごく細い帯だけ */
        line(shape(B)) +
        c.stitch('path', id + '-top', 'd="M' + (L + 34) + ' ' + (T + 80) + ' H' + (R - 34) + '"') + /* 縫い目だけ（折り目の線は描かない）*/
        grommet(gx[0], T + 34) + grommet(gx[1], T + 34);
    }
    var front = face('sb29f') + embAt(c, cx, T + 170, 48);
    var back = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + face('sb29b') + '</g>';
    /* 底面：楕円の底（サブ）のまわりに側面の革（メイン）の縁。左にひも収納パーツ（サブ）が少し出る 2026.11.02 */
    var bcy = 600, brx = 240, bry = 200;
    var bottom = '<path d="M' + (cx - brx - 30) + ' ' + (bcy - 4) + ' H' + (cx - brx + 6) + ' V' + (bcy + 40) + ' H' + (cx - brx - 30) + ' Q' + (cx - brx - 52) + ' ' + (bcy + 18) + ' ' + (cx - brx - 30) + ' ' + (bcy - 4) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<ellipse cx="' + cx + '" cy="' + bcy + '" rx="' + brx + '" ry="' + bry + '" fill="' + m + '"' + EDGE + '/>' +
      '<ellipse cx="' + cx + '" cy="' + bcy + '" rx="' + (brx - 26) + '" ry="' + (bry - 24) + '" fill="' + s + '"' + EDGE + '/>';
    return frame(c, 'バッグの見本（左から前面・背面・底面）', [
      { box: [L - 70, T - 340, R - L + 140, B - T + 360], core: [T, B - T], body: front },
      { box: [L - 70, T - 340, R - L + 140, B - T + 360], body: back },
      { box: [cx - brx - 70, bcy - bry - 20, 2 * brx + 90, 2 * bry + 40], body: bottom }
    ]);
  };

  /* sb-1-2：ショルダーポーチ。選んだ方だけ描く（c.variant：0＝sb-1 縦長・1＝sb-2 横長。配置は同じ）。core は sb-1 で共通。ネームは描かない。
     ツートン＝底面（起毛の帯）・背面ポケット・サイドの4つのループ（ループとブランドタグはふだんキャメル）。
     前面：フタ（メイン・縫い目は左右の縦）、真ん中に横長の切れ込みとイカリの大ボタン（丸い金具・絵は描かない）、切れ込みの左右に縦の刺繍（左＝緑・右＝赤・選択で変わる）。
     フタの下から底まで真ん中に×の飾り縫い。左右の側面に上下2つずつのループ、下のループに革ひも（いつもキャメル）。
     背面：上の帯に横の縫い目2本、帯の下の真ん中に半月のブランドタグ、大きなポケット（サブ）、底の帯（起毛のサブ）2026.11.02 */
  shapes['sb-1-2'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)', k = 'url(#' + c.uid + '-k)';
    var wide = c.variant === 1, W = wide ? 580 : 440, H = wide ? 430 : 560, B = 860, T = B - H, L = 500 - W / 2, R = L + W, cx = 500, I = INSET;
    var FB = T + (wide ? 135 : 150), BT = B - (wide ? 90 : 95);
    function loops() {
      var g = '';
      [T + 60, BT - 60].forEach(function (y) {
        g += '<rect x="' + (L - 16) + '" y="' + (y - 24) + '" width="26" height="48" rx="5" fill="' + a + '"' + EDGE_SMALL + '/>' +
          '<rect x="' + (R - 10) + '" y="' + (y - 24) + '" width="26" height="48" rx="5" fill="' + a + '"' + EDGE_SMALL + '/>';
      });
      return g;
    }
    var cords = strapLine('M' + (L - 6) + ' ' + (BT - 40) + ' C' + (L - 40) + ' ' + (T - 100) + ' ' + (L - 10) + ' ' + (T - 200) + ' ' + (L + 40) + ' ' + (T - 260), 12, k) +
      strapLine('M' + (R + 6) + ' ' + (BT - 40) + ' C' + (R + 40) + ' ' + (T - 100) + ' ' + (R + 10) + ' ' + (T - 200) + ' ' + (R - 40) + ' ' + (T - 260), 12, k);
    var rect = rrect(L, T, R, B, 10);
    var band = suede('M' + L + ' ' + BT + ' H' + R + ' V' + (B - 10) + ' Q' + R + ' ' + B + ' ' + (R - 10) + ' ' + B + ' H' + (L + 10) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 10) + ' Z', s, true) +
      line('M' + L + ' ' + BT + ' H' + R) + c.stitch('path', 'sb12-band' + c.variant, 'd="M' + (L + 10) + ' ' + (BT + 14) + ' H' + (R - 10) + '"');
    var zz = '', zz2 = '', y0 = FB + 12, n = Math.floor((BT - 8 - y0) / 24);
    for (var i = 0; i <= n; i++) { var yy = y0 + i * 24; zz += (i ? ' L' : 'M') + (cx + (i % 2 ? 12 : -12)) + ' ' + yy; zz2 += (i ? ' L' : 'M') + (cx + (i % 2 ? -12 : 12)) + ' ' + yy; }
    var hy = (T + FB) / 2 + 8;
    var front = cords + loops() + '<path d="' + rect + '" fill="' + m + '"' + EDGE + '/>' + band +
      sStitch(c, 'path', 'sb12-x1', 'd="' + zz + '"') + sStitch(c, 'path', 'sb12-x2', 'd="' + zz2 + '"') +
      '<path d="' + rrect(L - 4, T - 4, R + 4, FB, 12) + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'sb12-flap', 'd="M' + (L + I + 10) + ' ' + (T + 30) + ' V' + (FB - 30) + ' M' + (R - I - 10) + ' ' + (T + 30) + ' V' + (FB - 30) + '"') +
      '<rect x="' + (cx - 78) + '" y="' + (hy - 12) + '" width="156" height="24" rx="12" fill="#000000" fill-opacity="0.35"' + EDGE_SMALL + '/>' +
      reinLine(c, 'M' + (cx - 84) + ' ' + (hy - 12) + ' V' + (hy + 12), 0) + reinLine(c, 'M' + (cx + 84) + ' ' + (hy - 12) + ' V' + (hy + 12), 1) +
      '<circle cx="' + cx + '" cy="' + hy + '" r="40" fill="' + METAL + '"' + EDGE_SMALL + '/><circle cx="' + cx + '" cy="' + hy + '" r="32" fill="none" stroke="#5E5236" stroke-width="3"/>';
    var pL = L + 50, pR = R - 50, pT = T + 125;
    var back = cords + loops() + '<path d="' + rect + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'sb12b-top', 'd="M' + (L + 15) + ' ' + (T + 20) + ' H' + (R - 15) + ' M' + (L + 15) + ' ' + (T + 50) + ' H' + (R - 15) + '"') +
      line('M' + (L + 4) + ' ' + (T + 66) + ' H' + (R - 4)) +
      '<path d="M' + (cx - 34) + ' ' + (T + 66) + ' Q' + (cx - 34) + ' ' + (T + 92) + ' ' + cx + ' ' + (T + 92) + ' Q' + (cx + 34) + ' ' + (T + 92) + ' ' + (cx + 34) + ' ' + (T + 66) + ' Z" fill="' + a + '"' + EDGE_SMALL + '/>' +
      '<rect x="' + pL + '" y="' + pT + '" width="' + (pR - pL) + '" height="' + (BT - pT) + '" fill="' + s + '"' + EDGE + '/>' +
      c.stitch('path', 'sb12b-pocket', 'd="M' + (pL + I) + ' ' + (pT + 10) + ' V' + (BT - 4) + ' M' + (pR - I) + ' ' + (pT + 10) + ' V' + (BT - 4) + '"') + band;
    return frame(c, 'ショルダーポーチの見本（左から前面・背面）', [
      { box: [L - 70, T - 280, W + 140, H + 300], core: [B - 560, 560], body: front },
      { box: [L - 70, T - 280, W + 140, H + 300], body: back }
    ]);
  };
  shapes['sb-1-2'].variants = ['sb-1', 'sb-2'];

  /* ola-15・ola-16：Martillo のオイルレザーのたばこケース（ラウンドファスナー・縦長）。前面・背面。ツートン＝たばこのポケット・ベルト・前後の連結パーツ。
     縦長で描く（向きを変えない）。ハンマーは olk-13 と同じ頭が縦の向き。
     連結パーツ：左の辺の真ん中にかぶる縦の帯（前面と背面で同じ大きさ。背面では右の辺）。ベルト（サブ・先は丸い）は連結パーツから右へ回り、ポケットの上でスナップ。
     ポケット（サブ）は右寄りの縦長、付け根（右）は外周と一緒に縫う。ola-15 は上下（サイド）が外周と別（内側に独立の横の縫い目）、ola-16 は上下も外周と一緒（ポケットは上から下まで）。
     背面：刻印は描かない、ネームは上寄りの真ん中（刻印の下）2026.11.02 */
  function tobacco(c, small) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var W = small ? 300 : 330, H = small ? 450 : 600, B = 860, T = B - H, L = 500 - W / 2, R = L + W, r = small ? 64 : 70, I = INSET, cx = (L + R) / 2, cy = (T + B) / 2;
    var outer = rrect(L, T, R, B, r);
    var zipD = 'M' + (L - 6) + ' ' + (T + r) + ' Q' + (L - 6) + ' ' + (T - 6) + ' ' + (L + r) + ' ' + (T - 6) + ' H' + (R - r) + ' Q' + (R + 6) + ' ' + (T - 6) + ' ' + (R + 6) + ' ' + (T + r) + ' V' + (B - r) + ' Q' + (R + 6) + ' ' + (B + 6) + ' ' + (R - r) + ' ' + (B + 6) + ' H' + (L + r) + ' Q' + (L - 6) + ' ' + (B + 6) + ' ' + (L - 6) + ' ' + (B - r) + ' Z';
    var st = 'x="' + (L + I) + '" y="' + (T + I) + '" width="' + (W - 2 * I) + '" height="' + (H - 2 * I) + '" rx="' + (r - I) + '"';
    var id = small ? 'ola16' : 'ola15';
    var ch = small ? 200 : 230;
    function conn(x) { return '<rect x="' + (x - 27) + '" y="' + (cy - ch / 2) + '" width="54" height="' + ch + '" rx="8" fill="' + s + '"' + EDGE + '/>' + sStitch(c, 'path', id + '-conn' + x, 'd="M' + x + ' ' + (cy - ch / 2 + 12) + ' V' + (cy + ch / 2 - 12) + '"'); }
    var pL = small ? L + 0.3 * W : L + 0.42 * W, pocket;
    if (small) {
      pocket = '<path d="M' + pL + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + pL + ' Z" fill="' + s + '"' + EDGE + '/>';
    } else {
      var pT = T + 34, pB = B - 34;
      pocket = '<path d="M' + pL + ' ' + pT + ' H' + (R - I) + ' V' + pB + ' H' + pL + ' Z" fill="' + s + '"' + EDGE + '/>' +
        sStitch(c, 'path', id + '-pside', 'd="M' + (pL + 14) + ' ' + (pT + 14) + ' H' + (R - I) + ' M' + (pL + 14) + ' ' + (pB - 14) + ' H' + (R - I) + '"');
    }
    var bh = 105, bx = pL + 95;
    var belt = '<path d="M' + (L - 10) + ' ' + (cy - bh / 2) + ' H' + (bx - bh / 2) + ' A' + (bh / 2) + ' ' + (bh / 2) + ' 0 0 1 ' + (bx - bh / 2) + ' ' + (cy + bh / 2) + ' H' + (L - 10) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<circle cx="' + (bx - bh / 2 + 4) + '" cy="' + cy + '" r="22" fill="#C9CCCF"' + EDGE_SMALL + '/>';
    var pull = '<rect x="' + (L - 30) + '" y="' + (T + r - 34) + '" width="22" height="34" rx="5" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>';
    var front = zip(id + '-zipf', zipD) + pull + '<path d="' + outer + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('rect', id + 'f-st', st) +
      pocket + hammerEmb(c, (pL + R) / 2 + 10, T + (small ? 70 : 110), 1.0, 90) + conn(L) + belt;
    var back = zip(id + '-zipb', zipD) + '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + pull + '</g>' +
      '<path d="' + outer + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('rect', id + 'b-st', st) + conn(R) +
      (c.name ? c.name(cx - 75, T + 0.27 * H, 150, 56, m) : '');
    return frame(c, 'たばこケースの見本（左から前面・背面）', [
      { box: [L - 40, B - 640, W + 80, 660], core: [B - 600, 600], body: front },
      { box: [L - 40, B - 640, W + 80, 660], body: back }
    ]);
  }
  shapes['ola-15'] = function (c) { return tobacco(c, false); };
  shapes['ola-16'] = function (c) { return tobacco(c, true); };

  /* ===== ベルトポーチ sb-18、ペンケース・メガネケース ac-29・st-6・st-7・ac-30・ola-30・ac-31 2026.11.02 ===== */

  /* sb-18：茶の縦型ベルトポーチ。前面・背面・サイド。ツートン＝ベルト・ベルトの付け根・マチ（サイド）。ネームは描かない。側面の短い縫い目は無い 2026.11.02
     前面：縦長・角は丸い。上の口にファスナー（布だけ少し見える）、上の左右にカシメ、ベルト通し2本（サブ）。イカリは右下。
     背面：上の左右にベルトの付け根（サブ・小さな革）と金具の輪、そこからベルト（サブ）が上へ。サイド：ファスナーが上から途中まで下り、その下にマチの当て（横の縫い目）2026.11.02 */
  shapes['sb-18'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 290, R = 710, T = 330, B = 880, r = 60, cx = (L + R) / 2, bx = [cx - 120, cx + 120];
    var body = rrect(L, T, R, B, r);
    var top = zip('sb18-zip', 'M' + (L + 50) + ' ' + (T - 2) + ' H' + (R - 50));
    var front = beltLoops(c, 'sb18f-b', bx, T - 250, T + 10, 56, s, false) + top + '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' +
      rivet(bx[0], T + 8, 15) + rivet(bx[1], T + 8, 15) + embAt(c, R - 80, B - 80, 48);
    var back = beltLoops(c, 'sb18b-b', bx, T - 250, T - 60, 56, s, false) + rivet(bx[0], T - 200, 11) + rivet(bx[1], T - 200, 11) +
      ring(bx[0], T - 46, 20, 6) + ring(bx[1], T - 46, 20, 6) + top + '<path d="' + body + '" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M' + (bx[0] - 32) + ' ' + (T - 30) + ' H' + (bx[0] + 32) + ' V' + (T + 50) + ' A32 32 0 0 1 ' + (bx[0] - 32) + ' ' + (T + 50) + ' Z" fill="' + s + '"' + EDGE + '/>' + rivet(bx[0], T + 40, 12) +
      '<path d="M' + (bx[1] - 32) + ' ' + (T - 30) + ' H' + (bx[1] + 32) + ' V' + (T + 50) + ' A32 32 0 0 1 ' + (bx[1] - 32) + ' ' + (T + 50) + ' Z" fill="' + s + '"' + EDGE + '/>' + rivet(bx[1], T + 40, 12);
    var sx = 300, hw = 75, gw = 40, pT = T + 0.55 * (B - T);
    var side = '<path d="' + rrect(sx - hw, T, sx + hw, B, 50) + '" fill="' + s + '"' + EDGE + '/>' + /* サイドはマチ（サブ）2026.11.02 */
      '<rect x="' + (sx - gw / 2) + '" y="' + (T + 4) + '" width="' + gw + '" height="' + (pT - T) + '" rx="' + (gw / 2) + '" fill="' + ZIP_TAPE + '"/>' +
      '<path d="M' + sx + ' ' + (T + 14) + ' V' + (pT - 6) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="12" stroke-dasharray="5 4"/>' +
      sStitch(c, 'path', 'sb18s-z', 'd="M' + (sx - gw / 2 - 12) + ' ' + (T + 24) + ' V' + pT + ' M' + (sx + gw / 2 + 12) + ' ' + (T + 24) + ' V' + pT + '"') +
      line('M' + (sx - hw) + ' ' + (pT + 6) + ' H' + (sx + hw)) +
      sStitch(c, 'path', 'sb18s-p', 'd="M' + (sx - hw + 10) + ' ' + (pT + 22) + ' H' + (sx + hw - 10) + '"');
    return frame(c, 'ベルトポーチの見本（左から前面・背面・サイド）', [
      { box: [L - 20, T - 270, R - L + 40, B - T + 290], core: [T, B - T], body: front },
      { box: [L - 20, T - 270, R - L + 40, B - T + 290], body: back },
      { box: [sx - hw - 20, T - 270, 2 * hw + 40, B - T + 290], body: side }
    ]);
  };

  /* 横長のファスナーポーチ（ac-29・st-6 共通・ゆるい楕円・左右対称）。前面・背面・サイド。ツートン＝マチ・引き手・サイドのブランドタグ（タグはふだんキャメル）。
     上も下もゆるい弧（極端にしない）。上にファスナー（布）。左右と下の外周をマチ（サブ）がふちどる。ファスナーとマチの境に短い横の縫い目。
     イカリは上寄りの真ん中。引き手は倒さず、ファスナーの始まり（左の端）から斜め上へ。ac-29＝細い革、st-6＝丸い引き手。背面：左右反転、ネームは右下寄り。
     サイド：真ん中にファスナー、その終わりを刻印タグが包み、その下はマチが丸く下まで。左右に前後の革が下の端まで 2026.11.02 */
  function zipPouch(c, o) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var W = o.W, H = o.H, B = 760, T = B - H, L = 500 - W / 2, R = L + W, cx = 500, p = 18, yE = T + 0.42 * H, bb = 0.16 * H;
    function shape(l, r, t, b) {
      return 'M' + l + ' ' + yE + ' C' + l + ' ' + (t + 0.05 * H) + ' ' + (l + W * 0.22) + ' ' + t + ' ' + cx + ' ' + t + ' C' + (r - W * 0.22) + ' ' + t + ' ' + r + ' ' + (t + 0.05 * H) + ' ' + r + ' ' + yE +
        ' C' + r + ' ' + (b - 0.05 * H) + ' ' + (r - W * 0.18) + ' ' + b + ' ' + cx + ' ' + b + ' C' + (l + W * 0.18) + ' ' + b + ' ' + l + ' ' + (b - 0.05 * H) + ' ' + l + ' ' + yE + ' Z';
    }
    var arcD = 'M' + L + ' ' + yE + ' C' + L + ' ' + (T + 0.05 * H) + ' ' + (L + W * 0.22) + ' ' + T + ' ' + cx + ' ' + T + ' C' + (R - W * 0.22) + ' ' + T + ' ' + R + ' ' + (T + 0.05 * H) + ' ' + R + ' ' + yE;
    function face(id) {
      var pull = o.disc
        ? '<rect x="' + (L - 16) + '" y="' + (yE - 24) + '" width="18" height="24" rx="4" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' + discPull(L - 22, yE - 42, 24, a)
        : '<g transform="rotate(-35 ' + (L - 2) + ' ' + (yE - 8) + ')">' + slimPull(L - 2, yE - 8, a) + '</g>';
      return pull +
        '<path d="' + shape(L, R, T, B) + '" fill="' + s + '"' + EDGE + '/>' +
        '<path d="' + shape(L + p, R - p, T + 6, B - p) + '" fill="' + m + '"' + EDGE + '/>' +
        '<path d="' + arcD + '" fill="none" stroke="' + ZIP_TAPE + '" stroke-width="22"/>' +
        '<path d="' + arcD + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="8" stroke-dasharray="5 4"/>' +
        '<rect x="' + (R - 6) + '" y="' + (yE - 6) + '" width="16" height="36" rx="4" fill="' + a + '"' + EDGE_SMALL + '/>' +
        sStitch(c, 'path', id + '-e', 'd="M' + (L + 2) + ' ' + (yE + 8) + ' H' + (L + 26) + ' M' + (R - 2) + ' ' + (yE + 8) + ' H' + (R - 26) + '"');
    }
    var front = face(o.id + 'f') + embAt(c, cx, T + 0.3 * H, 44);
    var back = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + face(o.id + 'b') + '</g>' +
      (c.name ? c.name(R - 200, B - 0.4 * H, 150, 56, m) : '');
    var sx = 300, hw = 62, gw = 46, zT = T + 6, zB = T + 0.42 * H;
    var lens = function (x, dir) { return '<path d="M' + x + ' ' + (zT + 10) + ' Q' + (x + dir * (hw - gw / 2) * 2) + ' ' + ((zT + B) / 2) + ' ' + x + ' ' + (B - 2) + ' Z" fill="' + m + '"' + EDGE + '/>'; };
    var side = lens(sx - gw / 2, -1) + lens(sx + gw / 2, 1) +
      '<path d="M' + (sx - gw / 2) + ' ' + zB + ' H' + (sx + gw / 2) + ' V' + (B - gw / 2) + ' A' + (gw / 2) + ' ' + (gw / 2) + ' 0 0 1 ' + (sx - gw / 2) + ' ' + (B - gw / 2) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<rect x="' + (sx - gw / 2) + '" y="' + zT + '" width="' + gw + '" height="' + (zB - zT + 10) + '" rx="' + (gw / 2) + '" fill="' + ZIP_TAPE + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + sx + ' ' + (zT + 16) + ' V' + (zB - 8) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="12" stroke-dasharray="5 4"/>' +
      '<rect x="' + (sx - 12) + '" y="' + (zB - 12) + '" width="24" height="14" rx="3" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + (sx - gw / 2 - 3) + ' ' + zB + ' H' + (sx + gw / 2 + 3) + ' V' + (zB + 50) + ' Q' + (sx + gw / 2 + 3) + ' ' + (zB + 68) + ' ' + sx + ' ' + (zB + 68) + ' Q' + (sx - gw / 2 - 3) + ' ' + (zB + 68) + ' ' + (sx - gw / 2 - 3) + ' ' + (zB + 50) + ' Z" fill="' + a + '"' + EDGE_SMALL + '/>' +
      sStitch(c, 'path', o.id + 's-tag', 'd="M' + (sx - gw / 2 + 6) + ' ' + (zB + 12) + ' H' + (sx + gw / 2 - 6) + '"');
    return frame(c, 'ポーチの見本（左から前面・背面・サイド）', [
      { box: [L - 80, T - 90, W + 150, H + 110], core: [B - o.coreH, o.coreH], body: front },
      { box: [L - 70, T - 90, W + 150, H + 110], body: back },
      { box: [sx - hw - 20, T - 90, 2 * hw + 40, H + 110], body: side }
    ]);
  }
  shapes['ac-29'] = function (c) { return zipPouch(c, { id: 'ac29', W: 680, H: 270, coreH: 270 }); };
  /* st-6：ac-29 と同じ作りで細長く低い（ゆるいオーバル・左右対称）。丸い引き手（ふだんキャメル）。S・M（M は一回り大きい）2026.11.02 */
  shapes['st-6'] = function (c) {
    var M = c.variant === 1;
    return zipPouch(c, { id: M ? 'st6m' : 'st6s', W: M ? 720 : 660, H: M ? 235 : 200, coreH: 235, disc: true });
  };
  shapes['st-6'].variants = ['S', 'M'];

  /* st-7：箱形のファスナーペンケース。斜め上から見た絵（前の面・上の面・右の端の面）。サイズは番号ではなく名前で引く（今：XS・S・M。予定では新しい XS ができて名前が1つずつずれる）。
     ベロ（サブ）の有無もサイズの表に持たせる（今の XS はベロなし）。前面・背面・サイド。ツートン＝引き手（丸い・ふだんキャメル）とサイドのベロ。
     上の面の真ん中にファスナーとその両側に縫い目。イカリは前の面の真ん中。丸い引き手は左の端から斜め上へ。背面：左右反転、ネームは前の面の右下（全サイズ共通）。
     右の端の面：ファスナーの終わりの下にベロ（下が半円）、ベロなしは縦の合わせ目 2026.11.02 */
  var ST7_SIZES = {
    'XS': { W: 600, H: 165, D: 150, bero: false },
    'S': { W: 620, H: 210, D: 190, bero: true },
    'M': { W: 680, H: 240, D: 215, bero: true }
  };
  var ST7_MAX_H = 240 + 215 * 0.42;
  function boxPen(c, sizeName) {
    var z = ST7_SIZES[sizeName] || ST7_SIZES['S'];
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)', a = 'url(#' + c.uid + '-a)';
    var W = z.W, H = z.H, D = z.D, ox = D * 0.42, oy = D * 0.42, B = 760, T = B - H, L = 470 - W / 2, R = L + W, cx = (L + R) / 2;
    var topF = 'M' + L + ' ' + T + ' L' + (L + ox) + ' ' + (T - oy) + ' H' + (R + ox) + ' L' + R + ' ' + T + ' Z';
    var endF = 'M' + R + ' ' + T + ' L' + (R + ox) + ' ' + (T - oy) + ' V' + (B - oy) + ' L' + R + ' ' + B + ' Z';
    var zy = T - oy / 2, zx0 = L + ox / 2 + 10, zx1 = R + ox / 2;
    function body(id, withName) {
      var g = '<path d="' + topF + '" fill="' + m + '"/><path d="' + topF + '" fill="#FFFFFF" fill-opacity="0.08"/>' +
        '<path d="' + endF + '" fill="' + m + '"/><path d="' + endF + '" fill="#000000" fill-opacity="0.12"/>' +
        '<rect x="' + L + '" y="' + T + '" width="' + W + '" height="' + H + '" fill="' + m + '"/>' +
        line(topF) + line(endF) + line('M' + L + ' ' + T + ' H' + R + ' V' + B + ' H' + L + ' Z') +
        zip(id + '-z', 'M' + zx0 + ' ' + zy + ' H' + zx1) +
        c.stitch('path', id + '-st', 'd="M' + zx0 + ' ' + (zy - 18) + ' H' + (zx1 - 6) + ' M' + zx0 + ' ' + (zy + 18) + ' H' + (zx1 - 6) + '"') +
        '<rect x="' + (zx0 - 22) + '" y="' + (zy - 10) + '" width="22" height="20" rx="4" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' + discPull(zx0 - 30, zy - 26, 22, a);
      var ex = R + ox / 2, ey = T - oy / 2 + 14;
      if (z.bero) {
        var bw = 0.5 * ox + 30;
        g += '<path d="M' + (ex - bw / 2) + ' ' + ey + ' H' + (ex + bw / 2) + ' V' + (ey + 40) + ' A' + (bw / 2) + ' ' + (bw / 2) + ' 0 0 1 ' + (ex - bw / 2) + ' ' + (ey + 40) + ' Z" fill="' + s + '"' + EDGE + '/>';
      } else {
        g += line('M' + ex + ' ' + ey + ' L' + ex + ' ' + (B - oy / 2));
      }
      return g;
    }
    var front = body('st7f' + sizeName) + embAt(c, cx, (T + B) / 2 + 4, 44);
    var back = '<g transform="translate(' + (2 * cx + ox) + ' 0) scale(-1 1)">' + body('st7b' + sizeName) + '</g>' +
      (c.name ? c.name(R + ox - 200 - (R - cx) + (R - cx) - 0, B - 0.42 * H, 150, 56, m) : '');
    var sx = 300, sL = sx - D / 2, sR = sx + D / 2, zB = T + 0.45 * H;
    var side = '<path d="' + rrect(sL, T, sR, B, 30) + '" fill="' + m + '"' + EDGE + '/>' +
      '<rect x="' + (sx - 18) + '" y="' + (T + 2) + '" width="36" height="' + (zB - T) + '" rx="8" fill="' + ZIP_TAPE + '"/>' +
      '<path d="M' + sx + ' ' + (T + 8) + ' V' + (zB - 8) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="12" stroke-dasharray="5 4"/>' +
      '<rect x="' + (sx - 12) + '" y="' + (zB - 12) + '" width="24" height="14" rx="3" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
      sStitch(c, 'path', 'st7s-z' + sizeName, 'd="M' + (sx - 30) + ' ' + (T + 8) + ' V' + zB + ' M' + (sx + 30) + ' ' + (T + 8) + ' V' + zB + '"');
    if (z.bero) {
      var bw2 = 0.55 * D;
      side += '<path d="M' + (sx - bw2 / 2) + ' ' + (zB - 4) + ' H' + (sx + bw2 / 2) + ' V' + (zB + 30) + ' A' + (bw2 / 2) + ' ' + (bw2 / 2) + ' 0 0 1 ' + (sx - bw2 / 2) + ' ' + (zB + 30) + ' Z" fill="' + s + '"' + EDGE + '/>';
    } else {
      side += line('M' + sx + ' ' + zB + ' V' + (B - 2));
    }
    return frame(c, 'ペンケースの見本（左から前面・背面・サイド）', [
      { box: [L - 80, B - ST7_MAX_H - 40, 800, ST7_MAX_H + 60], core: [B - ST7_MAX_H, ST7_MAX_H], body: front },
      { box: [L - 20, B - ST7_MAX_H - 40, 800, ST7_MAX_H + 60], body: back },
      { box: [sx - 130, B - ST7_MAX_H - 40, 260, ST7_MAX_H + 60], body: side }
    ]);
  }
  /* 選んだサイズの名前（c.variantName）で引く。無い時は番号から今の並びで読む */
  shapes['st-7'] = function (c) { return boxPen(c, c.variantName || ['S', 'M'][c.variant || 0]); };
  shapes['st-7'].variants = ['S', 'M'];
  shapes['st-7-xs'] = function (c) { return boxPen(c, 'XS'); };

  /* メガネケース（ac-30・ola-30 共通）：差し込み式・縦長。前面：右上が大きく丸い、左は折り目（縫い目なし）、縫い目は上の弧・右・下。刺繍は上寄りの真ん中。
     背面：左右反転。ネーム：ac-30＝下寄りの真ん中、ola-30＝左下寄り。ツートンなし 2026.11.02 */
  function glassCase(c, hammer, nameLeft) {
    var m = 'url(#' + c.uid + '-m)';
    var L = 340, R = 660, T = 200, B = 820, rr = 160, I = INSET, cx = (L + R) / 2;
    var out = 'M' + (L + 8) + ' ' + T + ' H' + (R - rr) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + rr) + ' V' + (B - 8) + ' Q' + R + ' ' + B + ' ' + (R - 8) + ' ' + B + ' H' + (L + 8) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 8) + ' V' + (T + 8) + ' Q' + L + ' ' + T + ' ' + (L + 8) + ' ' + T + ' Z';
    var st = 'd="M' + (L + 18) + ' ' + (T + I) + ' H' + (R - rr) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + rr) + ' V' + (B - I) + ' H' + (L + 18) + '"';
    var front = '<path d="' + out + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'glf', st) + (hammer ? hammerEmb(c, cx - 10, T + 120, 1.2) : embAt(c, cx - 10, T + 130, 52));
    var back = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)"><path d="' + out + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'glb', st) + '</g>' +
      (c.name ? c.name(nameLeft ? L + 40 : cx - 80, B - 120, 160, 60, m) : '');
    return frame(c, 'メガネケースの見本（左から前面・背面）', [
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], body: back }
    ]);
  }
  shapes['ac-30'] = function (c) { return glassCase(c, false, false); };
  shapes['ola-30'] = function (c) { return glassCase(c, true, true); };

  /* ac-31：横長のペンケース（差し込み式・1本差し）。前面・背面。ツートンなし。
     前面：左の端と上の辺に縫い目、下は折り目。右の端が口：前の革が右下へ丸くえぐれ、中の起毛（後ろの革の裏）がのぞく。イカリは真ん中より左寄り。
     背面：左右反転（縫い目は上と右の端）、ネームは右の端寄り 2026.11.02 */
  shapes['ac-31'] = function (c) {
    var m = 'url(#' + c.uid + '-m)';
    var L = 100, R = 900, T = 420, B = 580, I = INSET, k = 14;
    var full = 'M' + (L + 6) + ' ' + T + ' H' + (R - k) + ' L' + R + ' ' + (T + k) + ' V' + (B - 6) + ' Q' + R + ' ' + B + ' ' + (R - 6) + ' ' + B + ' H' + (L + 6) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 6) + ' V' + (T + 6) + ' Q' + L + ' ' + T + ' ' + (L + 6) + ' ' + T + ' Z';
    var frontLeather = 'M' + (L + 6) + ' ' + T + ' H' + (R - 125) + ' C' + (R - 118) + ' ' + (T + 70) + ' ' + (R - 60) + ' ' + (B - 50) + ' ' + R + ' ' + (B - 48) + ' V' + (B - 6) + ' Q' + R + ' ' + B + ' ' + (R - 6) + ' ' + B + ' H' + (L + 6) + ' Q' + L + ' ' + B + ' ' + L + ' ' + (B - 6) + ' V' + (T + 6) + ' Q' + L + ' ' + T + ' ' + (L + 6) + ' ' + T + ' Z';
    var front = suede(full, m, false) + '<path d="' + frontLeather + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'ac31f', 'd="M' + (R - 140) + ' ' + (T + I) + ' H' + (L + I) + ' V' + (B - 10) + '"') +
      embAt(c, L + 0.45 * (R - L), (T + B) / 2, 46);
    var back = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)"><path d="' + full + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('path', 'ac31b', 'd="M' + (R - 140) + ' ' + (T + I) + ' H' + (L + I) + ' V' + (B - 10) + '"') + '</g>' +
      (c.name ? c.name(R - 200, (T + B) / 2 - 2, 140, 54, m) : ''); /* もう少し下 2026.11.02 */
    return frame(c, 'ペンケースの見本（左から前面・背面）', [
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 20, T - 20, R - L + 40, B - T + 40], body: back }
    ]);
  };

  /* ===== ティッシュケース・タブレットケース・丸い/四角いポーチ・マグカバー・靴べら ac-17・ac-18・ac-38-39・lm-8・lm-9・st-13・ac-48・ac-49 2026.11.02 ===== */

  /* ac-17：ポケットティッシュケース。前面・背面。ツートンなし。タグはいつもキャメル（uid-k）。
     縫い目は左右の縦だけ（上下は折り目）。真ん中より少し上に横の取り出し口（上の革が下の革に重なる・ゆるい弧）。イカリは口の下の真ん中。
     右の辺の下寄りに丸い刻印タグ（文字なし）が外へ出る。背面は無地、タグは左、ネームは右下寄り 2026.11.02 */
  shapes['ac-17'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', k = 'url(#' + c.uid + '-k)';
    var L = 200, R = 800, T = 300, B = 690, I = INSET, cx = (L + R) / 2, my = T + 0.47 * (B - T);
    var rect = rrect(L, T, R, B, 8);
    var sides = 'd="M' + (L + I + 4) + ' ' + (T + 18) + ' V' + (B - 18) + ' M' + (R - I - 4) + ' ' + (T + 18) + ' V' + (B - 18) + '"';
    function tag(x, dir) { return '<path d="M' + x + ' ' + (B - 135) + ' H' + (x + dir * 22) + ' A30 30 0 0 ' + (dir > 0 ? 1 : 0) + ' ' + (x + dir * 22) + ' ' + (B - 75) + ' H' + x + ' Z" fill="' + k + '"' + EDGE_SMALL + '/>'; }
    var front = tag(R - 4, 1) + '<path d="' + rect + '" fill="' + m + '"' + EDGE + '/>' +
      '<path d="M' + (L + 28) + ' ' + (my + 10) + ' Q' + cx + ' ' + (my - 10) + ' ' + (R - 28) + ' ' + (my - 6) + ' V' + (my + 14) + ' Q' + cx + ' ' + my + ' ' + (L + 28) + ' ' + (my + 24) + ' Z" fill="#000000" fill-opacity="0.35"/>' +
      line('M' + (L + 28) + ' ' + (my + 10) + ' Q' + cx + ' ' + (my - 10) + ' ' + (R - 28) + ' ' + (my - 6)) +
      c.stitch('path', 'ac17f', sides) + embAt(c, cx, my + 105, 54);
    var back = tag(L + 4, -1) + '<path d="' + rect + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'ac17b', sides) +
      (c.name ? c.name(R - 230, B - 120, 160, 60, m) : '');
    return frame(c, 'ティッシュケースの見本（左から前面・背面）', [
      { box: [L - 50, T - 20, R - L + 100, B - T + 40], core: [T, B - T], body: front },
      { box: [L - 50, T - 20, R - L + 100, B - T + 40], body: back }
    ]);
  };

  /* ac-18：ボックスティッシュケース。斜め上から見た箱（前の面・上の面・右の端の面）。前面・背面。ツートン＝マチ（端の面）。
     ふだんのマチは基本の組み合わせの色（uid-p）、ツートンを選んだらサブ。上の面の取り出し口から白いティッシュが出る。
     上の面（ふた）の左右の端は帯になり、スナップで端の面に留める。前の面は四角く縫い目が回る。
     前面：イカリは前の面の上寄りの真ん中、ネームは前の面の右下。背面：前の面の右下にブランド刻印のタグ（文字なし・縫い目）2026.11.03 */
  function tissueBox(c, back) {
    var m = 'url(#' + c.uid + '-m)', p = 'url(#' + c.uid + '-p)';
    var W = 700, H = 210, D = 230, ox = D * 0.45, oy = D * 0.42, L = 140, R = L + W, B = 700, T = B - H, I = INSET, cx = (L + R) / 2;
    var topF = 'M' + L + ' ' + T + ' L' + (L + ox) + ' ' + (T - oy) + ' H' + (R + ox) + ' L' + R + ' ' + T + ' Z';
    var endF = 'M' + R + ' ' + T + ' L' + (R + ox) + ' ' + (T - oy) + ' V' + (B - oy) + ' L' + R + ' ' + B + ' Z';
    var oyM = T - oy / 2, oxL = L + ox / 2 + 90, oxR = R + ox / 2 - 90;
    var tissue = '<path d="M' + (oxL + 30) + ' ' + (oyM + 4) + ' C' + (oxL + 40) + ' ' + (oyM - 120) + ' ' + (cx + 40) + ' ' + (oyM - 200) + ' ' + (cx + ox / 2 + 60) + ' ' + (oyM - 170) + ' C' + (oxR - 40) + ' ' + (oyM - 150) + ' ' + (oxR) + ' ' + (oyM - 70) + ' ' + (oxR - 20) + ' ' + (oyM + 4) + ' Z" fill="#FCF6E8" stroke="#BFB8A8" stroke-width="3" stroke-linejoin="round"/>';
    var g = '<path d="' + endF + '" fill="' + p + '"/>' + line(endF) +
      sStitch(c, 'path', 'ac18-end' + (back ? 'b' : 'f'), 'd="M' + (R + 14) + ' ' + (T + 6) + ' L' + (R + ox - 12) + ' ' + (T - oy + 18) + ' V' + (B - oy - 12) + ' L' + (R + 14) + ' ' + (B - 16) + '"') +
      '<path d="' + topF + '" fill="' + m + '"/>' + line(topF) +
      '<path d="M' + oxL + ' ' + oyM + ' H' + oxR + '" stroke="#2A2A2A" stroke-width="10" stroke-linecap="round"/>' + tissue +
      '<rect x="' + L + '" y="' + T + '" width="' + W + '" height="' + H + '" fill="' + m + '"' + EDGE + '/>' +
      c.stitch('rect', 'ac18-st' + (back ? 'b' : 'f'), 'x="' + (L + I) + '" y="' + (T + I) + '" width="' + (W - 2 * I) + '" height="' + (H - 2 * I) + '" rx="3"') +
      ''; /* 端の面に帯・金具は無い。メインは端の面にかぶらない 2026.11.03 */
    if (back) {
      g += '<rect x="' + (R - 200) + '" y="' + (B - 90) + '" width="150" height="58" rx="5" fill="' + m + '"' + EDGE_SMALL + '/>' +
        c.stitch('rect', 'ac18-tag', 'x="' + (R - 192) + '" y="' + (B - 82) + '" width="134" height="42" rx="3"');
    } else {
      g += embAt(c, cx, T + 60, 48) + (c.name ? c.name(R - 190, B - 84, 120, 46, m) : '');
    }
    return g;
  }
  shapes['ac-18'] = function (c) {
    var box = [120, 230, 900, 490];
    return frame(c, 'ティッシュケースの見本（左から前面・背面）', [
      { box: box, core: [490, 210], body: tissueBox(c, false) },
      { box: box, body: tissueBox(c, true) }
    ]);
  };

  /* ac-38-39：タブレットケースのカバー。選んだ方だけ描く（c.variant：0＝ac-38 標準・1＝ac-39 ミニ）。前面・背面。ツートンなし。
     前面：横長、左の辺は口（縫い目なし）、縫い目は上と右、下は折り目。左下に四角い切り欠き（中のケースが見える）。イカリは上寄りの真ん中。
     背面：左右反転、ネームは右下寄り（ac-38・ac-39 共通）2026.11.02 */
  shapes['ac-38-39'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', mini = c.variant === 1;
    var W = mini ? 430 : 660, H = mini ? 290 : 380, B = 720, T = B - H, L = 500 - W / 2, R = L + W, I = INSET, r = 22;
    var nL = L + (mini ? 50 : 70), nR = nL + (mini ? 120 : 150), nT = B - (mini ? 50 : 70);
    var out = 'M' + L + ' ' + T + ' H' + (R - r) + ' Q' + R + ' ' + T + ' ' + R + ' ' + (T + r) + ' V' + (B - r) + ' Q' + R + ' ' + B + ' ' + (R - r) + ' ' + B + ' H' + nR + ' V' + nT + ' H' + nL + ' V' + B + ' H' + L + ' Z';
    var inner = '<rect x="' + (nL - 4) + '" y="' + (nT - 4) + '" width="' + (nR - nL + 8) + '" height="' + (B - nT + 4) + '" fill="#2A2A2A"/><rect x="' + (nL - 4) + '" y="' + (nT + 2) + '" width="' + (nR - nL + 8) + '" height="10" fill="#C9C2A8"/>';
    var st = 'd="M' + (L + 10) + ' ' + (T + I) + ' H' + (R - r) + ' Q' + (R - I) + ' ' + (T + I) + ' ' + (R - I) + ' ' + (T + r) + ' V' + (B - 12) + '"';
    var front = inner + '<path d="' + out + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'ac38f', st) + embAt(c, L + 0.47 * W, T + 0.24 * H, 48);
    var back = '<g transform="translate(' + (L + R) + ' 0) scale(-1 1)">' + inner + '<path d="' + out + '" fill="' + m + '"' + EDGE + '/>' + c.stitch('path', 'ac38b', st) + '</g>' +
      (c.name ? c.name(R - (mini ? 200 : 290), B - (mini ? 150 : 170), 140, 52, m) : ''); /* 切り欠きから離す 2026.11.03 */
    return frame(c, 'タブレットケースの見本（左から前面・背面）', [
      { box: [170 - 20, 340 - 20, 700, 420], core: [340, 380], body: front },
      { box: [170 - 20, 340 - 20, 700, 420], body: back }
    ]);
  };
  shapes['ac-38-39'].variants = ['ac-38', 'ac-39'];

  /* lm-8・lm-9：丸い／四角いファスナーポーチ。正面・背面・マチ。ツートン＝マチ・引き手・サイドのタグ。
     正面：外周をマチ（サブ）の細い縁がふちどる。左上から細長い革の引き手（サブ）が垂れる。刺繍は正面に無い。背面：左右反転、ネームは右下寄り。
     マチ：縦長。上から下近くまでファスナー（両縁に縫い目）。終わりを下が半円のタグ（サブ）が包み、上の辺に縫い目、タグにイカリ。左右に前後の革のふくらみ 2026.11.02 */
  function lmPouch(c, square) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var cx = 500, cy = 500, R = 260, rim = 12;
    var outer, inner;
    if (square) {
      var h = 250, k = 14, rr = 50;
      var sq = function (e) { var a = h - e, kk = k; return 'M' + (cx - a + rr) + ' ' + (cy - a) + ' Q' + cx + ' ' + (cy - a + kk) + ' ' + (cx + a - rr) + ' ' + (cy - a) + ' Q' + (cx + a) + ' ' + (cy - a) + ' ' + (cx + a) + ' ' + (cy - a + rr) + ' Q' + (cx + a - kk) + ' ' + cy + ' ' + (cx + a) + ' ' + (cy + a - rr) + ' Q' + (cx + a) + ' ' + (cy + a) + ' ' + (cx + a - rr) + ' ' + (cy + a) + ' Q' + cx + ' ' + (cy + a - kk) + ' ' + (cx - a + rr) + ' ' + (cy + a) + ' Q' + (cx - a) + ' ' + (cy + a) + ' ' + (cx - a) + ' ' + (cy + a - rr) + ' Q' + (cx - a + kk) + ' ' + cy + ' ' + (cx - a) + ' ' + (cy - a + rr) + ' Q' + (cx - a) + ' ' + (cy - a) + ' ' + (cx - a + rr) + ' ' + (cy - a) + ' Z'; };
      outer = sq(0); inner = sq(rim); R = h;
    } else {
      outer = 'M' + (cx - R) + ' ' + cy + ' A' + R + ' ' + R + ' 0 1 1 ' + (cx + R) + ' ' + cy + ' A' + R + ' ' + R + ' 0 1 1 ' + (cx - R) + ' ' + cy + ' Z';
      inner = 'M' + (cx - R + rim) + ' ' + cy + ' A' + (R - rim) + ' ' + (R - rim) + ' 0 1 1 ' + (cx + R - rim) + ' ' + cy + ' A' + (R - rim) + ' ' + (R - rim) + ' 0 1 1 ' + (cx - R + rim) + ' ' + cy + ' Z';
    }
    var px = square ? cx - R + 4 : cx - R * 0.89, py = square ? cy - R + 95 : cy - R * 0.45; /* マチの上の端より少しだけ下 2026.11.03 */
    var pull = '<rect x="' + (px - 6) + '" y="' + (py - 8) + '" width="16" height="16" rx="3" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + (px - 4) + ' ' + (py - 6) + ' L' + (px - 70) + ' ' + (py - 88) + ' L' + (px - 56) + ' ' + (py - 98) + ' L' + (px + 8) + ' ' + (py - 14) + ' Z" fill="' + s + '"' + EDGE + '/>'; /* スライダーから外へ斜め上に立ち上げる 2026.11.03 */
    function face() { return '<path d="' + outer + '" fill="' + s + '"' + EDGE + '/>' + '<path d="' + inner + '" fill="' + m + '"' + EDGE + '/>' + pull; } /* 引き手は本体の上に描く */
    var front = face();
    var back = '<g transform="translate(' + (2 * cx) + ' 0) scale(-1 1)">' + face() + '</g>' + (c.name ? c.name(square ? cx + R * 0.45 : cx + R * 0.3, square ? cy + R * 0.6 : cy + R * 0.42, 70, 28, m) : ''); /* lm-9 はもっと右下 2026.11.03 */ /* ネームは約4cm（本体約35cm）2026.11.03 */
    /* マチ：ファスナーは上の約25％だけ、その終わりをタグ（サブ・イカリ）が包み、残り約75％はマチの革（サブ）。引き手はスライダーから斜め上へ 2026.11.03 */
    var sx = 300, hw = 95, gw = 60, T = cy - R, B = cy + R, tT = T + 0.5 * R;
    var lens = function (x, dir) { return '<path d="M' + x + ' ' + (T + 20) + ' Q' + (x + dir * (hw - gw / 2) * 2) + ' ' + cy + ' ' + x + ' ' + (B - 20) + ' Z" fill="' + m + '"' + EDGE + '/>'; };
    var side = lens(sx - gw / 2, -1) + lens(sx + gw / 2, 1) +
      '<rect x="' + (sx - gw / 2) + '" y="' + T + '" width="' + gw + '" height="' + (B - T) + '" rx="' + (gw / 2) + '" fill="' + s + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'lm-g' + (square ? 9 : 8), 'd="M' + (sx - gw / 2 + 10) + ' ' + (tT + 40) + ' V' + (B - 30) + ' M' + (sx + gw / 2 - 10) + ' ' + (tT + 40) + ' V' + (B - 30) + '"') +
      '<rect x="' + (sx - 12) + '" y="' + (T + 14) + '" width="24" height="' + (tT - T - 10) + '" rx="10" fill="' + ZIP_TAPE + '"/>' +
      '<path d="M' + sx + ' ' + (T + 22) + ' V' + (tT - 6) + '" fill="none" stroke="' + ZIP_TEETH + '" stroke-width="9" stroke-dasharray="5 4"/>' +
      sStitch(c, 'path', 'lm-z' + (square ? 9 : 8), 'd="M' + (sx - 21) + ' ' + (T + 24) + ' V' + tT + ' M' + (sx + 21) + ' ' + (T + 24) + ' V' + tT + '"') +
      '<path d="M' + (sx - gw / 2 - 4) + ' ' + tT + ' H' + (sx + gw / 2 + 4) + ' V' + (tT + 40) + ' A' + (gw / 2 + 4) + ' ' + (gw / 2 + 4) + ' 0 0 1 ' + (sx - gw / 2 - 4) + ' ' + (tT + 40) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      sStitch(c, 'path', 'lm-t' + (square ? 9 : 8), 'd="M' + (sx - gw / 2 + 6) + ' ' + (tT + 12) + ' H' + (sx + gw / 2 - 6) + '"') +
      embAt(c, sx, tT + 50, 34) +
      '<rect x="' + (sx - 9) + '" y="' + (tT - 22) + '" width="18" height="16" rx="3" fill="' + ZIP_TEETH + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + (sx + 4) + ' ' + (tT - 18) + ' L' + (sx + 64) + ' ' + (tT - 110) + ' L' + (sx + 78) + ' ' + (tT - 100) + ' L' + (sx + 14) + ' ' + (tT - 8) + ' Z" fill="' + s + '"' + EDGE + '/>';
    return frame(c, 'ポーチの見本（左から正面・背面・マチ）', [
      { box: [cx - R - 100, cy - R - 110, 2 * R + 120, 2 * R + 130], core: [cy - R, 2 * R], body: front },
      { box: [cx - R - 20, cy - R - 110, 2 * R + 120, 2 * R + 130], body: back },
      { box: [sx - hw - 20, cy - R - 110, 2 * hw + 120, 2 * R + 130], body: side }
    ]);
  }
  shapes['lm-8'] = function (c) { return lmPouch(c, false); };
  shapes['lm-9'] = function (c) { return lmPouch(c, true); };

  /* st-13：マグカップカバー（筒形・持ち手付き）。正面・背面・マチ（横）。ツートン＝持ち手・本体上部（上の帯）・タグ。糸は白糸。
     上下の縁と上の帯は直線（丸みなし）。円柱なのでどの画像も幅は同じ。
     正面：持ち手は後ろ（見えない）。イカリ（帯の真ん中）・タグ（帯のすぐ下）・ネーム（タグの下）は左右の真ん中にそろえる。
     背面：持ち手（サブ）が真ん中。上下の付け根はベルト（サブ）で、上は帯の上近くまで伸びてカシメ、下も同じ。持ち手の真ん中に巻いた革（縫い目1本）。
     マチ（横）：同じ幅の筒の右に持ち手が C 字に出る。上下の付け根はベルトとカシメ、真ん中に巻いた革と縫い目 2026.11.03 */
  shapes['st-13'] = function (c) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var L = 330, R = 670, T = 280, B = 820, BT = T + 120, W = R - L, cx = (L + R) / 2;
    function cylBody(l, id) {
      var r = l + W;
      return '<rect x="' + l + '" y="' + T + '" width="' + W + '" height="' + (B - T) + '" rx="6" fill="' + m + '"' + EDGE + '/>' +
        '<rect x="' + (l - 4) + '" y="' + T + '" width="' + (W + 8) + '" height="' + (BT - T) + '" rx="4" fill="' + s + '"' + EDGE + '/>' +
        sStitch(c, 'path', id + '-b', 'd="M' + l + ' ' + (T + 18) + ' H' + r + ' M' + l + ' ' + (BT - 18) + ' H' + r + ' M' + l + ' ' + (B - 18) + ' H' + r + '"');
    }
    var front = cylBody(L, 'st13f') + embAt(c, cx, T + 60, 50) +
      '<path d="M' + (cx - 50) + ' ' + (BT + 4) + ' H' + (cx + 50) + ' V' + (BT + 34) + ' A50 30 0 0 1 ' + (cx - 50) + ' ' + (BT + 34) + ' Z" fill="' + s + '"' + EDGE_SMALL + '/>' +
      (c.name ? c.name(cx - 75, BT + 110, 150, 56, m) : '');
    /* 背面：上の付け根は帯が上の縁にクルッと巻き付く（カシメなし）。下の付け根はカシメ。持ち手は大きく、真ん中の巻いた革は約7cm（持ち手の大部分）2026.11.03 */
    var bw = 46, dT = B - 210, dB = B - 70;
    var back = cylBody(L, 'st13b') +
      sStitch(c, 'path', 'st13b-seam', 'd="M' + (cx + 46) + ' ' + (BT + 14) + ' V' + (B - 30) + '"') +
      '<path d="M' + (cx - bw / 2) + ' ' + (T + 70) + ' V' + (T - 6) + ' Q' + (cx - bw / 2) + ' ' + (T - 22) + ' ' + cx + ' ' + (T - 22) + ' Q' + (cx + bw / 2) + ' ' + (T - 22) + ' ' + (cx + bw / 2) + ' ' + (T - 6) + ' V' + (T + 70) + ' Z" fill="' + s + '"' + EDGE + '/>' +
      '<rect x="' + (cx - bw / 2) + '" y="' + dT + '" width="' + bw + '" height="' + (dB - dT) + '" rx="10" fill="' + s + '"' + EDGE + '/>' + rivet(cx, dB - 24, 12) +
      '<rect x="' + (cx - 46) + '" y="' + (T + 56) + '" width="92" height="' + (0.62 * (B - T) - 66) + '" rx="30" fill="' + s + '"' + EDGE + '/>' + /* 巻いた革は横と同じ上下の範囲 */
      sStitch(c, 'path', 'st13b-h', 'd="M' + cx + ' ' + (T + 70) + ' V' + (T + 0.62 * (B - T) - 24) + '"');
    /* マチ（横）：持ち手の形は写真どおり（上は縁にクルッと巻き付いて外へ・巻いた革が外側の弧のほとんど・下は細い帯が左下へ斜めに筒の右の端へ）。カシメ・タブは描かない */
    /* マチ（横）：持ち手の上の付け根は帯の下の端と同じ高さから生え、筒の右の端に沿って上がり、上の縁でクルッと回って外へ出る。
       丸み（R）は上（縁で回る所）と下（筒へ戻る所）だけ。間はゆるやかな直線で、そこに巻いた革（背面と同じ上下の範囲）。下の付け根は細い帯で筒の右の端へ。カシメ・タブは描かない 2026.11.03 */
    var sL = 300, sR = sL + W, ox = 150, yA = T + 46, yB = T + 0.62 * (B - T), yIn = yB + 60;
    var strap = function (d, w, f) { return '<path d="' + d + '" fill="none" stroke="#111111" stroke-width="' + (w + 8) + '" stroke-linecap="round" stroke-linejoin="round"/><path d="' + d + '" fill="none" stroke="' + f + '" stroke-width="' + w + '" stroke-linecap="round" stroke-linejoin="round"/>'; };
    var hd = 'M' + (sR + 4) + ' ' + BT + ' V' + (T + 10) + ' Q' + (sR + 4) + ' ' + (T - 14) + ' ' + (sR + 40) + ' ' + (T - 10) + ' Q' + (sR + ox - 10) + ' ' + (T) + ' ' + (sR + ox) + ' ' + yA +
      ' L' + (sR + ox + 16) + ' ' + (yB - 30) + ' Q' + (sR + ox + 18) + ' ' + yB + ' ' + (sR + ox - 30) + ' ' + (yB + 18) + ' L' + (sR + 2) + ' ' + yIn;
    var side = cylBody(sL, 'st13s') +
      sStitch(c, 'path', 'st13s-seam', 'd="M' + (sR - 16) + ' ' + (BT + 14) + ' V' + (yIn + 40) + '"') +
      strap(hd, 22, s) +
      strap('M' + (sR + ox + 2) + ' ' + (yA + 10) + ' L' + (sR + ox + 15) + ' ' + (yB - 40), 46, s) +
      sStitch(c, 'path', 'st13s-h', 'd="M' + (sR + ox + 16) + ' ' + (yA + 14) + ' L' + (sR + ox + 29) + ' ' + (yB - 44) + '"');
    return frame(c, 'マグカバーの見本（左から正面・背面・マチ）', [
      { box: [L - 20, T - 40, W + 40, B - T + 60], core: [T, B - T], body: front },
      { box: [L - 20, T - 40, W + 40, B - T + 60], body: back },
      { box: [sL - 20, T - 40, W + ox + 80, B - T + 60], body: side }
    ]);
  };

  /* 靴べら（ac-48・ac-49）。ネーム不可（描かない）。前面・背面。ツートン＝上部パーツ（輪を通す革・下の端は丸い）。上に二重丸カン（輪＋ナスカン）。
     大きさは写真の比率（輪の直径 D＝80 を基準）：
     ac-48：しずくの幅 2.6D・長さ 3.7D、上部パーツの幅 0.6D。縫い目は左の辺（背面は右）で、下はサイドから少し回って終わる。イカリは左右の真ん中。
     ac-49：キャップの幅 1.3D・高さ 1.1D、上部パーツの幅はキャップの 0.45 倍。下に金属の靴べら（キャップより少し狭く長い）。イカリはキャップの真ん中 2026.11.03 */
  function shoeHorn(c, cap) {
    var m = 'url(#' + c.uid + '-m)', s = 'url(#' + c.uid + '-s)';
    var D = 80, cx = 500, T = 300, g, st, B, tw, tabB, rY, emY, emS;
    if (cap) {
      var w = 1.3 * D, h = 1.1 * D; B = T + h; tw = 0.45 * w;
      g = 'M' + (cx - w / 2 + 4) + ' ' + B + ' L' + (cx - w / 2 + 8) + ' ' + (T + 26) + ' Q' + (cx - w / 2 + 10) + ' ' + T + ' ' + (cx - w / 2 + 34) + ' ' + T + ' H' + (cx + w / 2 - 34) + ' Q' + (cx + w / 2 - 10) + ' ' + T + ' ' + (cx + w / 2 - 8) + ' ' + (T + 26) + ' L' + (cx + w / 2 - 4) + ' ' + B + ' Z';
      st = 'd="M' + (cx - w / 2 + 16) + ' ' + (T + 18) + ' L' + (cx - w / 2 + 12) + ' ' + (B - 8) + ' M' + (cx + w / 2 - 16) + ' ' + (T + 18) + ' L' + (cx + w / 2 - 12) + ' ' + (B - 8) + '"';
      tabB = T + 44; rY = T + 24; emY = T + 64; emS = 30;
    } else {
      var w2 = 2.6 * D, L2 = 3.7 * D; B = T + L2; tw = 0.6 * D;
      var hw = w2 / 2, tp = 0.22 * w2;
      g = 'M' + cx + ' ' + T + ' C' + (cx + tp + 10) + ' ' + T + ' ' + (cx + tp + 14) + ' ' + (T + 30) + ' ' + (cx + tp + 22) + ' ' + (T + 70) + ' L' + (cx + hw - 8) + ' ' + (B - 90) + ' C' + (cx + hw + 4) + ' ' + (B - 20) + ' ' + (cx + 60) + ' ' + B + ' ' + cx + ' ' + B +
        ' C' + (cx - 60) + ' ' + B + ' ' + (cx - hw - 4) + ' ' + (B - 20) + ' ' + (cx - hw + 8) + ' ' + (B - 90) + ' L' + (cx - tp - 22) + ' ' + (T + 70) + ' C' + (cx - tp - 14) + ' ' + (T + 30) + ' ' + (cx - tp - 10) + ' ' + T + ' ' + cx + ' ' + T + ' Z';
      st = 'd="M' + (cx - tp - 4) + ' ' + (T + 24) + ' L' + (cx - hw + 16) + ' ' + (B - 90) + ' C' + (cx - hw + 10) + ' ' + (B - 50) + ' ' + (cx - hw + 26) + ' ' + (B - 26) + ' ' + (cx - hw + 46) + ' ' + (B - 16) + '"';
      tabB = T + 52; rY = T + 30; emY = T + 115; emS = 44;
    }
    /* 上部パーツ：細い革を二つ折りにし、折り目（上の端）に丸カンを通す。丸カンの下側は革に隠れる 2026.11.03 */
    var fT = T - 30;
    var tab = '<path d="M' + (cx - tw / 2) + ' ' + (fT + 10) + ' Q' + (cx - tw / 2) + ' ' + fT + ' ' + (cx - tw / 2 + 10) + ' ' + fT + ' H' + (cx + tw / 2 - 10) + ' Q' + (cx + tw / 2) + ' ' + fT + ' ' + (cx + tw / 2) + ' ' + (fT + 10) + ' V' + (tabB - tw / 2) + ' A' + (tw / 2) + ' ' + (tw / 2) + ' 0 0 1 ' + (cx - tw / 2) + ' ' + (tabB - tw / 2) + ' Z" fill="' + s + '"' + EDGE_SMALL + '/>' +
      '<path d="M' + (cx - tw / 2 + 4) + ' ' + (fT + 14) + ' H' + (cx + tw / 2 - 4) + '" stroke="#000" stroke-opacity="0.25" stroke-width="3"/>';
    var metals = ring(cx, fT + 8 - D / 2, D / 2, 6) + ring(cx, fT + 8 - D / 2, D / 2 - 7, 3); /* 丸カン（二重リング）だけ。下側は上部パーツの折り目の中（革の後ろ）2026.11.03 */
    var horn = cap ? '<path d="M' + (cx - 46) + ' ' + (B - 6) + ' L' + (cx - 62) + ' ' + (B + 230) + ' Q' + cx + ' ' + (B + 280) + ' ' + (cx + 62) + ' ' + (B + 230) + ' L' + (cx + 46) + ' ' + (B - 6) + ' Z" fill="#C9CCCF" stroke="#6F7378" stroke-width="4" stroke-linejoin="round"/>' +
      '<path d="M' + (cx - 20) + ' ' + (B + 20) + ' L' + (cx - 32) + ' ' + (B + 200) + '" stroke="#FFFFFF" stroke-opacity="0.6" stroke-width="10" stroke-linecap="round"/>' : '';
    function face(id) { return metals + horn + '<path d="' + g + '" fill="' + m + '"' + EDGE + '/>' + sStitch(c, 'path', id, st) + tab + rivet(cx, rY, cap ? 10 : 12); }
    var front = face('shf' + (cap ? 9 : 8)) + embAt(c, cx, emY, emS);
    var back = '<g transform="translate(' + (2 * cx) + ' 0) scale(-1 1)">' + face('shb' + (cap ? 9 : 8)) + '</g>';
    var bot = cap ? B + 280 : B, top = T - 130;
    return frame(c, '靴べらの見本（左から前面・背面）', [
      { box: [cx - 130, top, 260, bot - top + 20], core: [top, 0.66 * (bot - top)], body: front }, /* 前の2つの大きさの間 2026.11.03 */
      { box: [cx - 130, top, 260, bot - top + 20], body: back }
    ]);
  }
  shapes['ac-48'] = function (c) { return shoeHorn(c, false); };
  shapes['ac-49'] = function (c) { return shoeHorn(c, true); };
})();
/* ツートン製品別SVG（形データのみ）ここまで */
